/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminMpGoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param shopId (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAll(shopId: string | null | undefined, body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/AdminMpGood/GetAll?";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTempList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/AdminMpGood/GetTempList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTempList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param shopId (optional) 
     * @param body (optional) 
     * @return Success
     */
    priceUp(shopId: string | undefined, body: GoodPriceUpDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/AdminMpGood/PriceUp?";
        if (shopId === null)
            throw new Error("The parameter 'shopId' cannot be null.");
        else if (shopId !== undefined)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPriceUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPriceUp(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPriceUp(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param shopId (optional) 
     * @param body (optional) 
     * @return Success
     */
    setSale(shopId: string | undefined, body: SetSaleDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/AdminMpGood/SetSale?";
        if (shopId === null)
            throw new Error("The parameter 'shopId' cannot be null.");
        else if (shopId !== undefined)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSale(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetSale(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setForMarketPlace(body: SetForMarketplaceDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/AdminMpGood/SetForMarketPlace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetForMarketPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetForMarketPlace(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetForMarketPlace(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param updateBasePrices (optional) 
     * @param emergencyCall (optional) 
     * @return Success
     */
    rebuildPricesForMarketPlace(updateBasePrices: boolean | undefined, emergencyCall: boolean | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/AdminMpGood/RebuildPricesForMarketPlace?";
        if (updateBasePrices === null)
            throw new Error("The parameter 'updateBasePrices' cannot be null.");
        else if (updateBasePrices !== undefined)
            url_ += "updateBasePrices=" + encodeURIComponent("" + updateBasePrices) + "&";
        if (emergencyCall === null)
            throw new Error("The parameter 'emergencyCall' cannot be null.");
        else if (emergencyCall !== undefined)
            url_ += "emergencyCall=" + encodeURIComponent("" + emergencyCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildPricesForMarketPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildPricesForMarketPlace(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRebuildPricesForMarketPlace(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param username (optional) 
     * @param password (optional) 
     * @return Success
     */
    auth(username: string | null | undefined, password: string | null | undefined): Observable<UserInfoDto> {
        let url_ = this.baseUrl + "/Auth/Auth?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuth(<any>response_);
                } catch (e) {
                    return <Observable<UserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processAuth(response: HttpResponseBase): Observable<UserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUser(): Observable<UserInfoDto> {
        let url_ = this.baseUrl + "/Auth/GetUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<UserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfoDto>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CallHubApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    channelStateChangeEvent(token: string | null | undefined, body: Channel | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/CallHub/ChannelStateChangeEvent?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChannelStateChangeEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChannelStateChangeEvent(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processChannelStateChangeEvent(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalltouchApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param callerphone (optional) 
     * @param siteId (optional) 
     * @return Success
     */
    callNotify(callerphone: string | null | undefined, siteId: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/PublicImport/Calltouch/CallNotify?";
        if (callerphone !== undefined && callerphone !== null)
            url_ += "callerphone=" + encodeURIComponent("" + callerphone) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallNotify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallNotify(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCallNotify(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoryApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Category/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    createAttribute(categoryId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Category/CreateAttribute?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttribute(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAttribute(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    categoryPost(body: CategoryDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    categoryPut(body: CategoryDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    categoryDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Category?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Category> {
        let url_ = this.baseUrl + "/Category/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Category>><any>_observableThrow(e);
                }
            } else
                return <Observable<Category>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Category> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Category.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Category>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoryAttributeApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/CategoryAttribute/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    categoryAttributePost(body: CategoryAttributeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/CategoryAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryAttributePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryAttributePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryAttributePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    categoryAttributePut(body: CategoryAttributeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/CategoryAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryAttributePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryAttributePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryAttributePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    categoryAttributeDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/CategoryAttribute?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategoryAttributeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategoryAttributeDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCategoryAttributeDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<CategoryTenantAttribute> {
        let url_ = this.baseUrl + "/CategoryAttribute/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<CategoryTenantAttribute>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryTenantAttribute>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CategoryTenantAttribute> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryTenantAttribute.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryTenantAttribute>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CityApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/City/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBaseList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/City/GetBaseList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBaseList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cityPost(body: CityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/City";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCityPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCityPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cityPut(body: CityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/City";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCityPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCityPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    cityDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/City?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCityDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCityDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<City> {
        let url_ = this.baseUrl + "/City/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<City>><any>_observableThrow(e);
                }
            } else
                return <Observable<City>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<City> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = City.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<City>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CityDistanceApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    process(body: CityDistanceController_PassModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/CityDistance/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcess(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientControlApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkWarehouseProgress(): Observable<void> {
        let url_ = this.baseUrl + "/ClientControl/CheckWarehouseProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWarehouseProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWarehouseProgress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckWarehouseProgress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContactApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Contact/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param isForce (optional) 
     * @param body (optional) 
     * @return Success
     */
    createByPhoneNumber(isForce: boolean | undefined, body: ContactDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Contact/CreateByPhoneNumber?";
        if (isForce === null)
            throw new Error("The parameter 'isForce' cannot be null.");
        else if (isForce !== undefined)
            url_ += "isForce=" + encodeURIComponent("" + isForce) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateByPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateByPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateByPhoneNumber(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contactPost(body: ContactDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processContactPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contactPut(body: ContactDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processContactPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    contactDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Contact?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processContactDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Contact> {
        let url_ = this.baseUrl + "/Contact/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Contact>><any>_observableThrow(e);
                }
            } else
                return <Observable<Contact>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Contact> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contact>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryCityApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/DeliveryCity/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    getListWithoutLoadResult(): Observable<DeliveryCityDto[]> {
        let url_ = this.baseUrl + "/DeliveryCity/GetListWithoutLoadResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListWithoutLoadResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWithoutLoadResult(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryCityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryCityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListWithoutLoadResult(response: HttpResponseBase): Observable<DeliveryCityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryCityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryCityDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryCityPost(body: DeliveryCityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryCityPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryCityPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryCityPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryCityPut(body: DeliveryCityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryCityPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryCityPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryCityPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deliveryCityDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryCity?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryCityDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryCityDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryCityDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<DeliveryCity> {
        let url_ = this.baseUrl + "/DeliveryCity/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryCity>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryCity>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DeliveryCity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryCity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryCity>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryRegionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/DeliveryRegion/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    getListWithoutLoadResult(): Observable<DeliveryRegionDto[]> {
        let url_ = this.baseUrl + "/DeliveryRegion/GetListWithoutLoadResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListWithoutLoadResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWithoutLoadResult(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryRegionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryRegionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListWithoutLoadResult(response: HttpResponseBase): Observable<DeliveryRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryRegionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryRegionPost(body: DeliveryRegionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryRegionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryRegionPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryRegionPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deliveryRegionPut(body: DeliveryRegionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryRegionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryRegionPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryRegionPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deliveryRegionDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DeliveryRegion?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliveryRegionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliveryRegionDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeliveryRegionDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<DeliveryRegion> {
        let url_ = this.baseUrl + "/DeliveryRegion/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DeliveryRegion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryRegion>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DesignProjectApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/DesignProject/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    designProjectPut(body: DesignProjectDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DesignProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesignProjectPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesignProjectPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDesignProjectPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    designProjectDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/DesignProject?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesignProjectDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesignProjectDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDesignProjectDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<DesignProject> {
        let url_ = this.baseUrl + "/DesignProject/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<DesignProject>><any>_observableThrow(e);
                }
            } else
                return <Observable<DesignProject>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DesignProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignProject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignProject>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExcelExportApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    exportRunner(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ExcelExport/ExportRunner?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRunner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRunner(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportRunner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExcelImportApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param columnIndexes (optional) 
     * @param file (optional) 
     * @return Success
     */
    importExcel(columnIndexes: string | null | undefined, file: FileParameter | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/ExcelImport/ImportExcel?";
        if (columnIndexes !== undefined && columnIndexes !== null)
            url_ += "columnIndexes=" + encodeURIComponent("" + columnIndexes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExcel(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processImportExcel(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExcelColumns(): Observable<ExcelColumnDto[]> {
        let url_ = this.baseUrl + "/ExcelImport/GetExcelColumns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelColumns(<any>response_);
                } catch (e) {
                    return <Observable<ExcelColumnDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelColumnDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExcelColumns(response: HttpResponseBase): Observable<ExcelColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExcelColumnDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelColumnDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTemplateUrl(): Observable<HtmlResponse> {
        let url_ = this.baseUrl + "/ExcelImport/GetTemplateUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateUrl(<any>response_);
                } catch (e) {
                    return <Observable<HtmlResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HtmlResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateUrl(response: HttpResponseBase): Observable<HtmlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HtmlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HtmlResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportGoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getPrices(skip: number | null | undefined, take: number | null | undefined): Observable<GoodPriceDto[]> {
        let url_ = this.baseUrl + "/Export/ExportGood/GetPrices?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrices(<any>response_);
                } catch (e) {
                    return <Observable<GoodPriceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodPriceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrices(response: HttpResponseBase): Observable<GoodPriceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodPriceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodPriceDto[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportOrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param ordersAfterDate (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getList(ordersAfterDate: string | null | undefined, skip: number | null | undefined, take: number | null | undefined): Observable<Order1CDto[]> {
        let url_ = this.baseUrl + "/Export/ExportOrder/GetList?";
        if (ordersAfterDate !== undefined && ordersAfterDate !== null)
            url_ += "ordersAfterDate=" + encodeURIComponent("" + ordersAfterDate) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<Order1CDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Order1CDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<Order1CDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order1CDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Order1CDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postOrderData(body: PostOrder1CDto[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Export/ExportOrder/PostOrderData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOrderData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrderData(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostOrderData(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportRestApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param cityName (optional) 
     * @param goodId (optional) 
     * @param distance (optional) 
     * @return Success
     */
    getByCity(cityName: string | null | undefined, goodId: number | undefined, distance: number | undefined): Observable<RestResult> {
        let url_ = this.baseUrl + "/Export/ExportRest/GetByCity?";
        if (cityName !== undefined && cityName !== null)
            url_ += "cityName=" + encodeURIComponent("" + cityName) + "&";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        if (distance === null)
            throw new Error("The parameter 'distance' cannot be null.");
        else if (distance !== undefined)
            url_ += "distance=" + encodeURIComponent("" + distance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCity(<any>response_);
                } catch (e) {
                    return <Observable<RestResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RestResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCity(response: HttpResponseBase): Observable<RestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RestResult>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportSupplierOrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param ordersAfterDate (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getList(ordersAfterDate: string | null | undefined, skip: number | null | undefined, take: number | null | undefined): Observable<SupplierOrder1CDto[]> {
        let url_ = this.baseUrl + "/Export/ExportSupplierOrder/GetList?";
        if (ordersAfterDate !== undefined && ordersAfterDate !== null)
            url_ += "ordersAfterDate=" + encodeURIComponent("" + ordersAfterDate) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<SupplierOrder1CDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierOrder1CDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<SupplierOrder1CDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierOrder1CDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierOrder1CDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postOrderData(body: PostSupplierOrder1CDto[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Export/ExportSupplierOrder/PostOrderData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOrderData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrderData(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostOrderData(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    filesGet(fileId: number | undefined): Observable<ExportFile> {
        let url_ = this.baseUrl + "/Files?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesGet(<any>response_);
                } catch (e) {
                    return <Observable<ExportFile>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportFile>><any>_observableThrow(response_);
        }));
    }

    protected processFilesGet(response: HttpResponseBase): Observable<ExportFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportFile>(<any>null);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    filesDelete(fileId: number | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Files?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processFilesDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param source (optional) 
     * @param body (optional) 
     * @return Success
     */
    filesPost(source: CdnSource | undefined, body: NewFileParameters | undefined): Observable<ExportFile> {
        let url_ = this.baseUrl + "/Files?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesPost(<any>response_);
                } catch (e) {
                    return <Observable<ExportFile>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportFile>><any>_observableThrow(response_);
        }));
    }

    protected processFilesPost(response: HttpResponseBase): Observable<ExportFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportFile>(<any>null);
    }

    /**
     * @param source (optional) 
     * @param body (optional) 
     * @return Success
     */
    images(source: CdnSource | undefined, body: NewFileParameters | undefined): Observable<ExportFile> {
        let url_ = this.baseUrl + "/Files/Images?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImages(<any>response_);
                } catch (e) {
                    return <Observable<ExportFile>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportFile>><any>_observableThrow(response_);
        }));
    }

    protected processImages(response: HttpResponseBase): Observable<ExportFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportFile>(<any>null);
    }

    /**
     * @param source (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadDetailed(source: CdnSource | undefined, body: NewFileParameters | undefined): Observable<ExportDetailedFile> {
        let url_ = this.baseUrl + "/Files/UploadDetailedAsync?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDetailed(<any>response_);
                } catch (e) {
                    return <Observable<ExportDetailedFile>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportDetailedFile>><any>_observableThrow(response_);
        }));
    }

    protected processUploadDetailed(response: HttpResponseBase): Observable<ExportDetailedFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportDetailedFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportDetailedFile>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GeneralOptionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/GeneralOption/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generalOptionPost(body: GeneralOptionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GeneralOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralOptionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralOptionPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGeneralOptionPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generalOptionPut(body: GeneralOptionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GeneralOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralOptionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralOptionPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGeneralOptionPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    generalOptionDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GeneralOption?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneralOptionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneralOptionDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGeneralOptionDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    urlRewrite(): Observable<void> {
        let url_ = this.baseUrl + "/Good/UrlRewrite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUrlRewrite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUrlRewrite(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUrlRewrite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNikaCatalog(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Good/GetNikaCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNikaCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNikaCatalog(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetNikaCatalog(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Good/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    getModulesFull(id: string | undefined, body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Good/GetModulesFull?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModulesFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModulesFull(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetModulesFull(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getListLight(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Good/GetListLight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListLight(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetListLight(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    priceUp(body: GoodPriceUpDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/PriceUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPriceUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPriceUp(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPriceUp(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSale(body: SetSaleDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/SetSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSale(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetSale(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRange(body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRange(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRange(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archiveRange(body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/ArchiveRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveRange(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processArchiveRange(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSelectionType(body: GoodSetSelectionTypeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/SetSelectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSelectionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSelectionType(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetSelectionType(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param goodId (optional) 
     * @return Success
     */
    moveToArchive(goodId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good/MoveToArchive?";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveToArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveToArchive(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMoveToArchive(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getModules(id: string | undefined): Observable<GoodDto[]> {
        let url_ = this.baseUrl + "/Good/GetModules?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModules(<any>response_);
                } catch (e) {
                    return <Observable<GoodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetModules(response: HttpResponseBase): Observable<GoodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goodPost(body: GoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goodPut(body: GoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    goodDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Good?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Good> {
        let url_ = this.baseUrl + "/Good/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Good>><any>_observableThrow(e);
                }
            } else
                return <Observable<Good>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Good> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Good.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Good>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoodSelectionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/GoodSelection/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goodSelectionPost(body: GoodSelectionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GoodSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodSelectionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodSelectionPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodSelectionPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goodSelectionPut(body: GoodSelectionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GoodSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodSelectionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodSelectionPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodSelectionPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    goodSelectionDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GoodSelection?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoodSelectionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoodSelectionDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGoodSelectionDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<GoodTenantSelection> {
        let url_ = this.baseUrl + "/GoodSelection/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GoodTenantSelection>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodTenantSelection>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GoodTenantSelection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoodTenantSelection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodTenantSelection>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRange(body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/GoodSelection/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRange(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRange(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HomeInfoApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInfo(): Observable<CommonInfoDto> {
        let url_ = this.baseUrl + "/HomeInfo/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(<any>response_);
                } catch (e) {
                    return <Observable<CommonInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<CommonInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonInfoDto>(<any>null);
    }

    /**
     * @param dateType (optional) 
     * @return Success
     */
    getOrderStatistics(dateType: HomeInfoController_StatisticDateType | undefined): Observable<OrderStatisticModel> {
        let url_ = this.baseUrl + "/HomeInfo/GetOrderStatistics?";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatistics(<any>response_);
                } catch (e) {
                    return <Observable<OrderStatisticModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStatisticModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderStatistics(response: HttpResponseBase): Observable<OrderStatisticModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatisticModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStatisticModel>(<any>null);
    }

    /**
     * @param dateType (optional) 
     * @return Success
     */
    getCategoryStatistics(dateType: HomeInfoController_StatisticDateType | undefined): Observable<CategoryStatisticModel> {
        let url_ = this.baseUrl + "/HomeInfo/GetCategoryStatistics?";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryStatistics(<any>response_);
                } catch (e) {
                    return <Observable<CategoryStatisticModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryStatisticModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryStatistics(response: HttpResponseBase): Observable<CategoryStatisticModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryStatisticModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryStatisticModel>(<any>null);
    }

    /**
     * @param dateType (optional) 
     * @return Success
     */
    getSellStatistics(dateType: HomeInfoController_StatisticDateType | undefined): Observable<LineChartStatisticModel> {
        let url_ = this.baseUrl + "/HomeInfo/GetSellStatistics?";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellStatistics(<any>response_);
                } catch (e) {
                    return <Observable<LineChartStatisticModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LineChartStatisticModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSellStatistics(response: HttpResponseBase): Observable<LineChartStatisticModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineChartStatisticModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LineChartStatisticModel>(<any>null);
    }

    /**
     * @param dateType (optional) 
     * @return Success
     */
    getOrderStatusStatistics(dateType: HomeInfoController_StatisticDateType | undefined): Observable<PyramidChartStatisticModel> {
        let url_ = this.baseUrl + "/HomeInfo/GetOrderStatusStatistics?";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatusStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatusStatistics(<any>response_);
                } catch (e) {
                    return <Observable<PyramidChartStatisticModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PyramidChartStatisticModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderStatusStatistics(response: HttpResponseBase): Observable<PyramidChartStatisticModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PyramidChartStatisticModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PyramidChartStatisticModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ImportApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    syncCalltouch(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/SyncCalltouch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCalltouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCalltouch(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSyncCalltouch(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    syncOrders(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/SyncOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOrders(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSyncOrders(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoods(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/UpdateGoods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoods(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGoods(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    updateMpGoods(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/UpdateMpGoods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMpGoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMpGoods(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMpGoods(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    updatePrices(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/UpdatePrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrices(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePrices(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    updateCategories(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/UpdateCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategories(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCategories(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    updateRests(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/UpdateRests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRests(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRests(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getImportStatus(): Observable<ImportStatusResponseModel> {
        let url_ = this.baseUrl + "/Import/GetImportStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportStatus(<any>response_);
                } catch (e) {
                    return <Observable<ImportStatusResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportStatusResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetImportStatus(response: HttpResponseBase): Observable<ImportStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportStatusResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class KanbanApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param stageId (optional) 
     * @return Success
     */
    updateItem(id: string | undefined, stageId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Kanban/UpdateItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (stageId === null)
            throw new Error("The parameter 'stageId' cannot be null.");
        else if (stageId !== undefined)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param responsibleId (optional) 
     * @return Success
     */
    updateResponsible(id: string | undefined, responsibleId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Kanban/UpdateResponsible?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (responsibleId !== undefined && responsibleId !== null)
            url_ += "responsibleId=" + encodeURIComponent("" + responsibleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResponsible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResponsible(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateResponsible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromIndex (optional) 
     * @param toIndex (optional) 
     * @param kanbanType (optional) 
     * @return Success
     */
    updateStage(fromIndex: number | undefined, toIndex: number | undefined, kanbanType: KanbanType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Kanban/UpdateStage?";
        if (fromIndex === null)
            throw new Error("The parameter 'fromIndex' cannot be null.");
        else if (fromIndex !== undefined)
            url_ += "fromIndex=" + encodeURIComponent("" + fromIndex) + "&";
        if (toIndex === null)
            throw new Error("The parameter 'toIndex' cannot be null.");
        else if (toIndex !== undefined)
            url_ += "toIndex=" + encodeURIComponent("" + toIndex) + "&";
        if (kanbanType === null)
            throw new Error("The parameter 'kanbanType' cannot be null.");
        else if (kanbanType !== undefined)
            url_ += "kanbanType=" + encodeURIComponent("" + kanbanType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStage(id: string | undefined): Observable<TenantKanbanStageDto> {
        let url_ = this.baseUrl + "/Kanban/GetStage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStage(<any>response_);
                } catch (e) {
                    return <Observable<TenantKanbanStageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantKanbanStageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStage(response: HttpResponseBase): Observable<TenantKanbanStageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantKanbanStageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantKanbanStageDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateStage(body: TenantKanbanStageDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Kanban/AddOrUpdateStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateStage(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrUpdateStage(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteStage(id: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Kanban/DeleteStage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStage(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteStage(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getStatus(type: KanbanType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/Kanban/GetStatus?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    init(type: KanbanType | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Kanban/Init?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInit(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processInit(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param daysMargin (optional) 
     * @param showFinishedOrders (optional) 
     * @param responsibleOnly (optional) 
     * @return Success
     */
    getOrders(daysMargin: number | undefined, showFinishedOrders: boolean | undefined, responsibleOnly: boolean | undefined): Observable<KanbanStageItem[]> {
        let url_ = this.baseUrl + "/Kanban/GetOrders?";
        if (daysMargin === null)
            throw new Error("The parameter 'daysMargin' cannot be null.");
        else if (daysMargin !== undefined)
            url_ += "daysMargin=" + encodeURIComponent("" + daysMargin) + "&";
        if (showFinishedOrders === null)
            throw new Error("The parameter 'showFinishedOrders' cannot be null.");
        else if (showFinishedOrders !== undefined)
            url_ += "showFinishedOrders=" + encodeURIComponent("" + showFinishedOrders) + "&";
        if (responsibleOnly === null)
            throw new Error("The parameter 'responsibleOnly' cannot be null.");
        else if (responsibleOnly !== undefined)
            url_ += "responsibleOnly=" + encodeURIComponent("" + responsibleOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(<any>response_);
                } catch (e) {
                    return <Observable<KanbanStageItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<KanbanStageItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<KanbanStageItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KanbanStageItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KanbanStageItem[]>(<any>null);
    }

    /**
     * @param daysMargin (optional) 
     * @return Success
     */
    getSupplierOrders(daysMargin: number | undefined): Observable<KanbanStageItem[]> {
        let url_ = this.baseUrl + "/Kanban/GetSupplierOrders?";
        if (daysMargin === null)
            throw new Error("The parameter 'daysMargin' cannot be null.");
        else if (daysMargin !== undefined)
            url_ += "daysMargin=" + encodeURIComponent("" + daysMargin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierOrders(<any>response_);
                } catch (e) {
                    return <Observable<KanbanStageItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<KanbanStageItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierOrders(response: HttpResponseBase): Observable<KanbanStageItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KanbanStageItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KanbanStageItem[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LogsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Logs/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<LogInfoDto> {
        let url_ = this.baseUrl + "/Logs/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<LogInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LogInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<LogInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LogInfoDto>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainAccountApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param username (optional) 
     * @param password (optional) 
     * @return Success
     */
    register(username: string | null | undefined, password: string | null | undefined): Observable<RegisterResponse> {
        let url_ = this.baseUrl + "/Main/MainAccount/Register?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    edit(body: UserProfileVM | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Main/MainAccount/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    forgotPassword(email: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Main/MainAccount/ForgotPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getUser(): Observable<UserInfoDto> {
        let url_ = this.baseUrl + "/Main/MainAccount/GetUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<UserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfoDto>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainAuthApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param username (optional) 
     * @param password (optional) 
     * @return Success
     */
    auth(username: string | null | undefined, password: string | null | undefined): Observable<UserInfoDto> {
        let url_ = this.baseUrl + "/Main/MainAuth/Auth?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuth(<any>response_);
                } catch (e) {
                    return <Observable<UserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processAuth(response: HttpResponseBase): Observable<UserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfoDto>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainCartApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCartItems(body: CartItemVM[] | null | undefined): Observable<CartGoodPreviewCardVM[]> {
        let url_ = this.baseUrl + "/MainCart/GetCartItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCartItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartItems(<any>response_);
                } catch (e) {
                    return <Observable<CartGoodPreviewCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartGoodPreviewCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCartItems(response: HttpResponseBase): Observable<CartGoodPreviewCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CartGoodPreviewCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartGoodPreviewCardVM[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainCatalogApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFilterModel(): Observable<CatalogFiltersVM> {
        let url_ = this.baseUrl + "/MainCatalog/GetFilterModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterModel(<any>response_);
                } catch (e) {
                    return <Observable<CatalogFiltersVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<CatalogFiltersVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilterModel(response: HttpResponseBase): Observable<CatalogFiltersVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogFiltersVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CatalogFiltersVM>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainCategoryApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getList(): Observable<CategoryItemVM[]> {
        let url_ = this.baseUrl + "/MainCategory/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<CategoryItemVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryItemVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CategoryItemVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryItemVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryItemVM[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWithCount(): Observable<GetCategoriesResponse> {
        let url_ = this.baseUrl + "/MainCategory/GetWithCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithCount(<any>response_);
                } catch (e) {
                    return <Observable<GetCategoriesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCategoriesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetWithCount(response: HttpResponseBase): Observable<GetCategoriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoriesResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainGoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param needFilterModel (optional) 
     * @param body (optional) 
     * @return Success
     */
    getList(needFilterModel: boolean | undefined, body: FilterModelVM | undefined): Observable<CatalogResultVM> {
        let url_ = this.baseUrl + "/MainGood/GetList?";
        if (needFilterModel === null)
            throw new Error("The parameter 'needFilterModel' cannot be null.");
        else if (needFilterModel !== undefined)
            url_ += "needFilterModel=" + encodeURIComponent("" + needFilterModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<CatalogResultVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<CatalogResultVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CatalogResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CatalogResultVM>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBySelectionTypeCode(code: string | null | undefined): Observable<GoodPreviewCardVM[]> {
        let url_ = this.baseUrl + "/MainGood/GetBySelectionTypeCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySelectionTypeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySelectionTypeCode(<any>response_);
                } catch (e) {
                    return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBySelectionTypeCode(response: HttpResponseBase): Observable<GoodPreviewCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodPreviewCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodPreviewCardVM[]>(<any>null);
    }

    /**
     * @param alias (optional) 
     * @return Success
     */
    getByAlias(alias: string | null | undefined): Observable<GoodCardVM> {
        let url_ = this.baseUrl + "/MainGood/GetByAlias?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAlias(<any>response_);
                } catch (e) {
                    return <Observable<GoodCardVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodCardVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetByAlias(response: HttpResponseBase): Observable<GoodCardVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoodCardVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodCardVM>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getModules(id: string | undefined): Observable<GoodPreviewCardVM[]> {
        let url_ = this.baseUrl + "/MainGood/GetModules?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModules(<any>response_);
                } catch (e) {
                    return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetModules(response: HttpResponseBase): Observable<GoodPreviewCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodPreviewCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodPreviewCardVM[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStructures(id: string | undefined): Observable<GoodPreviewCardVM[]> {
        let url_ = this.baseUrl + "/MainGood/GetStructures?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructures(<any>response_);
                } catch (e) {
                    return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructures(response: HttpResponseBase): Observable<GoodPreviewCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodPreviewCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodPreviewCardVM[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMainSliderItems(): Observable<MainSliderItemCardVM[]> {
        let url_ = this.baseUrl + "/MainGood/GetMainSliderItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainSliderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainSliderItems(<any>response_);
                } catch (e) {
                    return <Observable<MainSliderItemCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MainSliderItemCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMainSliderItems(response: HttpResponseBase): Observable<MainSliderItemCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainSliderItemCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MainSliderItemCardVM[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainNewsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getList(): Observable<NewsCardVM[]> {
        let url_ = this.baseUrl + "/MainNews/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<NewsCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<NewsCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewsCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsCardVM[]>(<any>null);
    }

    /**
     * @param alias (optional) 
     * @return Success
     */
    getByAlias(alias: string | null | undefined): Observable<NewsCardVM> {
        let url_ = this.baseUrl + "/MainNews/GetByAlias?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAlias(<any>response_);
                } catch (e) {
                    return <Observable<NewsCardVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsCardVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetByAlias(response: HttpResponseBase): Observable<NewsCardVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsCardVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsCardVM>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainOrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getList(): Observable<OrderItemVM[]> {
        let url_ = this.baseUrl + "/Main/MainOrder/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<OrderItemVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderItemVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<OrderItemVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderItemVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemVM[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initOrder(body: InitOrderVM | undefined): Observable<InitOrderResponse> {
        let url_ = this.baseUrl + "/Main/MainOrder/InitOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitOrder(<any>response_);
                } catch (e) {
                    return <Observable<InitOrderResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<InitOrderResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInitOrder(response: HttpResponseBase): Observable<InitOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InitOrderResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainRequestApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    designProject(body: DesignProjectDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MainRequest/DesignProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesignProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesignProject(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDesignProject(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainSearchApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param query (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    search(query: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<GoodPreviewCardVM[]> {
        let url_ = this.baseUrl + "/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodPreviewCardVM[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GoodPreviewCardVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodPreviewCardVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodPreviewCardVM[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainSeoApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param url (optional) 
     * @param category (optional) 
     * @param good (optional) 
     * @return Success
     */
    getForPage(url: string | null | undefined, category: string | null | undefined, good: string | null | undefined): Observable<SeoForPageVM> {
        let url_ = this.baseUrl + "/MainSeo/GetForPage?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (good !== undefined && good !== null)
            url_ += "good=" + encodeURIComponent("" + good) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForPage(<any>response_);
                } catch (e) {
                    return <Observable<SeoForPageVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<SeoForPageVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetForPage(response: HttpResponseBase): Observable<SeoForPageVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeoForPageVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SeoForPageVM>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainSliderItemApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MainSliderItem/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mainSliderItemPost(body: MainSliderItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MainSliderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMainSliderItemPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMainSliderItemPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMainSliderItemPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mainSliderItemPut(body: MainSliderItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MainSliderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMainSliderItemPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMainSliderItemPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMainSliderItemPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mainSliderItemDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MainSliderItem?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMainSliderItemDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMainSliderItemDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMainSliderItemDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MainSliderItem> {
        let url_ = this.baseUrl + "/MainSliderItem/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MainSliderItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<MainSliderItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MainSliderItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MainSliderItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MainSliderItem>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MainTenantApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInfo(): Observable<TenantInfoVM> {
        let url_ = this.baseUrl + "/MainTenant/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfoVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfoVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<TenantInfoVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfoVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfoVM>(<any>null);
    }

    /**
     * @return Success
     */
    getFullInfo(): Observable<TenantInfoVM> {
        let url_ = this.baseUrl + "/MainTenant/GetFullInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullInfo(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfoVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfoVM>><any>_observableThrow(response_);
        }));
    }

    protected processGetFullInfo(response: HttpResponseBase): Observable<TenantInfoVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfoVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfoVM>(<any>null);
    }

    /**
     * @return Success
     */
    getCities(): Observable<GetTenantCitiesResponse> {
        let url_ = this.baseUrl + "/MainTenant/GetCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCities(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantCitiesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantCitiesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCities(response: HttpResponseBase): Observable<GetTenantCitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantCitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantCitiesResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ManufacturerApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Manufacturer/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    manufacturerPost(body: ManufacturerDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManufacturerPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManufacturerPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processManufacturerPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    manufacturerPut(body: ManufacturerDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManufacturerPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManufacturerPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processManufacturerPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    manufacturerDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Manufacturer?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManufacturerDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManufacturerDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processManufacturerDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Manufacturer> {
        let url_ = this.baseUrl + "/Manufacturer/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Manufacturer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Manufacturer>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Manufacturer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Manufacturer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Manufacturer>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpArticleApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpArticle/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpArticlePost(body: ArticleDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpArticlePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpArticlePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpArticlePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpArticlePut(body: ArticleDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpArticlePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpArticlePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpArticlePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpArticleDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpArticle?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpArticleDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpArticleDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpArticleDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putHtmlContent(body: ArticleDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpArticle/PutHtmlContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutHtmlContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutHtmlContent(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutHtmlContent(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Article> {
        let url_ = this.baseUrl + "/MpArticle/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Article>><any>_observableThrow(e);
                }
            } else
                return <Observable<Article>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Article> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Article.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Article>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpCategoryApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpCategory/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCategoryPost(body: MpCategoryDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCategoryPut(body: MpCategoryDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpCategoryDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategory?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param categoryId (optional) 
     * @param parentCategoryId (optional) 
     * @param index (optional) 
     * @return Success
     */
    updateParent(categoryId: string | undefined, parentCategoryId: string | null | undefined, index: number | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategory/UpdateParent?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (parentCategoryId !== undefined && parentCategoryId !== null)
            url_ += "parentCategoryId=" + encodeURIComponent("" + parentCategoryId) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParent(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateParent(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpCategory> {
        let url_ = this.baseUrl + "/MpCategory/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpCategory>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpCategory>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpCategory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpCategory.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpCategory>(<any>null);
    }

    /**
     * @return Success
     */
    getPlainList(): Observable<MpCategoryDto[]> {
        let url_ = this.baseUrl + "/MpCategory/GetPlainList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlainList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlainList(<any>response_);
                } catch (e) {
                    return <Observable<MpCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlainList(response: HttpResponseBase): Observable<MpCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MpCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpCategoryDto[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpCategoryRelatedGoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCategoryRelatedGoodPost(body: MpCategoryRelatedGoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryRelatedGoodPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryRelatedGoodPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryRelatedGoodPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCategoryRelatedGoodPut(body: MpCategoryRelatedGoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryRelatedGoodPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryRelatedGoodPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryRelatedGoodPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpCategoryRelatedGoodDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCategoryRelatedGoodDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCategoryRelatedGoodDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCategoryRelatedGoodDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpCategoryRelatedGood> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpCategoryRelatedGood>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpCategoryRelatedGood>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpCategoryRelatedGood> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpCategoryRelatedGood.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpCategoryRelatedGood>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setRelatedGoods(body: SetMpCategoryRelatedGoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood/SetRelatedGoods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRelatedGoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRelatedGoods(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetRelatedGoods(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRange(body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCategoryRelatedGood/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRange(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRange(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpCityApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpCity/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCityPost(body: MpCityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCityPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCityPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCityPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpCityPut(body: MpCityDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCityPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCityPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCityPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpCityDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpCity?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpCityDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpCityDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpCityDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpCity> {
        let url_ = this.baseUrl + "/MpCity/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpCity>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpCity>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpCity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpCity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpCity>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpGoodApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpGood/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTempList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpGood/GetTempList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTempList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getListLight(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpGood/GetListLight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListLight(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetListLight(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpGood(body: MpGoodDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param categoryId (optional) 
     * @param body (optional) 
     * @return Success
     */
    setCategory(categoryId: string | undefined, body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGood/SetCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCategory(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetCategory(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    priceUpBase(body: GoodPriceUpDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGood/PriceUpBase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPriceUpBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPriceUpBase(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPriceUpBase(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setForMarketPlace(body: SetForMarketplaceDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGood/SetForMarketPlace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetForMarketPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetForMarketPlace(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetForMarketPlace(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setHideInCatalog(body: SetHideInCatalogDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGood/SetHideInCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetHideInCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetHideInCatalog(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetHideInCatalog(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpGood> {
        let url_ = this.baseUrl + "/MpGood/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpGood>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpGood>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpGood> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpGood.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpGood>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpGoodSelectionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpGoodSelection/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpGoodSelectionPost(body: MpGoodSelectionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGoodSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpGoodSelectionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpGoodSelectionPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpGoodSelectionPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpGoodSelectionPut(body: MpGoodSelectionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGoodSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpGoodSelectionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpGoodSelectionPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpGoodSelectionPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpGoodSelectionDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGoodSelection?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpGoodSelectionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpGoodSelectionDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpGoodSelectionDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpGoodSelection> {
        let url_ = this.baseUrl + "/MpGoodSelection/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpGoodSelection>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpGoodSelection>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpGoodSelection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpGoodSelection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpGoodSelection>(<any>null);
    }

    /**
     * @return Success
     */
    getMpSelectionTypes(): Observable<CodeValueEnumPair[]> {
        let url_ = this.baseUrl + "/MpGoodSelection/GetMpSelectionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMpSelectionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMpSelectionTypes(<any>response_);
                } catch (e) {
                    return <Observable<CodeValueEnumPair[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CodeValueEnumPair[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMpSelectionTypes(response: HttpResponseBase): Observable<CodeValueEnumPair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeValueEnumPair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CodeValueEnumPair[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSelectionType(body: MpGoodSetSelectionTypeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGoodSelection/SetSelectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSelectionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSelectionType(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetSelectionType(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRange(body: string[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpGoodSelection/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRange(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRange(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpMainSliderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpMainSlider/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpMainSliderPost(body: MpMainSliderItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpMainSlider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpMainSliderPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpMainSliderPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpMainSliderPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpMainSliderPut(body: MpMainSliderItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpMainSlider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpMainSliderPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpMainSliderPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpMainSliderPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpMainSliderDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpMainSlider?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpMainSliderDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpMainSliderDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpMainSliderDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MpMainSliderItem> {
        let url_ = this.baseUrl + "/MpMainSlider/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MpMainSliderItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<MpMainSliderItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MpMainSliderItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MpMainSliderItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MpMainSliderItem>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MpRequestApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/MpRequest/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mpRequestPut(body: MpRequestDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpRequestPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpRequestPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpRequestPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mpRequestDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/MpRequest?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpRequestDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpRequestDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMpRequestDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<MPRequest> {
        let url_ = this.baseUrl + "/MpRequest/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<MPRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MPRequest>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MPRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MPRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MPRequest>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MPRequestApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postRequest(body: MPRequestController_MPRequestImportModel | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/PublicImport/MPRequest/PostRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRequest(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostRequest(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NavsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Navs/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Navs/GetAllList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    navsPost(body: NavigationItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Navs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNavsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNavsPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNavsPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    navsPut(body: NavigationItemDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Navs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNavsPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNavsPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNavsPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    navsDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Navs?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNavsDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNavsDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNavsDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<NavigationItem> {
        let url_ = this.baseUrl + "/Navs/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<NavigationItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<NavigationItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<NavigationItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavigationItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NavigationItem>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NavsSettingsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param navigationType (optional) 
     * @param isWithoutHidden (optional) 
     * @param treeView (optional) 
     * @return Success
     */
    getList(navigationType: NavigationType | undefined, isWithoutHidden: boolean | undefined, treeView: boolean | undefined): Observable<NavigationDto[]> {
        let url_ = this.baseUrl + "/NavsSettings/GetList?";
        if (navigationType === null)
            throw new Error("The parameter 'navigationType' cannot be null.");
        else if (navigationType !== undefined)
            url_ += "navigationType=" + encodeURIComponent("" + navigationType) + "&";
        if (isWithoutHidden === null)
            throw new Error("The parameter 'isWithoutHidden' cannot be null.");
        else if (isWithoutHidden !== undefined)
            url_ += "isWithoutHidden=" + encodeURIComponent("" + isWithoutHidden) + "&";
        if (treeView === null)
            throw new Error("The parameter 'treeView' cannot be null.");
        else if (treeView !== undefined)
            url_ += "treeView=" + encodeURIComponent("" + treeView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<NavigationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NavigationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<NavigationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavigationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NavigationDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSettings(body: NavigationItemUpdateDto[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/NavsSettings/SaveSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSettings(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSaveSettings(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NewsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/News/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    newsPost(body: NewsDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNewsPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    newsPut(body: NewsDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNewsPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    newsDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/News?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNewsDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<News> {
        let url_ = this.baseUrl + "/News/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<News>><any>_observableThrow(e);
                }
            } else
                return <Observable<News>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<News> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = News.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<News>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OneCImportApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postBasePrices(body: PostBasePriceData[] | null | undefined): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/OneCImport/PostBasePrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBasePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBasePrices(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostBasePrices(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    applyBasePrices(): Observable<void> {
        let url_ = this.baseUrl + "/Import/OneCImport/ApplyBasePrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyBasePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyBasePrices(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApplyBasePrices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postPartnersInfo(body: PostPartnerInfoData[] | null | undefined): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Import/OneCImport/PostPartnersInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPartnersInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPartnersInfo(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostPartnersInfo(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Order/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    import(): Observable<ImportResponseModel> {
        let url_ = this.baseUrl + "/Order/Import";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(<any>response_);
                } catch (e) {
                    return <Observable<ImportResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ImportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrder(body: CreateOrderDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param comment (optional) 
     * @param orderId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addSupplierOrder(comment: string | null | undefined, orderId: string | null | undefined, body: GoodSupplierInfoDto[] | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/AddSupplierOrder?";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplierOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplierOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddSupplierOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSupplierOrderInfo(body: string[] | null | undefined): Observable<GoodSupplierInfoDto[]> {
        let url_ = this.baseUrl + "/Order/GetSupplierOrderInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierOrderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierOrderInfo(<any>response_);
                } catch (e) {
                    return <Observable<GoodSupplierInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodSupplierInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierOrderInfo(response: HttpResponseBase): Observable<GoodSupplierInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoodSupplierInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodSupplierInfoDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    rebuildOrder(orderId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/RebuildOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRebuildOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    rebuildInitialPrices(orderId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/RebuildInitialPrices?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildInitialPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildInitialPrices(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRebuildInitialPrices(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    finishOrder(orderId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/FinishOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processFinishOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGoodsIds(id: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/Order/GetGoodsIds?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGoodsIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsIds(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGoodsIds(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    getGoods(id: string | undefined, body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Order/GetGoods?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoods(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetGoods(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param goodId (optional) 
     * @param fullMode (optional) 
     * @return Success
     */
    breakUp(id: string | undefined, goodId: string | undefined, fullMode: boolean | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/BreakUp?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        if (fullMode === null)
            throw new Error("The parameter 'fullMode' cannot be null.");
        else if (fullMode !== undefined)
            url_ += "fullMode=" + encodeURIComponent("" + fullMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBreakUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBreakUp(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processBreakUp(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRests(id: string | undefined): Observable<OrderGoodRestDto[]> {
        let url_ = this.baseUrl + "/Order/GetRests?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRests(<any>response_);
                } catch (e) {
                    return <Observable<OrderGoodRestDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderGoodRestDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRests(response: HttpResponseBase): Observable<OrderGoodRestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderGoodRestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderGoodRestDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putOrder(body: OrderDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/PutOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putOrderGood(id: string | null | undefined, body: OrderGoodPutDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/PutOrderGood?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutOrderGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutOrderGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutOrderGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChangeHistory(id: string | undefined): Observable<ChangeLogDto[]> {
        let url_ = this.baseUrl + "/Order/GetChangeHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeHistory(<any>response_);
                } catch (e) {
                    return <Observable<ChangeLogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangeLogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetChangeHistory(response: HttpResponseBase): Observable<ChangeLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeLogDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param goodId (optional) 
     * @return Success
     */
    addOrderGood(id: string | undefined, goodId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/AddOrderGood?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrderGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrderGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrderGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrderGood(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/DeleteOrderGood?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrderGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    order(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByIdDetailed(id: string | undefined): Observable<DetailedOrderModel> {
        let url_ = this.baseUrl + "/Order/GetByIdDetailed?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdDetailed(<any>response_);
                } catch (e) {
                    return <Observable<DetailedOrderModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<DetailedOrderModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetByIdDetailed(response: HttpResponseBase): Observable<DetailedOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailedOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailedOrderModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putOrderDetailed(body: Order | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/PutOrderDetailed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutOrderDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutOrderDetailed(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutOrderDetailed(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Order> {
        let url_ = this.baseUrl + "/Order/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Order>><any>_observableThrow(e);
                }
            } else
                return <Observable<Order>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Order>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param initialFileName (optional) 
     * @param body (optional) 
     * @return Success
     */
    addAttachment(orderId: string | undefined, initialFileName: string | null | undefined, body: ExportDetailedFile | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/AddAttachment?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (initialFileName !== undefined && initialFileName !== null)
            url_ += "initialFileName=" + encodeURIComponent("" + initialFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttachment(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAddAttachment(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAttachment(id: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Order/DeleteAttachment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getAttachments(orderId: string | undefined): Observable<OrderAttachment[]> {
        let url_ = this.baseUrl + "/Order/GetAttachments?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(<any>response_);
                } catch (e) {
                    return <Observable<OrderAttachment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderAttachment[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<OrderAttachment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderAttachment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderAttachment[]>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    stolplitImportExcel(file: FileParameter | null | undefined): Observable<StolplitExcelImportValidationModel> {
        let url_ = this.baseUrl + "/Order/StolplitImportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStolplitImportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStolplitImportExcel(<any>response_);
                } catch (e) {
                    return <Observable<StolplitExcelImportValidationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StolplitExcelImportValidationModel>><any>_observableThrow(response_);
        }));
    }

    protected processStolplitImportExcel(response: HttpResponseBase): Observable<StolplitExcelImportValidationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StolplitExcelImportValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StolplitExcelImportValidationModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stolplitImportExcelUpload(body: StolplitOrderExcelImportDto[] | null | undefined): Observable<ValidationModel> {
        let url_ = this.baseUrl + "/Order/StolplitImportExcelUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStolplitImportExcelUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStolplitImportExcelUpload(<any>response_);
                } catch (e) {
                    return <Observable<ValidationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidationModel>><any>_observableThrow(response_);
        }));
    }

    protected processStolplitImportExcelUpload(response: HttpResponseBase): Observable<ValidationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrderSourceApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/OrderSource/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    getListWithoutLoadResult(): Observable<OrderSourceDto[]> {
        let url_ = this.baseUrl + "/OrderSource/GetListWithoutLoadResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListWithoutLoadResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWithoutLoadResult(<any>response_);
                } catch (e) {
                    return <Observable<OrderSourceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderSourceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListWithoutLoadResult(response: HttpResponseBase): Observable<OrderSourceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderSourceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderSourceDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderSourcePost(body: OrderSourceDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/OrderSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderSourcePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderSourcePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processOrderSourcePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderSourcePut(body: OrderSourceDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/OrderSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderSourcePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderSourcePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processOrderSourcePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    orderSourceDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/OrderSource?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderSourceDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderSourceDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processOrderSourceDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<OrderSource> {
        let url_ = this.baseUrl + "/OrderSource/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<OrderSource>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderSource>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrderSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderSource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderSource>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OzonApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGoods(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Ozon/GetGoods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoods(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetGoods(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    edit(body: GoodOzonDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWarehouses(): Observable<OzonWarehouseResponseItem[]> {
        let url_ = this.baseUrl + "/Ozon/GetAllWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<OzonWarehouseResponseItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OzonWarehouseResponseItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWarehouses(response: HttpResponseBase): Observable<OzonWarehouseResponseItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OzonWarehouseResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OzonWarehouseResponseItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLastSyncDate(): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/GetLastSyncDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastSyncDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastSyncDate(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastSyncDate(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param articul (optional) 
     * @return Success
     */
    checkIfProductExistsOnOzon(articul: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/CheckIfProductExistsOnOzon?";
        if (articul !== undefined && articul !== null)
            url_ += "articul=" + encodeURIComponent("" + articul) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfProductExistsOnOzon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfProductExistsOnOzon(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfProductExistsOnOzon(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    syncProducts(): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/SyncProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncProducts(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSyncProducts(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param goodId (optional) 
     * @return Success
     */
    updateStockForCertainGood(goodId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/UpdateStockForCertainGood?";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStockForCertainGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStockForCertainGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStockForCertainGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param goodId (optional) 
     * @return Success
     */
    updatePriceForCertainGood(goodId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Ozon/UpdatePriceForCertainGood?";
        if (goodId === null)
            throw new Error("The parameter 'goodId' cannot be null.");
        else if (goodId !== undefined)
            url_ += "goodId=" + encodeURIComponent("" + goodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePriceForCertainGood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePriceForCertainGood(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePriceForCertainGood(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PageSeoOptionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/PageSeoOption/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pageSeoOptionPost(body: PageSeoOptionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/PageSeoOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageSeoOptionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageSeoOptionPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPageSeoOptionPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pageSeoOptionPut(body: PageSeoOptionDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/PageSeoOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageSeoOptionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageSeoOptionPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPageSeoOptionPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pageSeoOptionDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/PageSeoOption?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageSeoOptionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageSeoOptionDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPageSeoOptionDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<PageSeoOption> {
        let url_ = this.baseUrl + "/PageSeoOption/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<PageSeoOption>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageSeoOption>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PageSeoOption> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageSeoOption.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageSeoOption>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentSystemApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getList(): Observable<PaymentSystemDto[]> {
        let url_ = this.baseUrl + "/PaymentSystem/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PaymentSystemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentSystemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PaymentSystemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentSystemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentSystemDto[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RealizationApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Realization/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    sync(): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Realization/Sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SelectionTypeApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/SelectionType/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/SelectionType/GetAllList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    selectionTypePost(body: SelectionTypeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SelectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectionTypePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectionTypePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSelectionTypePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    selectionTypePut(body: SelectionTypeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SelectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectionTypePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectionTypePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSelectionTypePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    selectionTypeDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SelectionType?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectionTypeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectionTypeDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSelectionTypeDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<GoodSelectionType> {
        let url_ = this.baseUrl + "/SelectionType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GoodSelectionType>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoodSelectionType>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GoodSelectionType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoodSelectionType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodSelectionType>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SitemapApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Observable<void> {
        let url_ = this.baseUrl + "/Sitemap/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SitemapManualUrlApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/SitemapManualUrl/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sitemapManualUrlPost(body: SitemapManualUrlDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SitemapManualUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSitemapManualUrlPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSitemapManualUrlPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSitemapManualUrlPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sitemapManualUrlPut(body: SitemapManualUrlDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SitemapManualUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSitemapManualUrlPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSitemapManualUrlPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSitemapManualUrlPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sitemapManualUrlDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SitemapManualUrl?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSitemapManualUrlDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSitemapManualUrlDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSitemapManualUrlDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<SitemapManualUrl> {
        let url_ = this.baseUrl + "/SitemapManualUrl/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<SitemapManualUrl>><any>_observableThrow(e);
                }
            } else
                return <Observable<SitemapManualUrl>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SitemapManualUrl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SitemapManualUrl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SitemapManualUrl>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupplierOrderApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/SupplierOrder/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    realizationRequest(body: NewRealizationRequestParameters | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SupplierOrder/RealizationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRealizationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRealizationRequest(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRealizationRequest(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    cancelOrder(orderId: number | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/SupplierOrder/CancelOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrder(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCancelOrder(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Tenant/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCityInfo(cityId: string | null | undefined, tenantId: string | null | undefined): Observable<GetCityInfoResponse> {
        let url_ = this.baseUrl + "/Tenant/GetCityInfo?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetCityInfoResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCityInfoResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCityInfo(response: HttpResponseBase): Observable<GetCityInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCityInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCityInfoResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantPost(body: TenantDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantPut(body: TenantDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    tenantDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putSeoData(body: TenantSeoDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/PutSeoData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutSeoData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutSeoData(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutSeoData(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param marketplaceInclusions (optional) 
     * @return Success
     */
    setMarketPlaceInclusions(tenantId: string | undefined, marketplaceInclusions: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/SetMarketPlaceInclusions?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (marketplaceInclusions !== undefined && marketplaceInclusions !== null)
            url_ += "marketplaceInclusions=" + encodeURIComponent("" + marketplaceInclusions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMarketPlaceInclusions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMarketPlaceInclusions(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSetMarketPlaceInclusions(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putPages(cityId: string | null | undefined, body: TenantDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/PutPages?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPages(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutPages(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putSuperAdmin(cityId: string | null | undefined, body: TenantDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/PutSuperAdmin?";
        if (cityId !== undefined && cityId !== null)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutSuperAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutSuperAdmin(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutSuperAdmin(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/Tenant/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    rebuildMarketPlaceInclusions(tenantId: string | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/RebuildMarketPlaceInclusions?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildMarketPlaceInclusions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildMarketPlaceInclusions(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRebuildMarketPlaceInclusions(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param updateBasePrices (optional) 
     * @return Success
     */
    rebuildPricesForMarketPlace(tenantId: string | undefined, updateBasePrices: boolean | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Tenant/RebuildPricesForMarketPlace?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (updateBasePrices === null)
            throw new Error("The parameter 'updateBasePrices' cannot be null.");
        else if (updateBasePrices !== undefined)
            url_ += "updateBasePrices=" + encodeURIComponent("" + updateBasePrices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildPricesForMarketPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildPricesForMarketPlace(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRebuildPricesForMarketPlace(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getAvailableWarehouses(): Observable<City[]> {
        let url_ = this.baseUrl + "/Tenant/GetAvailableWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<City[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<City[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableWarehouses(response: HttpResponseBase): Observable<City[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(City.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<City[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPartnerInfos(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Tenant/GetPartnerInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerInfos(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerInfos(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param xmlId (optional) 
     * @return Success
     */
    getPartnerInfoByXmlId(xmlId: string | undefined): Observable<NikaPartnerInfo> {
        let url_ = this.baseUrl + "/Tenant/GetPartnerInfoByXmlId?";
        if (xmlId === null)
            throw new Error("The parameter 'xmlId' cannot be null.");
        else if (xmlId !== undefined)
            url_ += "xmlId=" + encodeURIComponent("" + xmlId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerInfoByXmlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerInfoByXmlId(<any>response_);
                } catch (e) {
                    return <Observable<NikaPartnerInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<NikaPartnerInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerInfoByXmlId(response: HttpResponseBase): Observable<NikaPartnerInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NikaPartnerInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NikaPartnerInfo>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPartnerInfoById(id: string | undefined): Observable<NikaPartnerInfo> {
        let url_ = this.baseUrl + "/Tenant/GetPartnerInfoById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerInfoById(<any>response_);
                } catch (e) {
                    return <Observable<NikaPartnerInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<NikaPartnerInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerInfoById(response: HttpResponseBase): Observable<NikaPartnerInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NikaPartnerInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NikaPartnerInfo>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantActionSetupApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/TenantActionSetup/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantActionSetup(body: TenantActionSetupDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantActionSetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantActionSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantActionSetup(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantActionSetup(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantActionSetup> {
        let url_ = this.baseUrl + "/TenantActionSetup/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantActionSetup>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantActionSetup>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantActionSetup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantActionSetup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantActionSetup>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantCategoryTextApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/TenantCategoryText/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantCategoryTextPost(body: TenantCategoryTextDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantCategoryText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantCategoryTextPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantCategoryTextPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantCategoryTextPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantCategoryTextPut(body: TenantCategoryTextDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantCategoryText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantCategoryTextPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantCategoryTextPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantCategoryTextPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    tenantCategoryTextDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantCategoryText?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantCategoryTextDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantCategoryTextDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantCategoryTextDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantCategoryText> {
        let url_ = this.baseUrl + "/TenantCategoryText/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantCategoryText>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantCategoryText>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantCategoryText> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantCategoryText.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantCategoryText>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantInboundEmailApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/TenantInboundEmail/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantInboundEmailPost(body: TenantInboundEmailDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantInboundEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantInboundEmailPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantInboundEmailPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantInboundEmailPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantInboundEmailPut(body: TenantInboundEmailDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantInboundEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantInboundEmailPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantInboundEmailPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantInboundEmailPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    tenantInboundEmailDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantInboundEmail?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantInboundEmailDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantInboundEmailDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantInboundEmailDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantInboundEmail> {
        let url_ = this.baseUrl + "/TenantInboundEmail/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantInboundEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInboundEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantInboundEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInboundEmail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInboundEmail>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantSeoAttributeApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/TenantSeoAttribute/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantSeoAttributePost(body: TenantSeoAttributeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantSeoAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantSeoAttributePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantSeoAttributePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantSeoAttributePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantSeoAttributePut(body: TenantSeoAttributeDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantSeoAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantSeoAttributePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantSeoAttributePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantSeoAttributePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    tenantSeoAttributeDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantSeoAttribute?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantSeoAttributeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantSeoAttributeDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantSeoAttributeDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantSeoAttribute> {
        let url_ = this.baseUrl + "/TenantSeoAttribute/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantSeoAttribute>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSeoAttribute>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantSeoAttribute> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSeoAttribute.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSeoAttribute>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantWarehouseRestApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param showModules (optional) 
     * @param body (optional) 
     * @return Success
     */
    getList(showModules: boolean | undefined, body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/TenantWarehouseRest/GetList?";
        if (showModules === null)
            throw new Error("The parameter 'showModules' cannot be null.");
        else if (showModules !== undefined)
            url_ += "showModules=" + encodeURIComponent("" + showModules) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantWarehouseRest(body: TenantWarehouseRestDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantWarehouseRest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantWarehouseRest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantWarehouseRest(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processTenantWarehouseRest(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<TenantWarehouseRest> {
        let url_ = this.baseUrl + "/TenantWarehouseRest/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TenantWarehouseRest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantWarehouseRest>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TenantWarehouseRest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantWarehouseRest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantWarehouseRest>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importExcel(file: FileParameter | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/TenantWarehouseRest/ImportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExcel(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processImportExcel(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UploadApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Upload/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    getByPhoneNumber(phoneNumber: string | null | undefined): Observable<CallUserInfo> {
        let url_ = this.baseUrl + "/User/GetByPhoneNumber?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<CallUserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<CallUserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetByPhoneNumber(response: HttpResponseBase): Observable<CallUserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallUserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CallUserInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdminUsers(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/User/GetAdminUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUsers(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminUsers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantAdminUsersWithoutLoadResult(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/User/GetTenantAdminUsersWithoutLoadResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantAdminUsersWithoutLoadResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantAdminUsersWithoutLoadResult(<any>response_);
                } catch (e) {
                    return <Observable<UserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantAdminUsersWithoutLoadResult(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTenantAdminUsers(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/User/GetTenantAdminUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantAdminUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantAdminUsers(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantAdminUsers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSiteUsers(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/User/GetSiteUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteUsers(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetSiteUsers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userPost(body: UserDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUserPost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userPut(body: UserDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUserPut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    userDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/User?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processUserDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putSiteUser(body: UserDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/User/PutSiteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutSiteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutSiteUser(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processPutSiteUser(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | null | undefined): Observable<User> {
        let url_ = this.baseUrl + "/User/GetById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<User>><any>_observableThrow(e);
                }
            } else
                return <Observable<User>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WarehouseApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getList(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Warehouse/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    warehousePost(body: WarehouseDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Warehouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWarehousePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWarehousePost(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processWarehousePost(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    warehousePut(body: WarehouseDto | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Warehouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWarehousePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWarehousePut(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processWarehousePut(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    warehouseDelete(id: string | null | undefined): Observable<BaseResponseModel> {
        let url_ = this.baseUrl + "/Warehouse?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWarehouseDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWarehouseDelete(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processWarehouseDelete(response: HttpResponseBase): Observable<BaseResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponseModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<Warehouse> {
        let url_ = this.baseUrl + "/Warehouse/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Warehouse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Warehouse>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Warehouse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Warehouse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Warehouse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPartnerInfos(body: DataSourceLoadOptions | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/Warehouse/GetPartnerInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerInfos(<any>response_);
                } catch (e) {
                    return <Observable<LoadResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerInfos(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPartnerInfoByAgreementXmlId(id: string | undefined): Observable<NikaPartnerInfo> {
        let url_ = this.baseUrl + "/Warehouse/GetPartnerInfoByAgreementXmlId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerInfoByAgreementXmlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerInfoByAgreementXmlId(<any>response_);
                } catch (e) {
                    return <Observable<NikaPartnerInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<NikaPartnerInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerInfoByAgreementXmlId(response: HttpResponseBase): Observable<NikaPartnerInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NikaPartnerInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NikaPartnerInfo>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class YmlApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    get(tenantId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Yml/Get?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class SortingInfo implements ISortingInfo {
    selector?: string | null;
    desc?: boolean;

    constructor(data?: ISortingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"] !== undefined ? _data["selector"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
        }
    }

    static fromJS(data: any): SortingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SortingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector !== undefined ? this.selector : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        return data; 
    }

    clone(): SortingInfo {
        const json = this.toJSON();
        let result = new SortingInfo();
        result.init(json);
        return result;
    }
}

export interface ISortingInfo {
    selector?: string | null;
    desc?: boolean;
}

export class GroupingInfo implements IGroupingInfo {
    selector?: string | null;
    desc?: boolean;
    groupInterval?: string | null;
    isExpanded?: boolean | null;

    constructor(data?: IGroupingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"] !== undefined ? _data["selector"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            this.groupInterval = _data["groupInterval"] !== undefined ? _data["groupInterval"] : <any>null;
            this.isExpanded = _data["isExpanded"] !== undefined ? _data["isExpanded"] : <any>null;
        }
    }

    static fromJS(data: any): GroupingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GroupingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector !== undefined ? this.selector : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        data["groupInterval"] = this.groupInterval !== undefined ? this.groupInterval : <any>null;
        data["isExpanded"] = this.isExpanded !== undefined ? this.isExpanded : <any>null;
        return data; 
    }

    clone(): GroupingInfo {
        const json = this.toJSON();
        let result = new GroupingInfo();
        result.init(json);
        return result;
    }
}

export interface IGroupingInfo {
    selector?: string | null;
    desc?: boolean;
    groupInterval?: string | null;
    isExpanded?: boolean | null;
}

export class SummaryInfo implements ISummaryInfo {
    selector?: string | null;
    summaryType?: string | null;

    constructor(data?: ISummaryInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"] !== undefined ? _data["selector"] : <any>null;
            this.summaryType = _data["summaryType"] !== undefined ? _data["summaryType"] : <any>null;
        }
    }

    static fromJS(data: any): SummaryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector !== undefined ? this.selector : <any>null;
        data["summaryType"] = this.summaryType !== undefined ? this.summaryType : <any>null;
        return data; 
    }

    clone(): SummaryInfo {
        const json = this.toJSON();
        let result = new SummaryInfo();
        result.init(json);
        return result;
    }
}

export interface ISummaryInfo {
    selector?: string | null;
    summaryType?: string | null;
}

export class DataSourceLoadOptions implements IDataSourceLoadOptions {
    requireTotalCount?: boolean;
    requireGroupCount?: boolean;
    isCountQuery?: boolean;
    skip?: number;
    take?: number;
    sort?: SortingInfo[] | null;
    group?: GroupingInfo[] | null;
    filter?: any[] | null;
    totalSummary?: SummaryInfo[] | null;
    groupSummary?: SummaryInfo[] | null;
    select?: string[] | null;
    preSelect?: string[] | null;
    remoteSelect?: boolean | null;
    remoteGrouping?: boolean | null;
    primaryKey?: string[] | null;
    defaultSort?: string | null;
    stringToLower?: boolean | null;

    constructor(data?: IDataSourceLoadOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireTotalCount = _data["requireTotalCount"] !== undefined ? _data["requireTotalCount"] : <any>null;
            this.requireGroupCount = _data["requireGroupCount"] !== undefined ? _data["requireGroupCount"] : <any>null;
            this.isCountQuery = _data["isCountQuery"] !== undefined ? _data["isCountQuery"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.take = _data["take"] !== undefined ? _data["take"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortingInfo.fromJS(item));
            }
            else {
                this.sort = <any>null;
            }
            if (Array.isArray(_data["group"])) {
                this.group = [] as any;
                for (let item of _data["group"])
                    this.group!.push(GroupingInfo.fromJS(item));
            }
            else {
                this.group = <any>null;
            }
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(item);
            }
            else {
                this.filter = <any>null;
            }
            if (Array.isArray(_data["totalSummary"])) {
                this.totalSummary = [] as any;
                for (let item of _data["totalSummary"])
                    this.totalSummary!.push(SummaryInfo.fromJS(item));
            }
            else {
                this.totalSummary = <any>null;
            }
            if (Array.isArray(_data["groupSummary"])) {
                this.groupSummary = [] as any;
                for (let item of _data["groupSummary"])
                    this.groupSummary!.push(SummaryInfo.fromJS(item));
            }
            else {
                this.groupSummary = <any>null;
            }
            if (Array.isArray(_data["select"])) {
                this.select = [] as any;
                for (let item of _data["select"])
                    this.select!.push(item);
            }
            else {
                this.select = <any>null;
            }
            if (Array.isArray(_data["preSelect"])) {
                this.preSelect = [] as any;
                for (let item of _data["preSelect"])
                    this.preSelect!.push(item);
            }
            else {
                this.preSelect = <any>null;
            }
            this.remoteSelect = _data["remoteSelect"] !== undefined ? _data["remoteSelect"] : <any>null;
            this.remoteGrouping = _data["remoteGrouping"] !== undefined ? _data["remoteGrouping"] : <any>null;
            if (Array.isArray(_data["primaryKey"])) {
                this.primaryKey = [] as any;
                for (let item of _data["primaryKey"])
                    this.primaryKey!.push(item);
            }
            else {
                this.primaryKey = <any>null;
            }
            this.defaultSort = _data["defaultSort"] !== undefined ? _data["defaultSort"] : <any>null;
            this.stringToLower = _data["stringToLower"] !== undefined ? _data["stringToLower"] : <any>null;
        }
    }

    static fromJS(data: any): DataSourceLoadOptions {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceLoadOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireTotalCount"] = this.requireTotalCount !== undefined ? this.requireTotalCount : <any>null;
        data["requireGroupCount"] = this.requireGroupCount !== undefined ? this.requireGroupCount : <any>null;
        data["isCountQuery"] = this.isCountQuery !== undefined ? this.isCountQuery : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["take"] = this.take !== undefined ? this.take : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item.toJSON());
        }
        if (Array.isArray(this.group)) {
            data["group"] = [];
            for (let item of this.group)
                data["group"].push(item.toJSON());
        }
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item);
        }
        if (Array.isArray(this.totalSummary)) {
            data["totalSummary"] = [];
            for (let item of this.totalSummary)
                data["totalSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.groupSummary)) {
            data["groupSummary"] = [];
            for (let item of this.groupSummary)
                data["groupSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.select)) {
            data["select"] = [];
            for (let item of this.select)
                data["select"].push(item);
        }
        if (Array.isArray(this.preSelect)) {
            data["preSelect"] = [];
            for (let item of this.preSelect)
                data["preSelect"].push(item);
        }
        data["remoteSelect"] = this.remoteSelect !== undefined ? this.remoteSelect : <any>null;
        data["remoteGrouping"] = this.remoteGrouping !== undefined ? this.remoteGrouping : <any>null;
        if (Array.isArray(this.primaryKey)) {
            data["primaryKey"] = [];
            for (let item of this.primaryKey)
                data["primaryKey"].push(item);
        }
        data["defaultSort"] = this.defaultSort !== undefined ? this.defaultSort : <any>null;
        data["stringToLower"] = this.stringToLower !== undefined ? this.stringToLower : <any>null;
        return data; 
    }

    clone(): DataSourceLoadOptions {
        const json = this.toJSON();
        let result = new DataSourceLoadOptions();
        result.init(json);
        return result;
    }
}

export interface IDataSourceLoadOptions {
    requireTotalCount?: boolean;
    requireGroupCount?: boolean;
    isCountQuery?: boolean;
    skip?: number;
    take?: number;
    sort?: SortingInfo[] | null;
    group?: GroupingInfo[] | null;
    filter?: any[] | null;
    totalSummary?: SummaryInfo[] | null;
    groupSummary?: SummaryInfo[] | null;
    select?: string[] | null;
    preSelect?: string[] | null;
    remoteSelect?: boolean | null;
    remoteGrouping?: boolean | null;
    primaryKey?: string[] | null;
    defaultSort?: string | null;
    stringToLower?: boolean | null;
}

export class LoadResult implements ILoadResult {
    data?: any[] | null;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | null;

    constructor(data?: ILoadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.totalCount = -1;
            this.groupCount = -1;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            else {
                this.data = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : -1;
            this.groupCount = _data["groupCount"] !== undefined ? _data["groupCount"] : -1;
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
            else {
                this.summary = <any>null;
            }
        }
    }

    static fromJS(data: any): LoadResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["groupCount"] = this.groupCount !== undefined ? this.groupCount : <any>null;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data; 
    }

    clone(): LoadResult {
        const json = this.toJSON();
        let result = new LoadResult();
        result.init(json);
        return result;
    }
}

export interface ILoadResult {
    data?: any[] | null;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | null;
}

export class GoodPriceUpDto implements IGoodPriceUpDto {
    goodIds?: string[] | null;
    priceUpRate?: number;

    constructor(data?: IGoodPriceUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
            this.priceUpRate = _data["priceUpRate"] !== undefined ? _data["priceUpRate"] : <any>null;
        }
    }

    static fromJS(data: any): GoodPriceUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodPriceUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        data["priceUpRate"] = this.priceUpRate !== undefined ? this.priceUpRate : <any>null;
        return data; 
    }

    clone(): GoodPriceUpDto {
        const json = this.toJSON();
        let result = new GoodPriceUpDto();
        result.init(json);
        return result;
    }
}

export interface IGoodPriceUpDto {
    goodIds?: string[] | null;
    priceUpRate?: number;
}

export class BaseResponseModel implements IBaseResponseModel {
    success?: boolean;
    message?: string | null;

    constructor(data?: IBaseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): BaseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data; 
    }

    clone(): BaseResponseModel {
        const json = this.toJSON();
        let result = new BaseResponseModel();
        result.init(json);
        return result;
    }
}

export interface IBaseResponseModel {
    success?: boolean;
    message?: string | null;
}

export class SetSaleDto implements ISetSaleDto {
    goodIds?: string[] | null;
    saleRate?: number;
    saleEndDateTime?: string | null;

    constructor(data?: ISetSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
            this.saleRate = _data["saleRate"] !== undefined ? _data["saleRate"] : <any>null;
            this.saleEndDateTime = _data["saleEndDateTime"] !== undefined ? _data["saleEndDateTime"] : <any>null;
        }
    }

    static fromJS(data: any): SetSaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        data["saleRate"] = this.saleRate !== undefined ? this.saleRate : <any>null;
        data["saleEndDateTime"] = this.saleEndDateTime !== undefined ? this.saleEndDateTime : <any>null;
        return data; 
    }

    clone(): SetSaleDto {
        const json = this.toJSON();
        let result = new SetSaleDto();
        result.init(json);
        return result;
    }
}

export interface ISetSaleDto {
    goodIds?: string[] | null;
    saleRate?: number;
    saleEndDateTime?: string | null;
}

export class SetForMarketplaceDto implements ISetForMarketplaceDto {
    goodIds?: string[] | null;

    constructor(data?: ISetForMarketplaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetForMarketplaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetForMarketplaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        return data; 
    }

    clone(): SetForMarketplaceDto {
        const json = this.toJSON();
        let result = new SetForMarketplaceDto();
        result.init(json);
        return result;
    }
}

export interface ISetForMarketplaceDto {
    goodIds?: string[] | null;
}

export enum PaymentSystem {
    _100 = 100,
    _200 = 200,
}

export enum RoundType {
    _1 = 1,
    _10 = 10,
    _100 = 100,
}

export enum NavigationType {
    _50 = 50,
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
    _500 = 500,
    _600 = 600,
    _700 = 700,
    _800 = 800,
}

export class TenantDto implements ITenantDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    isActive?: boolean | null;
    login?: string | null;
    password?: string | null;
    sitePhoneNumber?: string | null;
    siteWorkSchedule?: string | null;
    siteLogo?: string | null;
    siteTitle?: string | null;
    defaultPriceUpRate?: number | null;
    rewiewsPageInnerHtml?: string | null;
    paymentSystem?: PaymentSystem;
    paymentSystemLogin?: string | null;
    paymentSystemPassword?: string | null;
    paymentSystemLoginInfo?: string | null;
    paymentSystemPasswordInfo?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    deliveryPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    deliveryPageRawHtml?: string | null;
    contactPageRawHtml?: string | null;
    privacyPolicyPageRawHtml?: string | null;
    termsOfUsePageRawHtml?: string | null;
    aboutPageRawHtml?: string | null;
    returnPageRawHtml?: string | null;
    requisitesPageRawHtml?: string | null;
    guaranteePageRawHtml?: string | null;
    publicOfferPageRawHtml?: string | null;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    bitrixWebhook?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    enabledDeliveryMethods?: string | null;
    enabledPaymentMethods?: string | null;
    cashDisabled?: boolean | null;
    bankCardDisabled?: boolean | null;
    onlineDisabled?: boolean | null;
    legalEntityDisabled?: boolean | null;
    dynamicScripts?: string | null;
    mainPageSeoBlock?: string | null;
    mainUrl?: string | null;
    roundType?: RoundType;
    siteConnected?: boolean | null;
    marketPlaceConnected?: boolean | null;
    nikaConnected?: boolean | null;
    dynamicHeadScripts?: string | null;
    inboundEmail?: string | null;
    navType?: NavigationType;
    claims?: string | null;
    marketPlaceInclusions?: string | null;
    calltouchAccessToken?: string | null;
    calltouchSiteId?: string | null;
    defaultWarehouseId?: string | null;
    nikaPartnerInfoId?: string | null;
    ozonApiKey?: string | null;
    ozonClientId?: string | null;
    ozonWarehouseId?: number | null;
    ozonIntegrationEnabled?: boolean | null;
    externalConstructorLink?: string | null;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.sitePhoneNumber = _data["sitePhoneNumber"] !== undefined ? _data["sitePhoneNumber"] : <any>null;
            this.siteWorkSchedule = _data["siteWorkSchedule"] !== undefined ? _data["siteWorkSchedule"] : <any>null;
            this.siteLogo = _data["siteLogo"] !== undefined ? _data["siteLogo"] : <any>null;
            this.siteTitle = _data["siteTitle"] !== undefined ? _data["siteTitle"] : <any>null;
            this.defaultPriceUpRate = _data["defaultPriceUpRate"] !== undefined ? _data["defaultPriceUpRate"] : <any>null;
            this.rewiewsPageInnerHtml = _data["rewiewsPageInnerHtml"] !== undefined ? _data["rewiewsPageInnerHtml"] : <any>null;
            this.paymentSystem = _data["paymentSystem"] !== undefined ? _data["paymentSystem"] : <any>null;
            this.paymentSystemLogin = _data["paymentSystemLogin"] !== undefined ? _data["paymentSystemLogin"] : <any>null;
            this.paymentSystemPassword = _data["paymentSystemPassword"] !== undefined ? _data["paymentSystemPassword"] : <any>null;
            this.paymentSystemLoginInfo = _data["paymentSystemLoginInfo"] !== undefined ? _data["paymentSystemLoginInfo"] : <any>null;
            this.paymentSystemPasswordInfo = _data["paymentSystemPasswordInfo"] !== undefined ? _data["paymentSystemPasswordInfo"] : <any>null;
            this.telegramLink = _data["telegramLink"] !== undefined ? _data["telegramLink"] : <any>null;
            this.instagramLink = _data["instagramLink"] !== undefined ? _data["instagramLink"] : <any>null;
            this.vkLink = _data["vkLink"] !== undefined ? _data["vkLink"] : <any>null;
            this.okLink = _data["okLink"] !== undefined ? _data["okLink"] : <any>null;
            this.facebookLink = _data["facebookLink"] !== undefined ? _data["facebookLink"] : <any>null;
            this.twitterLink = _data["twitterLink"] !== undefined ? _data["twitterLink"] : <any>null;
            this.youTubeLink = _data["youTubeLink"] !== undefined ? _data["youTubeLink"] : <any>null;
            this.deliveryPageInnerHtml = _data["deliveryPageInnerHtml"] !== undefined ? _data["deliveryPageInnerHtml"] : <any>null;
            this.contactPageInnerHtml = _data["contactPageInnerHtml"] !== undefined ? _data["contactPageInnerHtml"] : <any>null;
            this.privacyPolicyPageInnerHtml = _data["privacyPolicyPageInnerHtml"] !== undefined ? _data["privacyPolicyPageInnerHtml"] : <any>null;
            this.termsOfUsePageInnerHtml = _data["termsOfUsePageInnerHtml"] !== undefined ? _data["termsOfUsePageInnerHtml"] : <any>null;
            this.aboutPageInnerHtml = _data["aboutPageInnerHtml"] !== undefined ? _data["aboutPageInnerHtml"] : <any>null;
            this.returnPageInnerHtml = _data["returnPageInnerHtml"] !== undefined ? _data["returnPageInnerHtml"] : <any>null;
            this.requisitesPageInnerHtml = _data["requisitesPageInnerHtml"] !== undefined ? _data["requisitesPageInnerHtml"] : <any>null;
            this.guaranteePageInnerHtml = _data["guaranteePageInnerHtml"] !== undefined ? _data["guaranteePageInnerHtml"] : <any>null;
            this.publicOfferPageInnerHtml = _data["publicOfferPageInnerHtml"] !== undefined ? _data["publicOfferPageInnerHtml"] : <any>null;
            this.deliveryPageRawHtml = _data["deliveryPageRawHtml"] !== undefined ? _data["deliveryPageRawHtml"] : <any>null;
            this.contactPageRawHtml = _data["contactPageRawHtml"] !== undefined ? _data["contactPageRawHtml"] : <any>null;
            this.privacyPolicyPageRawHtml = _data["privacyPolicyPageRawHtml"] !== undefined ? _data["privacyPolicyPageRawHtml"] : <any>null;
            this.termsOfUsePageRawHtml = _data["termsOfUsePageRawHtml"] !== undefined ? _data["termsOfUsePageRawHtml"] : <any>null;
            this.aboutPageRawHtml = _data["aboutPageRawHtml"] !== undefined ? _data["aboutPageRawHtml"] : <any>null;
            this.returnPageRawHtml = _data["returnPageRawHtml"] !== undefined ? _data["returnPageRawHtml"] : <any>null;
            this.requisitesPageRawHtml = _data["requisitesPageRawHtml"] !== undefined ? _data["requisitesPageRawHtml"] : <any>null;
            this.guaranteePageRawHtml = _data["guaranteePageRawHtml"] !== undefined ? _data["guaranteePageRawHtml"] : <any>null;
            this.publicOfferPageRawHtml = _data["publicOfferPageRawHtml"] !== undefined ? _data["publicOfferPageRawHtml"] : <any>null;
            this.mainColor = _data["mainColor"] !== undefined ? _data["mainColor"] : <any>null;
            this.secondColor = _data["secondColor"] !== undefined ? _data["secondColor"] : <any>null;
            this.faviconIcon = _data["faviconIcon"] !== undefined ? _data["faviconIcon"] : <any>null;
            this.bitrixWebhook = _data["bitrixWebhook"] !== undefined ? _data["bitrixWebhook"] : <any>null;
            this.categoryMetaTitlePattern = _data["categoryMetaTitlePattern"] !== undefined ? _data["categoryMetaTitlePattern"] : <any>null;
            this.categoryMetaDescriptionPattern = _data["categoryMetaDescriptionPattern"] !== undefined ? _data["categoryMetaDescriptionPattern"] : <any>null;
            this.goodMetaTitlePattern = _data["goodMetaTitlePattern"] !== undefined ? _data["goodMetaTitlePattern"] : <any>null;
            this.goodMetaDescriptionPattern = _data["goodMetaDescriptionPattern"] !== undefined ? _data["goodMetaDescriptionPattern"] : <any>null;
            this.enabledDeliveryMethods = _data["enabledDeliveryMethods"] !== undefined ? _data["enabledDeliveryMethods"] : <any>null;
            this.enabledPaymentMethods = _data["enabledPaymentMethods"] !== undefined ? _data["enabledPaymentMethods"] : <any>null;
            this.cashDisabled = _data["cashDisabled"] !== undefined ? _data["cashDisabled"] : <any>null;
            this.bankCardDisabled = _data["bankCardDisabled"] !== undefined ? _data["bankCardDisabled"] : <any>null;
            this.onlineDisabled = _data["onlineDisabled"] !== undefined ? _data["onlineDisabled"] : <any>null;
            this.legalEntityDisabled = _data["legalEntityDisabled"] !== undefined ? _data["legalEntityDisabled"] : <any>null;
            this.dynamicScripts = _data["dynamicScripts"] !== undefined ? _data["dynamicScripts"] : <any>null;
            this.mainPageSeoBlock = _data["mainPageSeoBlock"] !== undefined ? _data["mainPageSeoBlock"] : <any>null;
            this.mainUrl = _data["mainUrl"] !== undefined ? _data["mainUrl"] : <any>null;
            this.roundType = _data["roundType"] !== undefined ? _data["roundType"] : <any>null;
            this.siteConnected = _data["siteConnected"] !== undefined ? _data["siteConnected"] : <any>null;
            this.marketPlaceConnected = _data["marketPlaceConnected"] !== undefined ? _data["marketPlaceConnected"] : <any>null;
            this.nikaConnected = _data["nikaConnected"] !== undefined ? _data["nikaConnected"] : <any>null;
            this.dynamicHeadScripts = _data["dynamicHeadScripts"] !== undefined ? _data["dynamicHeadScripts"] : <any>null;
            this.inboundEmail = _data["inboundEmail"] !== undefined ? _data["inboundEmail"] : <any>null;
            this.navType = _data["navType"] !== undefined ? _data["navType"] : <any>null;
            this.claims = _data["claims"] !== undefined ? _data["claims"] : <any>null;
            this.marketPlaceInclusions = _data["marketPlaceInclusions"] !== undefined ? _data["marketPlaceInclusions"] : <any>null;
            this.calltouchAccessToken = _data["calltouchAccessToken"] !== undefined ? _data["calltouchAccessToken"] : <any>null;
            this.calltouchSiteId = _data["calltouchSiteId"] !== undefined ? _data["calltouchSiteId"] : <any>null;
            this.defaultWarehouseId = _data["defaultWarehouseId"] !== undefined ? _data["defaultWarehouseId"] : <any>null;
            this.nikaPartnerInfoId = _data["nikaPartnerInfoId"] !== undefined ? _data["nikaPartnerInfoId"] : <any>null;
            this.ozonApiKey = _data["ozonApiKey"] !== undefined ? _data["ozonApiKey"] : <any>null;
            this.ozonClientId = _data["ozonClientId"] !== undefined ? _data["ozonClientId"] : <any>null;
            this.ozonWarehouseId = _data["ozonWarehouseId"] !== undefined ? _data["ozonWarehouseId"] : <any>null;
            this.ozonIntegrationEnabled = _data["ozonIntegrationEnabled"] !== undefined ? _data["ozonIntegrationEnabled"] : <any>null;
            this.externalConstructorLink = _data["externalConstructorLink"] !== undefined ? _data["externalConstructorLink"] : <any>null;
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["sitePhoneNumber"] = this.sitePhoneNumber !== undefined ? this.sitePhoneNumber : <any>null;
        data["siteWorkSchedule"] = this.siteWorkSchedule !== undefined ? this.siteWorkSchedule : <any>null;
        data["siteLogo"] = this.siteLogo !== undefined ? this.siteLogo : <any>null;
        data["siteTitle"] = this.siteTitle !== undefined ? this.siteTitle : <any>null;
        data["defaultPriceUpRate"] = this.defaultPriceUpRate !== undefined ? this.defaultPriceUpRate : <any>null;
        data["rewiewsPageInnerHtml"] = this.rewiewsPageInnerHtml !== undefined ? this.rewiewsPageInnerHtml : <any>null;
        data["paymentSystem"] = this.paymentSystem !== undefined ? this.paymentSystem : <any>null;
        data["paymentSystemLogin"] = this.paymentSystemLogin !== undefined ? this.paymentSystemLogin : <any>null;
        data["paymentSystemPassword"] = this.paymentSystemPassword !== undefined ? this.paymentSystemPassword : <any>null;
        data["paymentSystemLoginInfo"] = this.paymentSystemLoginInfo !== undefined ? this.paymentSystemLoginInfo : <any>null;
        data["paymentSystemPasswordInfo"] = this.paymentSystemPasswordInfo !== undefined ? this.paymentSystemPasswordInfo : <any>null;
        data["telegramLink"] = this.telegramLink !== undefined ? this.telegramLink : <any>null;
        data["instagramLink"] = this.instagramLink !== undefined ? this.instagramLink : <any>null;
        data["vkLink"] = this.vkLink !== undefined ? this.vkLink : <any>null;
        data["okLink"] = this.okLink !== undefined ? this.okLink : <any>null;
        data["facebookLink"] = this.facebookLink !== undefined ? this.facebookLink : <any>null;
        data["twitterLink"] = this.twitterLink !== undefined ? this.twitterLink : <any>null;
        data["youTubeLink"] = this.youTubeLink !== undefined ? this.youTubeLink : <any>null;
        data["deliveryPageInnerHtml"] = this.deliveryPageInnerHtml !== undefined ? this.deliveryPageInnerHtml : <any>null;
        data["contactPageInnerHtml"] = this.contactPageInnerHtml !== undefined ? this.contactPageInnerHtml : <any>null;
        data["privacyPolicyPageInnerHtml"] = this.privacyPolicyPageInnerHtml !== undefined ? this.privacyPolicyPageInnerHtml : <any>null;
        data["termsOfUsePageInnerHtml"] = this.termsOfUsePageInnerHtml !== undefined ? this.termsOfUsePageInnerHtml : <any>null;
        data["aboutPageInnerHtml"] = this.aboutPageInnerHtml !== undefined ? this.aboutPageInnerHtml : <any>null;
        data["returnPageInnerHtml"] = this.returnPageInnerHtml !== undefined ? this.returnPageInnerHtml : <any>null;
        data["requisitesPageInnerHtml"] = this.requisitesPageInnerHtml !== undefined ? this.requisitesPageInnerHtml : <any>null;
        data["guaranteePageInnerHtml"] = this.guaranteePageInnerHtml !== undefined ? this.guaranteePageInnerHtml : <any>null;
        data["publicOfferPageInnerHtml"] = this.publicOfferPageInnerHtml !== undefined ? this.publicOfferPageInnerHtml : <any>null;
        data["deliveryPageRawHtml"] = this.deliveryPageRawHtml !== undefined ? this.deliveryPageRawHtml : <any>null;
        data["contactPageRawHtml"] = this.contactPageRawHtml !== undefined ? this.contactPageRawHtml : <any>null;
        data["privacyPolicyPageRawHtml"] = this.privacyPolicyPageRawHtml !== undefined ? this.privacyPolicyPageRawHtml : <any>null;
        data["termsOfUsePageRawHtml"] = this.termsOfUsePageRawHtml !== undefined ? this.termsOfUsePageRawHtml : <any>null;
        data["aboutPageRawHtml"] = this.aboutPageRawHtml !== undefined ? this.aboutPageRawHtml : <any>null;
        data["returnPageRawHtml"] = this.returnPageRawHtml !== undefined ? this.returnPageRawHtml : <any>null;
        data["requisitesPageRawHtml"] = this.requisitesPageRawHtml !== undefined ? this.requisitesPageRawHtml : <any>null;
        data["guaranteePageRawHtml"] = this.guaranteePageRawHtml !== undefined ? this.guaranteePageRawHtml : <any>null;
        data["publicOfferPageRawHtml"] = this.publicOfferPageRawHtml !== undefined ? this.publicOfferPageRawHtml : <any>null;
        data["mainColor"] = this.mainColor !== undefined ? this.mainColor : <any>null;
        data["secondColor"] = this.secondColor !== undefined ? this.secondColor : <any>null;
        data["faviconIcon"] = this.faviconIcon !== undefined ? this.faviconIcon : <any>null;
        data["bitrixWebhook"] = this.bitrixWebhook !== undefined ? this.bitrixWebhook : <any>null;
        data["categoryMetaTitlePattern"] = this.categoryMetaTitlePattern !== undefined ? this.categoryMetaTitlePattern : <any>null;
        data["categoryMetaDescriptionPattern"] = this.categoryMetaDescriptionPattern !== undefined ? this.categoryMetaDescriptionPattern : <any>null;
        data["goodMetaTitlePattern"] = this.goodMetaTitlePattern !== undefined ? this.goodMetaTitlePattern : <any>null;
        data["goodMetaDescriptionPattern"] = this.goodMetaDescriptionPattern !== undefined ? this.goodMetaDescriptionPattern : <any>null;
        data["enabledDeliveryMethods"] = this.enabledDeliveryMethods !== undefined ? this.enabledDeliveryMethods : <any>null;
        data["enabledPaymentMethods"] = this.enabledPaymentMethods !== undefined ? this.enabledPaymentMethods : <any>null;
        data["cashDisabled"] = this.cashDisabled !== undefined ? this.cashDisabled : <any>null;
        data["bankCardDisabled"] = this.bankCardDisabled !== undefined ? this.bankCardDisabled : <any>null;
        data["onlineDisabled"] = this.onlineDisabled !== undefined ? this.onlineDisabled : <any>null;
        data["legalEntityDisabled"] = this.legalEntityDisabled !== undefined ? this.legalEntityDisabled : <any>null;
        data["dynamicScripts"] = this.dynamicScripts !== undefined ? this.dynamicScripts : <any>null;
        data["mainPageSeoBlock"] = this.mainPageSeoBlock !== undefined ? this.mainPageSeoBlock : <any>null;
        data["mainUrl"] = this.mainUrl !== undefined ? this.mainUrl : <any>null;
        data["roundType"] = this.roundType !== undefined ? this.roundType : <any>null;
        data["siteConnected"] = this.siteConnected !== undefined ? this.siteConnected : <any>null;
        data["marketPlaceConnected"] = this.marketPlaceConnected !== undefined ? this.marketPlaceConnected : <any>null;
        data["nikaConnected"] = this.nikaConnected !== undefined ? this.nikaConnected : <any>null;
        data["dynamicHeadScripts"] = this.dynamicHeadScripts !== undefined ? this.dynamicHeadScripts : <any>null;
        data["inboundEmail"] = this.inboundEmail !== undefined ? this.inboundEmail : <any>null;
        data["navType"] = this.navType !== undefined ? this.navType : <any>null;
        data["claims"] = this.claims !== undefined ? this.claims : <any>null;
        data["marketPlaceInclusions"] = this.marketPlaceInclusions !== undefined ? this.marketPlaceInclusions : <any>null;
        data["calltouchAccessToken"] = this.calltouchAccessToken !== undefined ? this.calltouchAccessToken : <any>null;
        data["calltouchSiteId"] = this.calltouchSiteId !== undefined ? this.calltouchSiteId : <any>null;
        data["defaultWarehouseId"] = this.defaultWarehouseId !== undefined ? this.defaultWarehouseId : <any>null;
        data["nikaPartnerInfoId"] = this.nikaPartnerInfoId !== undefined ? this.nikaPartnerInfoId : <any>null;
        data["ozonApiKey"] = this.ozonApiKey !== undefined ? this.ozonApiKey : <any>null;
        data["ozonClientId"] = this.ozonClientId !== undefined ? this.ozonClientId : <any>null;
        data["ozonWarehouseId"] = this.ozonWarehouseId !== undefined ? this.ozonWarehouseId : <any>null;
        data["ozonIntegrationEnabled"] = this.ozonIntegrationEnabled !== undefined ? this.ozonIntegrationEnabled : <any>null;
        data["externalConstructorLink"] = this.externalConstructorLink !== undefined ? this.externalConstructorLink : <any>null;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    isActive?: boolean | null;
    login?: string | null;
    password?: string | null;
    sitePhoneNumber?: string | null;
    siteWorkSchedule?: string | null;
    siteLogo?: string | null;
    siteTitle?: string | null;
    defaultPriceUpRate?: number | null;
    rewiewsPageInnerHtml?: string | null;
    paymentSystem?: PaymentSystem;
    paymentSystemLogin?: string | null;
    paymentSystemPassword?: string | null;
    paymentSystemLoginInfo?: string | null;
    paymentSystemPasswordInfo?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    deliveryPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    deliveryPageRawHtml?: string | null;
    contactPageRawHtml?: string | null;
    privacyPolicyPageRawHtml?: string | null;
    termsOfUsePageRawHtml?: string | null;
    aboutPageRawHtml?: string | null;
    returnPageRawHtml?: string | null;
    requisitesPageRawHtml?: string | null;
    guaranteePageRawHtml?: string | null;
    publicOfferPageRawHtml?: string | null;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    bitrixWebhook?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    enabledDeliveryMethods?: string | null;
    enabledPaymentMethods?: string | null;
    cashDisabled?: boolean | null;
    bankCardDisabled?: boolean | null;
    onlineDisabled?: boolean | null;
    legalEntityDisabled?: boolean | null;
    dynamicScripts?: string | null;
    mainPageSeoBlock?: string | null;
    mainUrl?: string | null;
    roundType?: RoundType;
    siteConnected?: boolean | null;
    marketPlaceConnected?: boolean | null;
    nikaConnected?: boolean | null;
    dynamicHeadScripts?: string | null;
    inboundEmail?: string | null;
    navType?: NavigationType;
    claims?: string | null;
    marketPlaceInclusions?: string | null;
    calltouchAccessToken?: string | null;
    calltouchSiteId?: string | null;
    defaultWarehouseId?: string | null;
    nikaPartnerInfoId?: string | null;
    ozonApiKey?: string | null;
    ozonClientId?: string | null;
    ozonWarehouseId?: number | null;
    ozonIntegrationEnabled?: boolean | null;
    externalConstructorLink?: string | null;
}

export class UserInfoDto implements IUserInfoDto {
    id?: string | null;
    username?: string | null;
    email?: string | null;
    hasAccess?: boolean;
    tenantId?: string | null;
    role?: string | null;
    roles?: string[] | null;
    accessToken?: string | null;
    tenant?: TenantDto;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    deliveryAddress?: string | null;
    phoneNumber?: string | null;
    avatar?: string | null;
    readonly isSingIn?: boolean;
    errorMessage?: string | null;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.hasAccess = _data["hasAccess"] !== undefined ? _data["hasAccess"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.avatar = _data["avatar"] !== undefined ? _data["avatar"] : <any>null;
            (<any>this).isSingIn = _data["isSingIn"] !== undefined ? _data["isSingIn"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["hasAccess"] = this.hasAccess !== undefined ? this.hasAccess : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["avatar"] = this.avatar !== undefined ? this.avatar : <any>null;
        data["isSingIn"] = this.isSingIn !== undefined ? this.isSingIn : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data; 
    }

    clone(): UserInfoDto {
        const json = this.toJSON();
        let result = new UserInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserInfoDto {
    id?: string | null;
    username?: string | null;
    email?: string | null;
    hasAccess?: boolean;
    tenantId?: string | null;
    role?: string | null;
    roles?: string[] | null;
    accessToken?: string | null;
    tenant?: TenantDto;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    deliveryAddress?: string | null;
    phoneNumber?: string | null;
    avatar?: string | null;
    isSingIn?: boolean;
    errorMessage?: string | null;
}

export class CallerID implements ICallerID {
    name?: string | null;
    number?: string | null;

    constructor(data?: ICallerID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
        }
    }

    static fromJS(data: any): CallerID {
        data = typeof data === 'object' ? data : {};
        let result = new CallerID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["number"] = this.number !== undefined ? this.number : <any>null;
        return data; 
    }

    clone(): CallerID {
        const json = this.toJSON();
        let result = new CallerID();
        result.init(json);
        return result;
    }
}

export interface ICallerID {
    name?: string | null;
    number?: string | null;
}

export class DialplanCEP implements IDialplanCEP {
    context?: string | null;
    exten?: string | null;
    priority?: number;

    constructor(data?: IDialplanCEP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] !== undefined ? _data["context"] : <any>null;
            this.exten = _data["exten"] !== undefined ? _data["exten"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): DialplanCEP {
        data = typeof data === 'object' ? data : {};
        let result = new DialplanCEP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context !== undefined ? this.context : <any>null;
        data["exten"] = this.exten !== undefined ? this.exten : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): DialplanCEP {
        const json = this.toJSON();
        let result = new DialplanCEP();
        result.init(json);
        return result;
    }
}

export interface IDialplanCEP {
    context?: string | null;
    exten?: string | null;
    priority?: number;
}

export class Channel implements IChannel {
    id?: string | null;
    name?: string | null;
    state?: string | null;
    caller?: CallerID;
    connected?: CallerID;
    accountcode?: string | null;
    dialplan?: DialplanCEP;
    creationtime?: string;
    language?: string | null;

    constructor(data?: IChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.caller = _data["caller"] ? CallerID.fromJS(_data["caller"]) : <any>null;
            this.connected = _data["connected"] ? CallerID.fromJS(_data["connected"]) : <any>null;
            this.accountcode = _data["accountcode"] !== undefined ? _data["accountcode"] : <any>null;
            this.dialplan = _data["dialplan"] ? DialplanCEP.fromJS(_data["dialplan"]) : <any>null;
            this.creationtime = _data["creationtime"] !== undefined ? _data["creationtime"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): Channel {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["caller"] = this.caller ? this.caller.toJSON() : <any>null;
        data["connected"] = this.connected ? this.connected.toJSON() : <any>null;
        data["accountcode"] = this.accountcode !== undefined ? this.accountcode : <any>null;
        data["dialplan"] = this.dialplan ? this.dialplan.toJSON() : <any>null;
        data["creationtime"] = this.creationtime !== undefined ? this.creationtime : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data; 
    }

    clone(): Channel {
        const json = this.toJSON();
        let result = new Channel();
        result.init(json);
        return result;
    }
}

export interface IChannel {
    id?: string | null;
    name?: string | null;
    state?: string | null;
    caller?: CallerID;
    connected?: CallerID;
    accountcode?: string | null;
    dialplan?: DialplanCEP;
    creationtime?: string;
    language?: string | null;
}

export class CategoryDto implements ICategoryDto {
    id?: string | null;
    title?: string | null;
    created?: string | null;
    alias?: string | null;
    apiId?: number | null;
    visibleMainPage?: boolean | null;
    hasAttr?: boolean | null;
    parentCategoryId?: string | null;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.visibleMainPage = _data["visibleMainPage"] !== undefined ? _data["visibleMainPage"] : <any>null;
            this.hasAttr = _data["hasAttr"] !== undefined ? _data["hasAttr"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["visibleMainPage"] = this.visibleMainPage !== undefined ? this.visibleMainPage : <any>null;
        data["hasAttr"] = this.hasAttr !== undefined ? this.hasAttr : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        return data; 
    }

    clone(): CategoryDto {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDto {
    id?: string | null;
    title?: string | null;
    created?: string | null;
    alias?: string | null;
    apiId?: number | null;
    visibleMainPage?: boolean | null;
    hasAttr?: boolean | null;
    parentCategoryId?: string | null;
}

export class Category implements ICategory {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    alias?: string | null;
    apiId?: number;
    xmlId?: string | null;
    parentCategoryId?: string | null;
    isArchived?: boolean;
    isBase?: boolean;
    ymlId?: number;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.ymlId = _data["ymlId"] !== undefined ? _data["ymlId"] : <any>null;
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["ymlId"] = this.ymlId !== undefined ? this.ymlId : <any>null;
        return data; 
    }

    clone(): Category {
        const json = this.toJSON();
        let result = new Category();
        result.init(json);
        return result;
    }
}

export interface ICategory {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    alias?: string | null;
    apiId?: number;
    xmlId?: string | null;
    parentCategoryId?: string | null;
    isArchived?: boolean;
    isBase?: boolean;
    ymlId?: number;
}

export class CategoryAttributeDto implements ICategoryAttributeDto {
    id?: string | null;
    categoryId?: string | null;
    parentCategoryId?: string | null;
    displayTitle?: string | null;
    visibleMainPage?: boolean | null;
    hideInCatalog?: boolean | null;
    priority?: number | null;

    constructor(data?: ICategoryAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.visibleMainPage = _data["visibleMainPage"] !== undefined ? _data["visibleMainPage"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["visibleMainPage"] = this.visibleMainPage !== undefined ? this.visibleMainPage : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): CategoryAttributeDto {
        const json = this.toJSON();
        let result = new CategoryAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryAttributeDto {
    id?: string | null;
    categoryId?: string | null;
    parentCategoryId?: string | null;
    displayTitle?: string | null;
    visibleMainPage?: boolean | null;
    hideInCatalog?: boolean | null;
    priority?: number | null;
}

export class CategoryTenantAttribute implements ICategoryTenantAttribute {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    categoryId?: string | null;
    parentCategoryId?: string | null;
    displayTitle?: string | null;
    visibleMainPage?: boolean;
    hideInCatalog?: boolean;
    priority?: number;

    constructor(data?: ICategoryTenantAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.visibleMainPage = _data["visibleMainPage"] !== undefined ? _data["visibleMainPage"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryTenantAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTenantAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["visibleMainPage"] = this.visibleMainPage !== undefined ? this.visibleMainPage : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): CategoryTenantAttribute {
        const json = this.toJSON();
        let result = new CategoryTenantAttribute();
        result.init(json);
        return result;
    }
}

export interface ICategoryTenantAttribute {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    categoryId?: string | null;
    parentCategoryId?: string | null;
    displayTitle?: string | null;
    visibleMainPage?: boolean;
    hideInCatalog?: boolean;
    priority?: number;
}

export class CityDto implements ICityDto {
    id?: string | null;
    title?: string | null;
    created?: string | null;
    host?: string | null;
    cityDeliveryCost?: number | null;
    address?: string | null;
    transportDeliveryCost?: number | null;
    phoneNumber?: string | null;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.host = _data["host"] !== undefined ? _data["host"] : <any>null;
            this.cityDeliveryCost = _data["cityDeliveryCost"] !== undefined ? _data["cityDeliveryCost"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.transportDeliveryCost = _data["transportDeliveryCost"] !== undefined ? _data["transportDeliveryCost"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["host"] = this.host !== undefined ? this.host : <any>null;
        data["cityDeliveryCost"] = this.cityDeliveryCost !== undefined ? this.cityDeliveryCost : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["transportDeliveryCost"] = this.transportDeliveryCost !== undefined ? this.transportDeliveryCost : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data; 
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    id?: string | null;
    title?: string | null;
    created?: string | null;
    host?: string | null;
    cityDeliveryCost?: number | null;
    address?: string | null;
    transportDeliveryCost?: number | null;
    phoneNumber?: string | null;
}

export class City implements ICity {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    apiId?: string | null;
    isArchived?: boolean;

    constructor(data?: ICity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
        }
    }

    static fromJS(data: any): City {
        data = typeof data === 'object' ? data : {};
        let result = new City();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        return data; 
    }

    clone(): City {
        const json = this.toJSON();
        let result = new City();
        result.init(json);
        return result;
    }
}

export interface ICity {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    apiId?: string | null;
    isArchived?: boolean;
}

export class CityDistanceController_PassModel implements ICityDistanceController_PassModel {
    origins?: string[] | null;

    constructor(data?: ICityDistanceController_PassModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["origins"])) {
                this.origins = [] as any;
                for (let item of _data["origins"])
                    this.origins!.push(item);
            }
            else {
                this.origins = <any>null;
            }
        }
    }

    static fromJS(data: any): CityDistanceController_PassModel {
        data = typeof data === 'object' ? data : {};
        let result = new CityDistanceController_PassModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.origins)) {
            data["origins"] = [];
            for (let item of this.origins)
                data["origins"].push(item);
        }
        return data; 
    }

    clone(): CityDistanceController_PassModel {
        const json = this.toJSON();
        let result = new CityDistanceController_PassModel();
        result.init(json);
        return result;
    }
}

export interface ICityDistanceController_PassModel {
    origins?: string[] | null;
}

export class ContactDto implements IContactDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    email?: string | null;
    userId?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data; 
    }

    clone(): ContactDto {
        const json = this.toJSON();
        let result = new ContactDto();
        result.init(json);
        return result;
    }
}

export interface IContactDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    email?: string | null;
    userId?: string | null;
    phoneNumber?: string | null;
}

export class Contact implements IContact {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    userId?: string | null;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    userId?: string | null;
}

export class DeliveryCityDto implements IDeliveryCityDto {
    created?: string | null;
    id?: string | null;
    title?: string | null;

    constructor(data?: IDeliveryCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): DeliveryCityDto {
        const json = this.toJSON();
        let result = new DeliveryCityDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryCityDto {
    created?: string | null;
    id?: string | null;
    title?: string | null;
}

export class DeliveryCity implements IDeliveryCity {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;

    constructor(data?: IDeliveryCity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryCity {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): DeliveryCity {
        const json = this.toJSON();
        let result = new DeliveryCity();
        result.init(json);
        return result;
    }
}

export interface IDeliveryCity {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
}

export class DeliveryRegionDto implements IDeliveryRegionDto {
    created?: string | null;
    id?: string | null;
    title?: string | null;

    constructor(data?: IDeliveryRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): DeliveryRegionDto {
        const json = this.toJSON();
        let result = new DeliveryRegionDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryRegionDto {
    created?: string | null;
    id?: string | null;
    title?: string | null;
}

export class DeliveryRegion implements IDeliveryRegion {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;

    constructor(data?: IDeliveryRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryRegion {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): DeliveryRegion {
        const json = this.toJSON();
        let result = new DeliveryRegion();
        result.init(json);
        return result;
    }
}

export interface IDeliveryRegion {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
}

export class DesignProjectDto implements IDesignProjectDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    kitchenModel?: string | null;
    kitchenType?: string | null;
    sizeA?: string | null;
    sizeB?: string | null;
    sizeC?: string | null;
    applianceInfo?: string | null;
    additionalInfo?: string | null;
    responsibleId?: string | null;
    cityId?: string | null;
    inProgress?: boolean | null;
    calltouchSessionId?: string | null;

    constructor(data?: IDesignProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.kitchenModel = _data["kitchenModel"] !== undefined ? _data["kitchenModel"] : <any>null;
            this.kitchenType = _data["kitchenType"] !== undefined ? _data["kitchenType"] : <any>null;
            this.sizeA = _data["sizeA"] !== undefined ? _data["sizeA"] : <any>null;
            this.sizeB = _data["sizeB"] !== undefined ? _data["sizeB"] : <any>null;
            this.sizeC = _data["sizeC"] !== undefined ? _data["sizeC"] : <any>null;
            this.applianceInfo = _data["applianceInfo"] !== undefined ? _data["applianceInfo"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : <any>null;
            this.calltouchSessionId = _data["calltouchSessionId"] !== undefined ? _data["calltouchSessionId"] : <any>null;
        }
    }

    static fromJS(data: any): DesignProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["kitchenModel"] = this.kitchenModel !== undefined ? this.kitchenModel : <any>null;
        data["kitchenType"] = this.kitchenType !== undefined ? this.kitchenType : <any>null;
        data["sizeA"] = this.sizeA !== undefined ? this.sizeA : <any>null;
        data["sizeB"] = this.sizeB !== undefined ? this.sizeB : <any>null;
        data["sizeC"] = this.sizeC !== undefined ? this.sizeC : <any>null;
        data["applianceInfo"] = this.applianceInfo !== undefined ? this.applianceInfo : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : <any>null;
        data["calltouchSessionId"] = this.calltouchSessionId !== undefined ? this.calltouchSessionId : <any>null;
        return data; 
    }

    clone(): DesignProjectDto {
        const json = this.toJSON();
        let result = new DesignProjectDto();
        result.init(json);
        return result;
    }
}

export interface IDesignProjectDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    kitchenModel?: string | null;
    kitchenType?: string | null;
    sizeA?: string | null;
    sizeB?: string | null;
    sizeC?: string | null;
    applianceInfo?: string | null;
    additionalInfo?: string | null;
    responsibleId?: string | null;
    cityId?: string | null;
    inProgress?: boolean | null;
    calltouchSessionId?: string | null;
}

export class DesignProject implements IDesignProject {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    kitchenModel?: string | null;
    kitchenType?: string | null;
    sizeA?: string | null;
    sizeB?: string | null;
    sizeC?: string | null;
    applianceInfo?: string | null;
    additionalInfo?: string | null;
    responsibleId?: string | null;
    cityId?: string | null;
    inProgress?: boolean;

    constructor(data?: IDesignProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.kitchenModel = _data["kitchenModel"] !== undefined ? _data["kitchenModel"] : <any>null;
            this.kitchenType = _data["kitchenType"] !== undefined ? _data["kitchenType"] : <any>null;
            this.sizeA = _data["sizeA"] !== undefined ? _data["sizeA"] : <any>null;
            this.sizeB = _data["sizeB"] !== undefined ? _data["sizeB"] : <any>null;
            this.sizeC = _data["sizeC"] !== undefined ? _data["sizeC"] : <any>null;
            this.applianceInfo = _data["applianceInfo"] !== undefined ? _data["applianceInfo"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : <any>null;
        }
    }

    static fromJS(data: any): DesignProject {
        data = typeof data === 'object' ? data : {};
        let result = new DesignProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["kitchenModel"] = this.kitchenModel !== undefined ? this.kitchenModel : <any>null;
        data["kitchenType"] = this.kitchenType !== undefined ? this.kitchenType : <any>null;
        data["sizeA"] = this.sizeA !== undefined ? this.sizeA : <any>null;
        data["sizeB"] = this.sizeB !== undefined ? this.sizeB : <any>null;
        data["sizeC"] = this.sizeC !== undefined ? this.sizeC : <any>null;
        data["applianceInfo"] = this.applianceInfo !== undefined ? this.applianceInfo : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : <any>null;
        return data; 
    }

    clone(): DesignProject {
        const json = this.toJSON();
        let result = new DesignProject();
        result.init(json);
        return result;
    }
}

export interface IDesignProject {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    kitchenModel?: string | null;
    kitchenType?: string | null;
    sizeA?: string | null;
    sizeB?: string | null;
    sizeC?: string | null;
    applianceInfo?: string | null;
    additionalInfo?: string | null;
    responsibleId?: string | null;
    cityId?: string | null;
    inProgress?: boolean;
}

export class ExcelColumnDto implements IExcelColumnDto {
    index?: number;
    title?: string | null;
    checked?: boolean;

    constructor(data?: IExcelColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.checked = _data["checked"] !== undefined ? _data["checked"] : <any>null;
        }
    }

    static fromJS(data: any): ExcelColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["checked"] = this.checked !== undefined ? this.checked : <any>null;
        return data; 
    }

    clone(): ExcelColumnDto {
        const json = this.toJSON();
        let result = new ExcelColumnDto();
        result.init(json);
        return result;
    }
}

export interface IExcelColumnDto {
    index?: number;
    title?: string | null;
    checked?: boolean;
}

export class HtmlResponse implements IHtmlResponse {
    htmlContent?: string | null;
    rawText?: string | null;

    constructor(data?: IHtmlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.htmlContent = _data["htmlContent"] !== undefined ? _data["htmlContent"] : <any>null;
            this.rawText = _data["rawText"] !== undefined ? _data["rawText"] : <any>null;
        }
    }

    static fromJS(data: any): HtmlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlContent"] = this.htmlContent !== undefined ? this.htmlContent : <any>null;
        data["rawText"] = this.rawText !== undefined ? this.rawText : <any>null;
        return data; 
    }

    clone(): HtmlResponse {
        const json = this.toJSON();
        let result = new HtmlResponse();
        result.init(json);
        return result;
    }
}

export interface IHtmlResponse {
    htmlContent?: string | null;
    rawText?: string | null;
}

export class GoodPriceDto implements IGoodPriceDto {
    id?: string | null;
    xmlId?: string | null;
    price?: number;
    title?: string | null;

    constructor(data?: IGoodPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): GoodPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): GoodPriceDto {
        const json = this.toJSON();
        let result = new GoodPriceDto();
        result.init(json);
        return result;
    }
}

export interface IGoodPriceDto {
    id?: string | null;
    xmlId?: string | null;
    price?: number;
    title?: string | null;
}

export class OrderItem1CDto implements IOrderItem1CDto {
    id?: string | null;
    price?: number | null;
    title?: string | null;
    count?: number;
    xmlId?: string | null;

    constructor(data?: IOrderItem1CDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
        }
    }

    static fromJS(data: any): OrderItem1CDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem1CDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        return data; 
    }

    clone(): OrderItem1CDto {
        const json = this.toJSON();
        let result = new OrderItem1CDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItem1CDto {
    id?: string | null;
    price?: number | null;
    title?: string | null;
    count?: number;
    xmlId?: string | null;
}

export enum PaymentMethod {
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export enum DeliveryMethod {
    _100 = 100,
    _200 = 200,
}

export class Order1CDto implements IOrder1CDto {
    id?: string;
    isPaid?: boolean;
    city?: string | null;
    cost?: number;
    clientFullName?: string | null;
    orderNumber?: number;
    items?: OrderItem1CDto[] | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    additionalInfo?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    fullAddress?: string | null;
    userId?: string | null;
    created?: string | null;
    modified?: string | null;
    deliveryCost?: number;
    shippingDate?: string | null;
    sourceId?: string | null;
    sourceTitle?: string | null;

    constructor(data?: IOrder1CDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isPaid = _data["isPaid"] !== undefined ? _data["isPaid"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.clientFullName = _data["clientFullName"] !== undefined ? _data["clientFullName"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItem1CDto.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.paymentMethodTitle = _data["paymentMethodTitle"] !== undefined ? _data["paymentMethodTitle"] : <any>null;
            this.deliveryMethod = _data["deliveryMethod"] !== undefined ? _data["deliveryMethod"] : <any>null;
            this.deliveryMethodTitle = _data["deliveryMethodTitle"] !== undefined ? _data["deliveryMethodTitle"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.deliveryCost = _data["deliveryCost"] !== undefined ? _data["deliveryCost"] : <any>null;
            this.shippingDate = _data["shippingDate"] !== undefined ? _data["shippingDate"] : <any>null;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : <any>null;
            this.sourceTitle = _data["sourceTitle"] !== undefined ? _data["sourceTitle"] : <any>null;
        }
    }

    static fromJS(data: any): Order1CDto {
        data = typeof data === 'object' ? data : {};
        let result = new Order1CDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isPaid"] = this.isPaid !== undefined ? this.isPaid : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["clientFullName"] = this.clientFullName !== undefined ? this.clientFullName : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["paymentMethodTitle"] = this.paymentMethodTitle !== undefined ? this.paymentMethodTitle : <any>null;
        data["deliveryMethod"] = this.deliveryMethod !== undefined ? this.deliveryMethod : <any>null;
        data["deliveryMethodTitle"] = this.deliveryMethodTitle !== undefined ? this.deliveryMethodTitle : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["deliveryCost"] = this.deliveryCost !== undefined ? this.deliveryCost : <any>null;
        data["shippingDate"] = this.shippingDate !== undefined ? this.shippingDate : <any>null;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        data["sourceTitle"] = this.sourceTitle !== undefined ? this.sourceTitle : <any>null;
        return data; 
    }

    clone(): Order1CDto {
        const json = this.toJSON();
        let result = new Order1CDto();
        result.init(json);
        return result;
    }
}

export interface IOrder1CDto {
    id?: string;
    isPaid?: boolean;
    city?: string | null;
    cost?: number;
    clientFullName?: string | null;
    orderNumber?: number;
    items?: OrderItem1CDto[] | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    additionalInfo?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    fullAddress?: string | null;
    userId?: string | null;
    created?: string | null;
    modified?: string | null;
    deliveryCost?: number;
    shippingDate?: string | null;
    sourceId?: string | null;
    sourceTitle?: string | null;
}

export class PostOrder1CDto implements IPostOrder1CDto {
    id?: string;
    percentagePayment?: number | null;
    invoiceNumber?: string | null;
    invoiceUrl?: string | null;
    isFinished?: boolean;

    constructor(data?: IPostOrder1CDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.percentagePayment = _data["percentagePayment"] !== undefined ? _data["percentagePayment"] : <any>null;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : <any>null;
            this.invoiceUrl = _data["invoiceUrl"] !== undefined ? _data["invoiceUrl"] : <any>null;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : <any>null;
        }
    }

    static fromJS(data: any): PostOrder1CDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostOrder1CDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["percentagePayment"] = this.percentagePayment !== undefined ? this.percentagePayment : <any>null;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : <any>null;
        data["invoiceUrl"] = this.invoiceUrl !== undefined ? this.invoiceUrl : <any>null;
        data["isFinished"] = this.isFinished !== undefined ? this.isFinished : <any>null;
        return data; 
    }

    clone(): PostOrder1CDto {
        const json = this.toJSON();
        let result = new PostOrder1CDto();
        result.init(json);
        return result;
    }
}

export interface IPostOrder1CDto {
    id?: string;
    percentagePayment?: number | null;
    invoiceNumber?: string | null;
    invoiceUrl?: string | null;
    isFinished?: boolean;
}

export class RestItem implements IRestItem {
    city?: string | null;
    warehouseAddress?: string | null;
    shopName?: string | null;
    amount?: number;
    longitude?: number;
    latitude?: number;
    videoUrl?: string | null;
    imagesUrls?: string | null;
    imagesUrlList?: string[] | null;
    isNear?: boolean;
    goodTitle?: string | null;
    tenantId?: string;
    warehouseId?: string;

    constructor(data?: IRestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.warehouseAddress = _data["warehouseAddress"] !== undefined ? _data["warehouseAddress"] : <any>null;
            this.shopName = _data["shopName"] !== undefined ? _data["shopName"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.videoUrl = _data["videoUrl"] !== undefined ? _data["videoUrl"] : <any>null;
            this.imagesUrls = _data["imagesUrls"] !== undefined ? _data["imagesUrls"] : <any>null;
            if (Array.isArray(_data["imagesUrlList"])) {
                this.imagesUrlList = [] as any;
                for (let item of _data["imagesUrlList"])
                    this.imagesUrlList!.push(item);
            }
            else {
                this.imagesUrlList = <any>null;
            }
            this.isNear = _data["isNear"] !== undefined ? _data["isNear"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
        }
    }

    static fromJS(data: any): RestItem {
        data = typeof data === 'object' ? data : {};
        let result = new RestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["warehouseAddress"] = this.warehouseAddress !== undefined ? this.warehouseAddress : <any>null;
        data["shopName"] = this.shopName !== undefined ? this.shopName : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["videoUrl"] = this.videoUrl !== undefined ? this.videoUrl : <any>null;
        data["imagesUrls"] = this.imagesUrls !== undefined ? this.imagesUrls : <any>null;
        if (Array.isArray(this.imagesUrlList)) {
            data["imagesUrlList"] = [];
            for (let item of this.imagesUrlList)
                data["imagesUrlList"].push(item);
        }
        data["isNear"] = this.isNear !== undefined ? this.isNear : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        return data; 
    }

    clone(): RestItem {
        const json = this.toJSON();
        let result = new RestItem();
        result.init(json);
        return result;
    }
}

export interface IRestItem {
    city?: string | null;
    warehouseAddress?: string | null;
    shopName?: string | null;
    amount?: number;
    longitude?: number;
    latitude?: number;
    videoUrl?: string | null;
    imagesUrls?: string | null;
    imagesUrlList?: string[] | null;
    isNear?: boolean;
    goodTitle?: string | null;
    tenantId?: string;
    warehouseId?: string;
}

export class RestResult implements IRestResult {
    success?: boolean;
    errorMessage?: string | null;
    items?: RestItem[] | null;

    constructor(data?: IRestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RestItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): RestResult {
        data = typeof data === 'object' ? data : {};
        let result = new RestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RestResult {
        const json = this.toJSON();
        let result = new RestResult();
        result.init(json);
        return result;
    }
}

export interface IRestResult {
    success?: boolean;
    errorMessage?: string | null;
    items?: RestItem[] | null;
}

export enum SupplierOrderStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SupplierOrder1CPositionDto implements ISupplierOrder1CPositionDto {
    price?: number | null;
    count?: number;
    xmlId?: string;

    constructor(data?: ISupplierOrder1CPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierOrder1CPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierOrder1CPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        return data; 
    }

    clone(): SupplierOrder1CPositionDto {
        const json = this.toJSON();
        let result = new SupplierOrder1CPositionDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierOrder1CPositionDto {
    price?: number | null;
    count?: number;
    xmlId?: string;
}

export class SupplierOrder1CDto implements ISupplierOrder1CDto {
    id?: string;
    created?: string | null;
    modified?: string | null;
    finalCost?: number;
    orderId?: number;
    initialOrderId?: number | null;
    orderStatus?: SupplierOrderStatus;
    comment?: string | null;
    invoiceUrl?: string | null;
    supplierComment?: string | null;
    orderNumberFrom1C?: string | null;
    isCancelled?: boolean;
    clientOrderNumber?: string | null;
    sellerINN?: string | null;
    positions?: SupplierOrder1CPositionDto[] | null;

    constructor(data?: ISupplierOrder1CDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.finalCost = _data["finalCost"] !== undefined ? _data["finalCost"] : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.initialOrderId = _data["initialOrderId"] !== undefined ? _data["initialOrderId"] : <any>null;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.invoiceUrl = _data["invoiceUrl"] !== undefined ? _data["invoiceUrl"] : <any>null;
            this.supplierComment = _data["supplierComment"] !== undefined ? _data["supplierComment"] : <any>null;
            this.orderNumberFrom1C = _data["orderNumberFrom1C"] !== undefined ? _data["orderNumberFrom1C"] : <any>null;
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : <any>null;
            this.clientOrderNumber = _data["clientOrderNumber"] !== undefined ? _data["clientOrderNumber"] : <any>null;
            this.sellerINN = _data["sellerINN"] !== undefined ? _data["sellerINN"] : <any>null;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(SupplierOrder1CPositionDto.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
        }
    }

    static fromJS(data: any): SupplierOrder1CDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierOrder1CDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["finalCost"] = this.finalCost !== undefined ? this.finalCost : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["initialOrderId"] = this.initialOrderId !== undefined ? this.initialOrderId : <any>null;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["invoiceUrl"] = this.invoiceUrl !== undefined ? this.invoiceUrl : <any>null;
        data["supplierComment"] = this.supplierComment !== undefined ? this.supplierComment : <any>null;
        data["orderNumberFrom1C"] = this.orderNumberFrom1C !== undefined ? this.orderNumberFrom1C : <any>null;
        data["isCancelled"] = this.isCancelled !== undefined ? this.isCancelled : <any>null;
        data["clientOrderNumber"] = this.clientOrderNumber !== undefined ? this.clientOrderNumber : <any>null;
        data["sellerINN"] = this.sellerINN !== undefined ? this.sellerINN : <any>null;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SupplierOrder1CDto {
        const json = this.toJSON();
        let result = new SupplierOrder1CDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierOrder1CDto {
    id?: string;
    created?: string | null;
    modified?: string | null;
    finalCost?: number;
    orderId?: number;
    initialOrderId?: number | null;
    orderStatus?: SupplierOrderStatus;
    comment?: string | null;
    invoiceUrl?: string | null;
    supplierComment?: string | null;
    orderNumberFrom1C?: string | null;
    isCancelled?: boolean;
    clientOrderNumber?: string | null;
    sellerINN?: string | null;
    positions?: SupplierOrder1CPositionDto[] | null;
}

export class PostSupplierOrder1CDto implements IPostSupplierOrder1CDto {
    id?: string;
    orderNumberFrom1C?: string | null;

    constructor(data?: IPostSupplierOrder1CDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumberFrom1C = _data["orderNumberFrom1C"] !== undefined ? _data["orderNumberFrom1C"] : <any>null;
        }
    }

    static fromJS(data: any): PostSupplierOrder1CDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostSupplierOrder1CDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumberFrom1C"] = this.orderNumberFrom1C !== undefined ? this.orderNumberFrom1C : <any>null;
        return data; 
    }

    clone(): PostSupplierOrder1CDto {
        const json = this.toJSON();
        let result = new PostSupplierOrder1CDto();
        result.init(json);
        return result;
    }
}

export interface IPostSupplierOrder1CDto {
    id?: string;
    orderNumberFrom1C?: string | null;
}

export class ExportFile implements IExportFile {
    publicUrl?: string | null;
    fileId?: number;

    constructor(data?: IExportFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
        }
    }

    static fromJS(data: any): ExportFile {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        return data; 
    }

    clone(): ExportFile {
        const json = this.toJSON();
        let result = new ExportFile();
        result.init(json);
        return result;
    }
}

export interface IExportFile {
    publicUrl?: string | null;
    fileId?: number;
}

export enum CdnSource {
    _100 = 100,
    _200 = 200,
}

export class NewFileParameters implements INewFileParameters {
    name?: string | null;
    extension!: string;
    content!: string;

    constructor(data?: INewFileParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
        }
    }

    static fromJS(data: any): NewFileParameters {
        data = typeof data === 'object' ? data : {};
        let result = new NewFileParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["extension"] = this.extension !== undefined ? this.extension : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        return data; 
    }

    clone(): NewFileParameters {
        const json = this.toJSON();
        let result = new NewFileParameters();
        result.init(json);
        return result;
    }
}

export interface INewFileParameters {
    name?: string | null;
    extension: string;
    content: string;
}

export class ExportDetailedFile implements IExportDetailedFile {
    publicUrl?: string | null;
    fileId?: number;
    mimeType?: string | null;
    size?: number;

    constructor(data?: IExportDetailedFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : <any>null;
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
        }
    }

    static fromJS(data: any): ExportDetailedFile {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDetailedFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : <any>null;
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        return data; 
    }

    clone(): ExportDetailedFile {
        const json = this.toJSON();
        let result = new ExportDetailedFile();
        result.init(json);
        return result;
    }
}

export interface IExportDetailedFile {
    publicUrl?: string | null;
    fileId?: number;
    mimeType?: string | null;
    size?: number;
}

export class GeneralOptionDto implements IGeneralOptionDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    value?: string | null;

    constructor(data?: IGeneralOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): GeneralOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data; 
    }

    clone(): GeneralOptionDto {
        const json = this.toJSON();
        let result = new GeneralOptionDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralOptionDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    value?: string | null;
}

export class GoodSetSelectionTypeDto implements IGoodSetSelectionTypeDto {
    goodIds?: string[] | null;
    selectionTypeId?: string | null;

    constructor(data?: IGoodSetSelectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
            this.selectionTypeId = _data["selectionTypeId"] !== undefined ? _data["selectionTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): GoodSetSelectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodSetSelectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        data["selectionTypeId"] = this.selectionTypeId !== undefined ? this.selectionTypeId : <any>null;
        return data; 
    }

    clone(): GoodSetSelectionTypeDto {
        const json = this.toJSON();
        let result = new GoodSetSelectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface IGoodSetSelectionTypeDto {
    goodIds?: string[] | null;
    selectionTypeId?: string | null;
}

export class GoodDto implements IGoodDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;
    alias?: string | null;
    manufacturerId?: string | null;
    categoryId?: string | null;
    previewImage?: string | null;
    price?: number;
    displayPrice?: number | null;
    finalPrice?: number | null;
    saleRate?: number | null;
    saleEndDateTime?: string | null;
    priority?: number | null;
    displayTitle?: string | null;
    lastPriceUpRate?: number | null;
    colorGroup?: string | null;
    width?: number | null;
    height?: number | null;
    depth?: number | null;
    weight?: number | null;
    capacity?: number | null;
    material?: string | null;
    color?: string | null;
    hideInCatalog?: boolean | null;
    isPriceFixed?: boolean | null;
    nomenclatureStatus?: string | null;
    features?: string | null;
    isBase?: boolean | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;
    defaultWarehouseRestAmount?: number | null;

    constructor(data?: IGoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.displayPrice = _data["displayPrice"] !== undefined ? _data["displayPrice"] : <any>null;
            this.finalPrice = _data["finalPrice"] !== undefined ? _data["finalPrice"] : <any>null;
            this.saleRate = _data["saleRate"] !== undefined ? _data["saleRate"] : <any>null;
            this.saleEndDateTime = _data["saleEndDateTime"] !== undefined ? _data["saleEndDateTime"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.lastPriceUpRate = _data["lastPriceUpRate"] !== undefined ? _data["lastPriceUpRate"] : <any>null;
            this.colorGroup = _data["colorGroup"] !== undefined ? _data["colorGroup"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.isPriceFixed = _data["isPriceFixed"] !== undefined ? _data["isPriceFixed"] : <any>null;
            this.nomenclatureStatus = _data["nomenclatureStatus"] !== undefined ? _data["nomenclatureStatus"] : <any>null;
            this.features = _data["features"] !== undefined ? _data["features"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.exhibitionImages = _data["exhibitionImages"] !== undefined ? _data["exhibitionImages"] : <any>null;
            this.marketPlaceInclusions = _data["marketPlaceInclusions"] !== undefined ? _data["marketPlaceInclusions"] : <any>null;
            this.defaultWarehouseRestAmount = _data["defaultWarehouseRestAmount"] !== undefined ? _data["defaultWarehouseRestAmount"] : <any>null;
        }
    }

    static fromJS(data: any): GoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["displayPrice"] = this.displayPrice !== undefined ? this.displayPrice : <any>null;
        data["finalPrice"] = this.finalPrice !== undefined ? this.finalPrice : <any>null;
        data["saleRate"] = this.saleRate !== undefined ? this.saleRate : <any>null;
        data["saleEndDateTime"] = this.saleEndDateTime !== undefined ? this.saleEndDateTime : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["lastPriceUpRate"] = this.lastPriceUpRate !== undefined ? this.lastPriceUpRate : <any>null;
        data["colorGroup"] = this.colorGroup !== undefined ? this.colorGroup : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["isPriceFixed"] = this.isPriceFixed !== undefined ? this.isPriceFixed : <any>null;
        data["nomenclatureStatus"] = this.nomenclatureStatus !== undefined ? this.nomenclatureStatus : <any>null;
        data["features"] = this.features !== undefined ? this.features : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["exhibitionImages"] = this.exhibitionImages !== undefined ? this.exhibitionImages : <any>null;
        data["marketPlaceInclusions"] = this.marketPlaceInclusions !== undefined ? this.marketPlaceInclusions : <any>null;
        data["defaultWarehouseRestAmount"] = this.defaultWarehouseRestAmount !== undefined ? this.defaultWarehouseRestAmount : <any>null;
        return data; 
    }

    clone(): GoodDto {
        const json = this.toJSON();
        let result = new GoodDto();
        result.init(json);
        return result;
    }
}

export interface IGoodDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;
    alias?: string | null;
    manufacturerId?: string | null;
    categoryId?: string | null;
    previewImage?: string | null;
    price?: number;
    displayPrice?: number | null;
    finalPrice?: number | null;
    saleRate?: number | null;
    saleEndDateTime?: string | null;
    priority?: number | null;
    displayTitle?: string | null;
    lastPriceUpRate?: number | null;
    colorGroup?: string | null;
    width?: number | null;
    height?: number | null;
    depth?: number | null;
    weight?: number | null;
    capacity?: number | null;
    material?: string | null;
    color?: string | null;
    hideInCatalog?: boolean | null;
    isPriceFixed?: boolean | null;
    nomenclatureStatus?: string | null;
    features?: string | null;
    isBase?: boolean | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;
    defaultWarehouseRestAmount?: number | null;
}

export class Manufacturer implements IManufacturer {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    xmlId?: string | null;

    constructor(data?: IManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
        }
    }

    static fromJS(data: any): Manufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new Manufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        return data; 
    }

    clone(): Manufacturer {
        const json = this.toJSON();
        let result = new Manufacturer();
        result.init(json);
        return result;
    }
}

export interface IManufacturer {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    xmlId?: string | null;
}

export class Good implements IGood {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number;
    apiUpdatedAt?: string;
    category?: Category;
    manufacturerId?: string | null;
    manufacturer?: Manufacturer;
    categoryId?: string | null;
    previewImage?: string | null;
    detailImage?: string | null;
    moduleGroup?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    isArchived?: boolean;
    hideInCatalog?: boolean;
    width?: number;
    height?: number;
    depth?: number;
    material?: string | null;
    features?: string | null;
    color?: string | null;
    weight?: number;
    capacity?: number;
    excelAlias?: string | null;
    priority?: number;
    isBase?: boolean;
    hasStructure?: boolean;
    properties?: string | null;
    nomenclatureStatus?: string | null;
    code?: string | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;

    constructor(data?: IGood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.apiUpdatedAt = _data["apiUpdatedAt"] !== undefined ? _data["apiUpdatedAt"] : <any>null;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.manufacturer = _data["manufacturer"] ? Manufacturer.fromJS(_data["manufacturer"]) : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.detailImage = _data["detailImage"] !== undefined ? _data["detailImage"] : <any>null;
            this.moduleGroup = _data["moduleGroup"] !== undefined ? _data["moduleGroup"] : <any>null;
            this.colorGroup = _data["colorGroup"] !== undefined ? _data["colorGroup"] : <any>null;
            this.sizeGroup = _data["sizeGroup"] !== undefined ? _data["sizeGroup"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.additionalGoods = _data["additionalGoods"] !== undefined ? _data["additionalGoods"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.features = _data["features"] !== undefined ? _data["features"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.excelAlias = _data["excelAlias"] !== undefined ? _data["excelAlias"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.hasStructure = _data["hasStructure"] !== undefined ? _data["hasStructure"] : <any>null;
            this.properties = _data["properties"] !== undefined ? _data["properties"] : <any>null;
            this.nomenclatureStatus = _data["nomenclatureStatus"] !== undefined ? _data["nomenclatureStatus"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.exhibitionImages = _data["exhibitionImages"] !== undefined ? _data["exhibitionImages"] : <any>null;
            this.marketPlaceInclusions = _data["marketPlaceInclusions"] !== undefined ? _data["marketPlaceInclusions"] : <any>null;
        }
    }

    static fromJS(data: any): Good {
        data = typeof data === 'object' ? data : {};
        let result = new Good();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["apiUpdatedAt"] = this.apiUpdatedAt !== undefined ? this.apiUpdatedAt : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["detailImage"] = this.detailImage !== undefined ? this.detailImage : <any>null;
        data["moduleGroup"] = this.moduleGroup !== undefined ? this.moduleGroup : <any>null;
        data["colorGroup"] = this.colorGroup !== undefined ? this.colorGroup : <any>null;
        data["sizeGroup"] = this.sizeGroup !== undefined ? this.sizeGroup : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["additionalGoods"] = this.additionalGoods !== undefined ? this.additionalGoods : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["features"] = this.features !== undefined ? this.features : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["excelAlias"] = this.excelAlias !== undefined ? this.excelAlias : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["hasStructure"] = this.hasStructure !== undefined ? this.hasStructure : <any>null;
        data["properties"] = this.properties !== undefined ? this.properties : <any>null;
        data["nomenclatureStatus"] = this.nomenclatureStatus !== undefined ? this.nomenclatureStatus : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["exhibitionImages"] = this.exhibitionImages !== undefined ? this.exhibitionImages : <any>null;
        data["marketPlaceInclusions"] = this.marketPlaceInclusions !== undefined ? this.marketPlaceInclusions : <any>null;
        return data; 
    }

    clone(): Good {
        const json = this.toJSON();
        let result = new Good();
        result.init(json);
        return result;
    }
}

export interface IGood {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number;
    apiUpdatedAt?: string;
    category?: Category;
    manufacturerId?: string | null;
    manufacturer?: Manufacturer;
    categoryId?: string | null;
    previewImage?: string | null;
    detailImage?: string | null;
    moduleGroup?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    isArchived?: boolean;
    hideInCatalog?: boolean;
    width?: number;
    height?: number;
    depth?: number;
    material?: string | null;
    features?: string | null;
    color?: string | null;
    weight?: number;
    capacity?: number;
    excelAlias?: string | null;
    priority?: number;
    isBase?: boolean;
    hasStructure?: boolean;
    properties?: string | null;
    nomenclatureStatus?: string | null;
    code?: string | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;
}

export class GoodSelectionDto implements IGoodSelectionDto {
    id?: string | null;
    selectionTypeId?: string | null;
    goodId?: string | null;
    nomenclatureStatus?: string | null;
    priority?: number | null;

    constructor(data?: IGoodSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.selectionTypeId = _data["selectionTypeId"] !== undefined ? _data["selectionTypeId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.nomenclatureStatus = _data["nomenclatureStatus"] !== undefined ? _data["nomenclatureStatus"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): GoodSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["selectionTypeId"] = this.selectionTypeId !== undefined ? this.selectionTypeId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["nomenclatureStatus"] = this.nomenclatureStatus !== undefined ? this.nomenclatureStatus : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): GoodSelectionDto {
        const json = this.toJSON();
        let result = new GoodSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IGoodSelectionDto {
    id?: string | null;
    selectionTypeId?: string | null;
    goodId?: string | null;
    nomenclatureStatus?: string | null;
    priority?: number | null;
}

export class GoodTenantSelection implements IGoodTenantSelection {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    selectionTypeId?: string | null;
    goodId?: string | null;
    priority?: number;

    constructor(data?: IGoodTenantSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.selectionTypeId = _data["selectionTypeId"] !== undefined ? _data["selectionTypeId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): GoodTenantSelection {
        data = typeof data === 'object' ? data : {};
        let result = new GoodTenantSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["selectionTypeId"] = this.selectionTypeId !== undefined ? this.selectionTypeId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): GoodTenantSelection {
        const json = this.toJSON();
        let result = new GoodTenantSelection();
        result.init(json);
        return result;
    }
}

export interface IGoodTenantSelection {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    selectionTypeId?: string | null;
    goodId?: string | null;
    priority?: number;
}

export class CommonInfoDto implements ICommonInfoDto {
    userCount?: number;
    orderCount?: number;
    requestCount?: number;
    goodCount?: number;
    goodSaleCount?: number;
    hitCount?: number;
    bestPriceCount?: number;

    constructor(data?: ICommonInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCount = _data["userCount"] !== undefined ? _data["userCount"] : <any>null;
            this.orderCount = _data["orderCount"] !== undefined ? _data["orderCount"] : <any>null;
            this.requestCount = _data["requestCount"] !== undefined ? _data["requestCount"] : <any>null;
            this.goodCount = _data["goodCount"] !== undefined ? _data["goodCount"] : <any>null;
            this.goodSaleCount = _data["goodSaleCount"] !== undefined ? _data["goodSaleCount"] : <any>null;
            this.hitCount = _data["hitCount"] !== undefined ? _data["hitCount"] : <any>null;
            this.bestPriceCount = _data["bestPriceCount"] !== undefined ? _data["bestPriceCount"] : <any>null;
        }
    }

    static fromJS(data: any): CommonInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommonInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCount"] = this.userCount !== undefined ? this.userCount : <any>null;
        data["orderCount"] = this.orderCount !== undefined ? this.orderCount : <any>null;
        data["requestCount"] = this.requestCount !== undefined ? this.requestCount : <any>null;
        data["goodCount"] = this.goodCount !== undefined ? this.goodCount : <any>null;
        data["goodSaleCount"] = this.goodSaleCount !== undefined ? this.goodSaleCount : <any>null;
        data["hitCount"] = this.hitCount !== undefined ? this.hitCount : <any>null;
        data["bestPriceCount"] = this.bestPriceCount !== undefined ? this.bestPriceCount : <any>null;
        return data; 
    }

    clone(): CommonInfoDto {
        const json = this.toJSON();
        let result = new CommonInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICommonInfoDto {
    userCount?: number;
    orderCount?: number;
    requestCount?: number;
    goodCount?: number;
    goodSaleCount?: number;
    hitCount?: number;
    bestPriceCount?: number;
}

export enum HomeInfoController_StatisticDateType {
    _100 = 100,
    _200 = 200,
    _300 = 300,
}

export class DoughnutItem implements IDoughnutItem {
    title?: string | null;
    val?: number;

    constructor(data?: IDoughnutItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.val = _data["val"] !== undefined ? _data["val"] : <any>null;
        }
    }

    static fromJS(data: any): DoughnutItem {
        data = typeof data === 'object' ? data : {};
        let result = new DoughnutItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["val"] = this.val !== undefined ? this.val : <any>null;
        return data; 
    }

    clone(): DoughnutItem {
        const json = this.toJSON();
        let result = new DoughnutItem();
        result.init(json);
        return result;
    }
}

export interface IDoughnutItem {
    title?: string | null;
    val?: number;
}

export class OrderStatisticModel implements IOrderStatisticModel {
    items?: DoughnutItem[] | null;
    totalCount?: number;

    constructor(data?: IOrderStatisticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DoughnutItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderStatisticModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatisticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OrderStatisticModel {
        const json = this.toJSON();
        let result = new OrderStatisticModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStatisticModel {
    items?: DoughnutItem[] | null;
    totalCount?: number;
}

export class PolarChartItem implements IPolarChartItem {
    arg?: string | null;
    count?: number;
    val?: number;

    constructor(data?: IPolarChartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arg = _data["arg"] !== undefined ? _data["arg"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.val = _data["val"] !== undefined ? _data["val"] : <any>null;
        }
    }

    static fromJS(data: any): PolarChartItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolarChartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arg"] = this.arg !== undefined ? this.arg : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["val"] = this.val !== undefined ? this.val : <any>null;
        return data; 
    }

    clone(): PolarChartItem {
        const json = this.toJSON();
        let result = new PolarChartItem();
        result.init(json);
        return result;
    }
}

export interface IPolarChartItem {
    arg?: string | null;
    count?: number;
    val?: number;
}

export class CategoryStatisticModel implements ICategoryStatisticModel {
    items?: PolarChartItem[] | null;
    totalCount?: number;

    constructor(data?: ICategoryStatisticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolarChartItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryStatisticModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryStatisticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): CategoryStatisticModel {
        const json = this.toJSON();
        let result = new CategoryStatisticModel();
        result.init(json);
        return result;
    }
}

export interface ICategoryStatisticModel {
    items?: PolarChartItem[] | null;
    totalCount?: number;
}

export class LineChartStatisticModelItem implements ILineChartStatisticModelItem {
    argument?: string | null;
    value?: number;

    constructor(data?: ILineChartStatisticModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argument = _data["argument"] !== undefined ? _data["argument"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): LineChartStatisticModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new LineChartStatisticModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argument"] = this.argument !== undefined ? this.argument : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data; 
    }

    clone(): LineChartStatisticModelItem {
        const json = this.toJSON();
        let result = new LineChartStatisticModelItem();
        result.init(json);
        return result;
    }
}

export interface ILineChartStatisticModelItem {
    argument?: string | null;
    value?: number;
}

export class LineChartStatisticModel implements ILineChartStatisticModel {
    items?: LineChartStatisticModelItem[] | null;
    title?: string | null;

    constructor(data?: ILineChartStatisticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LineChartStatisticModelItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): LineChartStatisticModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineChartStatisticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): LineChartStatisticModel {
        const json = this.toJSON();
        let result = new LineChartStatisticModel();
        result.init(json);
        return result;
    }
}

export interface ILineChartStatisticModel {
    items?: LineChartStatisticModelItem[] | null;
    title?: string | null;
}

export class PyramidChartStatisticModelItem implements IPyramidChartStatisticModelItem {
    argument?: string | null;
    value?: number;

    constructor(data?: IPyramidChartStatisticModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argument = _data["argument"] !== undefined ? _data["argument"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): PyramidChartStatisticModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new PyramidChartStatisticModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argument"] = this.argument !== undefined ? this.argument : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data; 
    }

    clone(): PyramidChartStatisticModelItem {
        const json = this.toJSON();
        let result = new PyramidChartStatisticModelItem();
        result.init(json);
        return result;
    }
}

export interface IPyramidChartStatisticModelItem {
    argument?: string | null;
    value?: number;
}

export class PyramidChartStatisticModel implements IPyramidChartStatisticModel {
    items?: PyramidChartStatisticModelItem[] | null;
    title?: string | null;

    constructor(data?: IPyramidChartStatisticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PyramidChartStatisticModelItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): PyramidChartStatisticModel {
        data = typeof data === 'object' ? data : {};
        let result = new PyramidChartStatisticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): PyramidChartStatisticModel {
        const json = this.toJSON();
        let result = new PyramidChartStatisticModel();
        result.init(json);
        return result;
    }
}

export interface IPyramidChartStatisticModel {
    items?: PyramidChartStatisticModelItem[] | null;
    title?: string | null;
}

export class ImportResponseModel implements IImportResponseModel {
    success?: boolean;
    message?: string | null;

    constructor(data?: IImportResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ImportResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data; 
    }

    clone(): ImportResponseModel {
        const json = this.toJSON();
        let result = new ImportResponseModel();
        result.init(json);
        return result;
    }
}

export interface IImportResponseModel {
    success?: boolean;
    message?: string | null;
}

export class BaseInfo implements IBaseInfo {
    importType?: string | null;
    date?: string;
    isActive?: boolean;

    constructor(data?: IBaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importType = _data["importType"] !== undefined ? _data["importType"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): BaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importType"] = this.importType !== undefined ? this.importType : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data; 
    }

    clone(): BaseInfo {
        const json = this.toJSON();
        let result = new BaseInfo();
        result.init(json);
        return result;
    }
}

export interface IBaseInfo {
    importType?: string | null;
    date?: string;
    isActive?: boolean;
}

export class ImportStatusResponseModel implements IImportStatusResponseModel {
    categoryInfo?: BaseInfo;
    goodInfo?: BaseInfo;
    priceInfo?: BaseInfo;
    restInfo?: BaseInfo;
    mpGoodInfo?: BaseInfo;

    constructor(data?: IImportStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryInfo = _data["categoryInfo"] ? BaseInfo.fromJS(_data["categoryInfo"]) : <any>null;
            this.goodInfo = _data["goodInfo"] ? BaseInfo.fromJS(_data["goodInfo"]) : <any>null;
            this.priceInfo = _data["priceInfo"] ? BaseInfo.fromJS(_data["priceInfo"]) : <any>null;
            this.restInfo = _data["restInfo"] ? BaseInfo.fromJS(_data["restInfo"]) : <any>null;
            this.mpGoodInfo = _data["mpGoodInfo"] ? BaseInfo.fromJS(_data["mpGoodInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): ImportStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryInfo"] = this.categoryInfo ? this.categoryInfo.toJSON() : <any>null;
        data["goodInfo"] = this.goodInfo ? this.goodInfo.toJSON() : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["restInfo"] = this.restInfo ? this.restInfo.toJSON() : <any>null;
        data["mpGoodInfo"] = this.mpGoodInfo ? this.mpGoodInfo.toJSON() : <any>null;
        return data; 
    }

    clone(): ImportStatusResponseModel {
        const json = this.toJSON();
        let result = new ImportStatusResponseModel();
        result.init(json);
        return result;
    }
}

export interface IImportStatusResponseModel {
    categoryInfo?: BaseInfo;
    goodInfo?: BaseInfo;
    priceInfo?: BaseInfo;
    restInfo?: BaseInfo;
    mpGoodInfo?: BaseInfo;
}

export enum KanbanType {
    _100 = 100,
    _200 = 200,
}

export class TenantKanbanStageDto implements ITenantKanbanStageDto {
    id?: string | null;
    code?: string | null;
    title?: string | null;
    orderIndex?: number | null;
    eventCodes?: string | null;
    color?: string | null;
    kanbanType?: KanbanType;

    constructor(data?: ITenantKanbanStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.eventCodes = _data["eventCodes"] !== undefined ? _data["eventCodes"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.kanbanType = _data["kanbanType"] !== undefined ? _data["kanbanType"] : <any>null;
        }
    }

    static fromJS(data: any): TenantKanbanStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantKanbanStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["eventCodes"] = this.eventCodes !== undefined ? this.eventCodes : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["kanbanType"] = this.kanbanType !== undefined ? this.kanbanType : <any>null;
        return data; 
    }

    clone(): TenantKanbanStageDto {
        const json = this.toJSON();
        let result = new TenantKanbanStageDto();
        result.init(json);
        return result;
    }
}

export interface ITenantKanbanStageDto {
    id?: string | null;
    code?: string | null;
    title?: string | null;
    orderIndex?: number | null;
    eventCodes?: string | null;
    color?: string | null;
    kanbanType?: KanbanType;
}

export enum KanbanItemColorEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class KanbanCard implements IKanbanCard {
    id?: string;
    title?: string | null;
    created?: string;
    description?: string | null;
    priority?: number;
    stageId?: string | null;
    userId?: string;
    userName?: string | null;
    entityId?: string;
    finalCost?: number;
    responsibleId?: string | null;
    kanbanItemColorEnum?: KanbanItemColorEnum;
    readonly color?: string | null;

    constructor(data?: IKanbanCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.stageId = _data["stageId"] !== undefined ? _data["stageId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.finalCost = _data["finalCost"] !== undefined ? _data["finalCost"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.kanbanItemColorEnum = _data["kanbanItemColorEnum"] !== undefined ? _data["kanbanItemColorEnum"] : <any>null;
            (<any>this).color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): KanbanCard {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["stageId"] = this.stageId !== undefined ? this.stageId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["finalCost"] = this.finalCost !== undefined ? this.finalCost : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["kanbanItemColorEnum"] = this.kanbanItemColorEnum !== undefined ? this.kanbanItemColorEnum : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        return data; 
    }

    clone(): KanbanCard {
        const json = this.toJSON();
        let result = new KanbanCard();
        result.init(json);
        return result;
    }
}

export interface IKanbanCard {
    id?: string;
    title?: string | null;
    created?: string;
    description?: string | null;
    priority?: number;
    stageId?: string | null;
    userId?: string;
    userName?: string | null;
    entityId?: string;
    finalCost?: number;
    responsibleId?: string | null;
    kanbanItemColorEnum?: KanbanItemColorEnum;
    color?: string | null;
}

export class KanbanStageItem implements IKanbanStageItem {
    id?: string;
    code?: string | null;
    title?: string | null;
    color?: string | null;
    finalCost?: string | null;
    items?: KanbanCard[] | null;

    constructor(data?: IKanbanStageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.finalCost = _data["finalCost"] !== undefined ? _data["finalCost"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KanbanCard.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): KanbanStageItem {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanStageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["finalCost"] = this.finalCost !== undefined ? this.finalCost : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): KanbanStageItem {
        const json = this.toJSON();
        let result = new KanbanStageItem();
        result.init(json);
        return result;
    }
}

export interface IKanbanStageItem {
    id?: string;
    code?: string | null;
    title?: string | null;
    color?: string | null;
    finalCost?: string | null;
    items?: KanbanCard[] | null;
}

export enum LogInfoType {
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export class LogInfoDto implements ILogInfoDto {
    id?: string;
    message?: string | null;
    type?: LogInfoType;
    typeTitle?: string | null;
    data?: string | null;
    tenantId?: string | null;
    tenantTitle?: string | null;
    created?: string;

    constructor(data?: ILogInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.typeTitle = _data["typeTitle"] !== undefined ? _data["typeTitle"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantTitle = _data["tenantTitle"] !== undefined ? _data["tenantTitle"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
        }
    }

    static fromJS(data: any): LogInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["typeTitle"] = this.typeTitle !== undefined ? this.typeTitle : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantTitle"] = this.tenantTitle !== undefined ? this.tenantTitle : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        return data; 
    }

    clone(): LogInfoDto {
        const json = this.toJSON();
        let result = new LogInfoDto();
        result.init(json);
        return result;
    }
}

export interface ILogInfoDto {
    id?: string;
    message?: string | null;
    type?: LogInfoType;
    typeTitle?: string | null;
    data?: string | null;
    tenantId?: string | null;
    tenantTitle?: string | null;
    created?: string;
}

export class RegisterResponse implements IRegisterResponse {
    success?: boolean;
    errorMessage?: string | null;
    user?: UserInfoDto;

    constructor(data?: IRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.user = _data["user"] ? UserInfoDto.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): RegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): RegisterResponse {
        const json = this.toJSON();
        let result = new RegisterResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterResponse {
    success?: boolean;
    errorMessage?: string | null;
    user?: UserInfoDto;
}

export class UserProfileVM implements IUserProfileVM {
    username?: string | null;
    email?: string | null;
    fullName?: string | null;
    deliveryAddress?: string | null;
    phoneNumber?: string | null;
    password?: string | null;
    confirmPassword?: string | null;

    constructor(data?: IUserProfileVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): UserProfileVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        return data; 
    }

    clone(): UserProfileVM {
        const json = this.toJSON();
        let result = new UserProfileVM();
        result.init(json);
        return result;
    }
}

export interface IUserProfileVM {
    username?: string | null;
    email?: string | null;
    fullName?: string | null;
    deliveryAddress?: string | null;
    phoneNumber?: string | null;
    password?: string | null;
    confirmPassword?: string | null;
}

export class CartItemVM implements ICartItemVM {
    id?: string;
    count?: number;
    price?: number;

    constructor(data?: ICartItemVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): CartItemVM {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data; 
    }

    clone(): CartItemVM {
        const json = this.toJSON();
        let result = new CartItemVM();
        result.init(json);
        return result;
    }
}

export interface ICartItemVM {
    id?: string;
    count?: number;
    price?: number;
}

export class GoodPreviewCardVM implements IGoodPreviewCardVM {
    id?: string;
    alias?: string | null;
    previewImage?: string | null;
    title?: string | null;
    price?: number;
    oldPrice?: number;
    priceEquality?: boolean;
    categoryAlias?: string | null;
    hideInCatalog?: boolean;
    priority?: number;
    count?: number;
    manufacturerId?: string | null;
    depth?: number;
    width?: number;
    height?: number;
    material?: string | null;

    constructor(data?: IGoodPreviewCardVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.oldPrice = _data["oldPrice"] !== undefined ? _data["oldPrice"] : <any>null;
            this.priceEquality = _data["priceEquality"] !== undefined ? _data["priceEquality"] : <any>null;
            this.categoryAlias = _data["categoryAlias"] !== undefined ? _data["categoryAlias"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
        }
    }

    static fromJS(data: any): GoodPreviewCardVM {
        data = typeof data === 'object' ? data : {};
        let result = new GoodPreviewCardVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["oldPrice"] = this.oldPrice !== undefined ? this.oldPrice : <any>null;
        data["priceEquality"] = this.priceEquality !== undefined ? this.priceEquality : <any>null;
        data["categoryAlias"] = this.categoryAlias !== undefined ? this.categoryAlias : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        return data; 
    }

    clone(): GoodPreviewCardVM {
        const json = this.toJSON();
        let result = new GoodPreviewCardVM();
        result.init(json);
        return result;
    }
}

export interface IGoodPreviewCardVM {
    id?: string;
    alias?: string | null;
    previewImage?: string | null;
    title?: string | null;
    price?: number;
    oldPrice?: number;
    priceEquality?: boolean;
    categoryAlias?: string | null;
    hideInCatalog?: boolean;
    priority?: number;
    count?: number;
    manufacturerId?: string | null;
    depth?: number;
    width?: number;
    height?: number;
    material?: string | null;
}

export class CartGoodPreviewCardVM implements ICartGoodPreviewCardVM {
    count?: number;
    good?: GoodPreviewCardVM;

    constructor(data?: ICartGoodPreviewCardVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.good = _data["good"] ? GoodPreviewCardVM.fromJS(_data["good"]) : <any>null;
        }
    }

    static fromJS(data: any): CartGoodPreviewCardVM {
        data = typeof data === 'object' ? data : {};
        let result = new CartGoodPreviewCardVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["good"] = this.good ? this.good.toJSON() : <any>null;
        return data; 
    }

    clone(): CartGoodPreviewCardVM {
        const json = this.toJSON();
        let result = new CartGoodPreviewCardVM();
        result.init(json);
        return result;
    }
}

export interface ICartGoodPreviewCardVM {
    count?: number;
    good?: GoodPreviewCardVM;
}

export class CatalogFiltersVM implements ICatalogFiltersVM {
    manufacturers?: Manufacturer[] | null;
    materials?: string[] | null;
    minWidth?: number;
    maxWidth?: number;
    minHeight?: number;
    maxHeight?: number;
    minDepth?: number;
    maxDepth?: number;
    minPrice?: number;
    maxPrice?: number;
    filtersNeeded?: boolean;

    constructor(data?: ICatalogFiltersVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(Manufacturer.fromJS(item));
            }
            else {
                this.manufacturers = <any>null;
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(item);
            }
            else {
                this.materials = <any>null;
            }
            this.minWidth = _data["minWidth"] !== undefined ? _data["minWidth"] : <any>null;
            this.maxWidth = _data["maxWidth"] !== undefined ? _data["maxWidth"] : <any>null;
            this.minHeight = _data["minHeight"] !== undefined ? _data["minHeight"] : <any>null;
            this.maxHeight = _data["maxHeight"] !== undefined ? _data["maxHeight"] : <any>null;
            this.minDepth = _data["minDepth"] !== undefined ? _data["minDepth"] : <any>null;
            this.maxDepth = _data["maxDepth"] !== undefined ? _data["maxDepth"] : <any>null;
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : <any>null;
            this.maxPrice = _data["maxPrice"] !== undefined ? _data["maxPrice"] : <any>null;
            this.filtersNeeded = _data["filtersNeeded"] !== undefined ? _data["filtersNeeded"] : <any>null;
        }
    }

    static fromJS(data: any): CatalogFiltersVM {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogFiltersVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item);
        }
        data["minWidth"] = this.minWidth !== undefined ? this.minWidth : <any>null;
        data["maxWidth"] = this.maxWidth !== undefined ? this.maxWidth : <any>null;
        data["minHeight"] = this.minHeight !== undefined ? this.minHeight : <any>null;
        data["maxHeight"] = this.maxHeight !== undefined ? this.maxHeight : <any>null;
        data["minDepth"] = this.minDepth !== undefined ? this.minDepth : <any>null;
        data["maxDepth"] = this.maxDepth !== undefined ? this.maxDepth : <any>null;
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : <any>null;
        data["maxPrice"] = this.maxPrice !== undefined ? this.maxPrice : <any>null;
        data["filtersNeeded"] = this.filtersNeeded !== undefined ? this.filtersNeeded : <any>null;
        return data; 
    }

    clone(): CatalogFiltersVM {
        const json = this.toJSON();
        let result = new CatalogFiltersVM();
        result.init(json);
        return result;
    }
}

export interface ICatalogFiltersVM {
    manufacturers?: Manufacturer[] | null;
    materials?: string[] | null;
    minWidth?: number;
    maxWidth?: number;
    minHeight?: number;
    maxHeight?: number;
    minDepth?: number;
    maxDepth?: number;
    minPrice?: number;
    maxPrice?: number;
    filtersNeeded?: boolean;
}

export class CategoryItemVM implements ICategoryItemVM {
    id?: string | null;
    alias?: string | null;
    title?: string | null;
    image?: string | null;
    count?: number;
    parentId?: string | null;
    childs?: CategoryItemVM[] | null;
    priority?: number;
    isSelectionType?: boolean;
    visibleMainPage?: boolean;
    ymlId?: number;

    constructor(data?: ICategoryItemVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs!.push(CategoryItemVM.fromJS(item));
            }
            else {
                this.childs = <any>null;
            }
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.isSelectionType = _data["isSelectionType"] !== undefined ? _data["isSelectionType"] : <any>null;
            this.visibleMainPage = _data["visibleMainPage"] !== undefined ? _data["visibleMainPage"] : <any>null;
            this.ymlId = _data["ymlId"] !== undefined ? _data["ymlId"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryItemVM {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryItemVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["isSelectionType"] = this.isSelectionType !== undefined ? this.isSelectionType : <any>null;
        data["visibleMainPage"] = this.visibleMainPage !== undefined ? this.visibleMainPage : <any>null;
        data["ymlId"] = this.ymlId !== undefined ? this.ymlId : <any>null;
        return data; 
    }

    clone(): CategoryItemVM {
        const json = this.toJSON();
        let result = new CategoryItemVM();
        result.init(json);
        return result;
    }
}

export interface ICategoryItemVM {
    id?: string | null;
    alias?: string | null;
    title?: string | null;
    image?: string | null;
    count?: number;
    parentId?: string | null;
    childs?: CategoryItemVM[] | null;
    priority?: number;
    isSelectionType?: boolean;
    visibleMainPage?: boolean;
    ymlId?: number;
}

export class GetCategoriesResponse implements IGetCategoriesResponse {
    categories?: CategoryItemVM[] | null;
    categoriesList?: CategoryItemVM[] | null;

    constructor(data?: IGetCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryItemVM.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["categoriesList"])) {
                this.categoriesList = [] as any;
                for (let item of _data["categoriesList"])
                    this.categoriesList!.push(CategoryItemVM.fromJS(item));
            }
            else {
                this.categoriesList = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.categoriesList)) {
            data["categoriesList"] = [];
            for (let item of this.categoriesList)
                data["categoriesList"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCategoriesResponse {
        const json = this.toJSON();
        let result = new GetCategoriesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCategoriesResponse {
    categories?: CategoryItemVM[] | null;
    categoriesList?: CategoryItemVM[] | null;
}

export class FilterModelVM implements IFilterModelVM {
    page?: number;
    take?: number;
    sortType?: string | null;
    searchQuery?: string | null;
    selectionType?: string | null;
    categoryItemVm?: CategoryItemVM;
    manufacturersIds?: string[] | null;
    advancedFilters?: CatalogFiltersVM;

    constructor(data?: IFilterModelVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.take = _data["take"] !== undefined ? _data["take"] : <any>null;
            this.sortType = _data["sortType"] !== undefined ? _data["sortType"] : <any>null;
            this.searchQuery = _data["searchQuery"] !== undefined ? _data["searchQuery"] : <any>null;
            this.selectionType = _data["selectionType"] !== undefined ? _data["selectionType"] : <any>null;
            this.categoryItemVm = _data["categoryItemVm"] ? CategoryItemVM.fromJS(_data["categoryItemVm"]) : <any>null;
            if (Array.isArray(_data["manufacturersIds"])) {
                this.manufacturersIds = [] as any;
                for (let item of _data["manufacturersIds"])
                    this.manufacturersIds!.push(item);
            }
            else {
                this.manufacturersIds = <any>null;
            }
            this.advancedFilters = _data["advancedFilters"] ? CatalogFiltersVM.fromJS(_data["advancedFilters"]) : <any>null;
        }
    }

    static fromJS(data: any): FilterModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new FilterModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["take"] = this.take !== undefined ? this.take : <any>null;
        data["sortType"] = this.sortType !== undefined ? this.sortType : <any>null;
        data["searchQuery"] = this.searchQuery !== undefined ? this.searchQuery : <any>null;
        data["selectionType"] = this.selectionType !== undefined ? this.selectionType : <any>null;
        data["categoryItemVm"] = this.categoryItemVm ? this.categoryItemVm.toJSON() : <any>null;
        if (Array.isArray(this.manufacturersIds)) {
            data["manufacturersIds"] = [];
            for (let item of this.manufacturersIds)
                data["manufacturersIds"].push(item);
        }
        data["advancedFilters"] = this.advancedFilters ? this.advancedFilters.toJSON() : <any>null;
        return data; 
    }

    clone(): FilterModelVM {
        const json = this.toJSON();
        let result = new FilterModelVM();
        result.init(json);
        return result;
    }
}

export interface IFilterModelVM {
    page?: number;
    take?: number;
    sortType?: string | null;
    searchQuery?: string | null;
    selectionType?: string | null;
    categoryItemVm?: CategoryItemVM;
    manufacturersIds?: string[] | null;
    advancedFilters?: CatalogFiltersVM;
}

export class CatalogResultVM implements ICatalogResultVM {
    goods?: GoodPreviewCardVM[] | null;
    currentPage?: number;
    pageCount?: number;
    filterModel?: CatalogFiltersVM;

    constructor(data?: ICatalogResultVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goods"])) {
                this.goods = [] as any;
                for (let item of _data["goods"])
                    this.goods!.push(GoodPreviewCardVM.fromJS(item));
            }
            else {
                this.goods = <any>null;
            }
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : <any>null;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : <any>null;
            this.filterModel = _data["filterModel"] ? CatalogFiltersVM.fromJS(_data["filterModel"]) : <any>null;
        }
    }

    static fromJS(data: any): CatalogResultVM {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogResultVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goods)) {
            data["goods"] = [];
            for (let item of this.goods)
                data["goods"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : <any>null;
        data["filterModel"] = this.filterModel ? this.filterModel.toJSON() : <any>null;
        return data; 
    }

    clone(): CatalogResultVM {
        const json = this.toJSON();
        let result = new CatalogResultVM();
        result.init(json);
        return result;
    }
}

export interface ICatalogResultVM {
    goods?: GoodPreviewCardVM[] | null;
    currentPage?: number;
    pageCount?: number;
    filterModel?: CatalogFiltersVM;
}

export class GoodSizeVM implements IGoodSizeVM {
    width?: number;
    height?: number;
    depth?: number;

    constructor(data?: IGoodSizeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
        }
    }

    static fromJS(data: any): GoodSizeVM {
        data = typeof data === 'object' ? data : {};
        let result = new GoodSizeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        return data; 
    }

    clone(): GoodSizeVM {
        const json = this.toJSON();
        let result = new GoodSizeVM();
        result.init(json);
        return result;
    }
}

export interface IGoodSizeVM {
    width?: number;
    height?: number;
    depth?: number;
}

export class SimilarGoodUrlModel implements ISimilarGoodUrlModel {
    categoryAlias?: string | null;
    alias?: string | null;
    title?: string | null;

    constructor(data?: ISimilarGoodUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryAlias = _data["categoryAlias"] !== undefined ? _data["categoryAlias"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): SimilarGoodUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimilarGoodUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryAlias"] = this.categoryAlias !== undefined ? this.categoryAlias : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): SimilarGoodUrlModel {
        const json = this.toJSON();
        let result = new SimilarGoodUrlModel();
        result.init(json);
        return result;
    }
}

export interface ISimilarGoodUrlModel {
    categoryAlias?: string | null;
    alias?: string | null;
    title?: string | null;
}

export class GoodPropertyViewModelVM implements IGoodPropertyViewModelVM {
    title?: string | null;
    value?: string | null;

    constructor(data?: IGoodPropertyViewModelVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): GoodPropertyViewModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new GoodPropertyViewModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data; 
    }

    clone(): GoodPropertyViewModelVM {
        const json = this.toJSON();
        let result = new GoodPropertyViewModelVM();
        result.init(json);
        return result;
    }
}

export interface IGoodPropertyViewModelVM {
    title?: string | null;
    value?: string | null;
}

export class GoodCardVM implements IGoodCardVM {
    id?: string;
    alias?: string | null;
    previewImage?: string | null;
    title?: string | null;
    price?: number;
    oldPrice?: number;
    priceEquality?: boolean;
    categoryAlias?: string | null;
    hideInCatalog?: boolean;
    priority?: number;
    count?: number;
    manufacturerId?: string | null;
    depth?: number;
    width?: number;
    height?: number;
    category?: string | null;
    images?: string[] | null;
    exhibitionImages?: string[] | null;
    isKitchen?: boolean;
    manufacturer?: string | null;
    material?: string | null;
    features?: string | null;
    propertiesString?: string | null;
    composition?: string | null;
    color?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    size?: GoodSizeVM;
    parentGoods?: SimilarGoodUrlModel[] | null;
    similarColorGoods?: SimilarGoodUrlModel[] | null;
    similarSizeGoods?: SimilarGoodUrlModel[] | null;
    properties?: GoodPropertyViewModelVM[] | null;
    isBase?: boolean;
    restCount?: number | null;

    constructor(data?: IGoodCardVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.oldPrice = _data["oldPrice"] !== undefined ? _data["oldPrice"] : <any>null;
            this.priceEquality = _data["priceEquality"] !== undefined ? _data["priceEquality"] : <any>null;
            this.categoryAlias = _data["categoryAlias"] !== undefined ? _data["categoryAlias"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            else {
                this.images = <any>null;
            }
            if (Array.isArray(_data["exhibitionImages"])) {
                this.exhibitionImages = [] as any;
                for (let item of _data["exhibitionImages"])
                    this.exhibitionImages!.push(item);
            }
            else {
                this.exhibitionImages = <any>null;
            }
            this.isKitchen = _data["isKitchen"] !== undefined ? _data["isKitchen"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.features = _data["features"] !== undefined ? _data["features"] : <any>null;
            this.propertiesString = _data["propertiesString"] !== undefined ? _data["propertiesString"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.colorGroup = _data["colorGroup"] !== undefined ? _data["colorGroup"] : <any>null;
            this.sizeGroup = _data["sizeGroup"] !== undefined ? _data["sizeGroup"] : <any>null;
            this.size = _data["size"] ? GoodSizeVM.fromJS(_data["size"]) : <any>null;
            if (Array.isArray(_data["parentGoods"])) {
                this.parentGoods = [] as any;
                for (let item of _data["parentGoods"])
                    this.parentGoods!.push(SimilarGoodUrlModel.fromJS(item));
            }
            else {
                this.parentGoods = <any>null;
            }
            if (Array.isArray(_data["similarColorGoods"])) {
                this.similarColorGoods = [] as any;
                for (let item of _data["similarColorGoods"])
                    this.similarColorGoods!.push(SimilarGoodUrlModel.fromJS(item));
            }
            else {
                this.similarColorGoods = <any>null;
            }
            if (Array.isArray(_data["similarSizeGoods"])) {
                this.similarSizeGoods = [] as any;
                for (let item of _data["similarSizeGoods"])
                    this.similarSizeGoods!.push(SimilarGoodUrlModel.fromJS(item));
            }
            else {
                this.similarSizeGoods = <any>null;
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(GoodPropertyViewModelVM.fromJS(item));
            }
            else {
                this.properties = <any>null;
            }
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.restCount = _data["restCount"] !== undefined ? _data["restCount"] : <any>null;
        }
    }

    static fromJS(data: any): GoodCardVM {
        data = typeof data === 'object' ? data : {};
        let result = new GoodCardVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["oldPrice"] = this.oldPrice !== undefined ? this.oldPrice : <any>null;
        data["priceEquality"] = this.priceEquality !== undefined ? this.priceEquality : <any>null;
        data["categoryAlias"] = this.categoryAlias !== undefined ? this.categoryAlias : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.exhibitionImages)) {
            data["exhibitionImages"] = [];
            for (let item of this.exhibitionImages)
                data["exhibitionImages"].push(item);
        }
        data["isKitchen"] = this.isKitchen !== undefined ? this.isKitchen : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["features"] = this.features !== undefined ? this.features : <any>null;
        data["propertiesString"] = this.propertiesString !== undefined ? this.propertiesString : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["colorGroup"] = this.colorGroup !== undefined ? this.colorGroup : <any>null;
        data["sizeGroup"] = this.sizeGroup !== undefined ? this.sizeGroup : <any>null;
        data["size"] = this.size ? this.size.toJSON() : <any>null;
        if (Array.isArray(this.parentGoods)) {
            data["parentGoods"] = [];
            for (let item of this.parentGoods)
                data["parentGoods"].push(item.toJSON());
        }
        if (Array.isArray(this.similarColorGoods)) {
            data["similarColorGoods"] = [];
            for (let item of this.similarColorGoods)
                data["similarColorGoods"].push(item.toJSON());
        }
        if (Array.isArray(this.similarSizeGoods)) {
            data["similarSizeGoods"] = [];
            for (let item of this.similarSizeGoods)
                data["similarSizeGoods"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["restCount"] = this.restCount !== undefined ? this.restCount : <any>null;
        return data; 
    }

    clone(): GoodCardVM {
        const json = this.toJSON();
        let result = new GoodCardVM();
        result.init(json);
        return result;
    }
}

export interface IGoodCardVM {
    id?: string;
    alias?: string | null;
    previewImage?: string | null;
    title?: string | null;
    price?: number;
    oldPrice?: number;
    priceEquality?: boolean;
    categoryAlias?: string | null;
    hideInCatalog?: boolean;
    priority?: number;
    count?: number;
    manufacturerId?: string | null;
    depth?: number;
    width?: number;
    height?: number;
    category?: string | null;
    images?: string[] | null;
    exhibitionImages?: string[] | null;
    isKitchen?: boolean;
    manufacturer?: string | null;
    material?: string | null;
    features?: string | null;
    propertiesString?: string | null;
    composition?: string | null;
    color?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    size?: GoodSizeVM;
    parentGoods?: SimilarGoodUrlModel[] | null;
    similarColorGoods?: SimilarGoodUrlModel[] | null;
    similarSizeGoods?: SimilarGoodUrlModel[] | null;
    properties?: GoodPropertyViewModelVM[] | null;
    isBase?: boolean;
    restCount?: number | null;
}

export class MainSliderItemCardVM implements IMainSliderItemCardVM {
    path?: string | null;
    url?: string | null;

    constructor(data?: IMainSliderItemCardVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): MainSliderItemCardVM {
        data = typeof data === 'object' ? data : {};
        let result = new MainSliderItemCardVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data; 
    }

    clone(): MainSliderItemCardVM {
        const json = this.toJSON();
        let result = new MainSliderItemCardVM();
        result.init(json);
        return result;
    }
}

export interface IMainSliderItemCardVM {
    path?: string | null;
    url?: string | null;
}

export class NewsCardVM implements INewsCardVM {
    alias?: string | null;
    content?: string | null;
    image?: string | null;
    header?: string | null;
    published?: string | null;

    constructor(data?: INewsCardVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
        }
    }

    static fromJS(data: any): NewsCardVM {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCardVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        return data; 
    }

    clone(): NewsCardVM {
        const json = this.toJSON();
        let result = new NewsCardVM();
        result.init(json);
        return result;
    }
}

export interface INewsCardVM {
    alias?: string | null;
    content?: string | null;
    image?: string | null;
    header?: string | null;
    published?: string | null;
}

export class OrderGoodDto implements IOrderGoodDto {
    id?: string | null;
    previewImage?: string | null;
    title?: string | null;
    goodId?: string | null;
    count?: number;
    price?: number;
    xmlId?: string | null;
    hasStructure?: boolean;
    isArchived?: boolean;
    url?: string | null;
    initialPrice?: number | null;
    initialPricePriority?: boolean | null;

    constructor(data?: IOrderGoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.hasStructure = _data["hasStructure"] !== undefined ? _data["hasStructure"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.initialPrice = _data["initialPrice"] !== undefined ? _data["initialPrice"] : <any>null;
            this.initialPricePriority = _data["initialPricePriority"] !== undefined ? _data["initialPricePriority"] : <any>null;
        }
    }

    static fromJS(data: any): OrderGoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["hasStructure"] = this.hasStructure !== undefined ? this.hasStructure : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["initialPrice"] = this.initialPrice !== undefined ? this.initialPrice : <any>null;
        data["initialPricePriority"] = this.initialPricePriority !== undefined ? this.initialPricePriority : <any>null;
        return data; 
    }

    clone(): OrderGoodDto {
        const json = this.toJSON();
        let result = new OrderGoodDto();
        result.init(json);
        return result;
    }
}

export interface IOrderGoodDto {
    id?: string | null;
    previewImage?: string | null;
    title?: string | null;
    goodId?: string | null;
    count?: number;
    price?: number;
    xmlId?: string | null;
    hasStructure?: boolean;
    isArchived?: boolean;
    url?: string | null;
    initialPrice?: number | null;
    initialPricePriority?: boolean | null;
}

export class OrderItemVM implements IOrderItemVM {
    number?: string | null;
    orderNumberFrom1C?: string | null;
    date?: string;
    cost?: number;
    deliveryCost?: number;
    isPaid?: boolean;
    isAccepted?: boolean;
    id?: string;
    count?: number;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    paymentUrl?: string | null;
    composition?: string | null;
    items?: OrderGoodDto[] | null;
    invoiceUrl?: string | null;

    constructor(data?: IOrderItemVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.orderNumberFrom1C = _data["orderNumberFrom1C"] !== undefined ? _data["orderNumberFrom1C"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.deliveryCost = _data["deliveryCost"] !== undefined ? _data["deliveryCost"] : <any>null;
            this.isPaid = _data["isPaid"] !== undefined ? _data["isPaid"] : <any>null;
            this.isAccepted = _data["isAccepted"] !== undefined ? _data["isAccepted"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.deliveryMethod = _data["deliveryMethod"] !== undefined ? _data["deliveryMethod"] : <any>null;
            this.deliveryMethodTitle = _data["deliveryMethodTitle"] !== undefined ? _data["deliveryMethodTitle"] : <any>null;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.paymentMethodTitle = _data["paymentMethodTitle"] !== undefined ? _data["paymentMethodTitle"] : <any>null;
            this.paymentUrl = _data["paymentUrl"] !== undefined ? _data["paymentUrl"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderGoodDto.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.invoiceUrl = _data["invoiceUrl"] !== undefined ? _data["invoiceUrl"] : <any>null;
        }
    }

    static fromJS(data: any): OrderItemVM {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["orderNumberFrom1C"] = this.orderNumberFrom1C !== undefined ? this.orderNumberFrom1C : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["deliveryCost"] = this.deliveryCost !== undefined ? this.deliveryCost : <any>null;
        data["isPaid"] = this.isPaid !== undefined ? this.isPaid : <any>null;
        data["isAccepted"] = this.isAccepted !== undefined ? this.isAccepted : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["deliveryMethod"] = this.deliveryMethod !== undefined ? this.deliveryMethod : <any>null;
        data["deliveryMethodTitle"] = this.deliveryMethodTitle !== undefined ? this.deliveryMethodTitle : <any>null;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["paymentMethodTitle"] = this.paymentMethodTitle !== undefined ? this.paymentMethodTitle : <any>null;
        data["paymentUrl"] = this.paymentUrl !== undefined ? this.paymentUrl : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["invoiceUrl"] = this.invoiceUrl !== undefined ? this.invoiceUrl : <any>null;
        return data; 
    }

    clone(): OrderItemVM {
        const json = this.toJSON();
        let result = new OrderItemVM();
        result.init(json);
        return result;
    }
}

export interface IOrderItemVM {
    number?: string | null;
    orderNumberFrom1C?: string | null;
    date?: string;
    cost?: number;
    deliveryCost?: number;
    isPaid?: boolean;
    isAccepted?: boolean;
    id?: string;
    count?: number;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    paymentUrl?: string | null;
    composition?: string | null;
    items?: OrderGoodDto[] | null;
    invoiceUrl?: string | null;
}

export class OrderDto implements IOrderDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    fullAddress?: string | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    additionalInfo?: string | null;
    composition?: string | null;
    orderId?: string | null;
    isPaid?: boolean | null;
    city?: string | null;
    finalCost?: number | null;
    deliveryCost?: number | null;
    userId?: string | null;
    isAccepted?: boolean | null;
    isFinished?: boolean | null;
    invoiceUrl?: string | null;
    percentagePayment?: number | null;
    orderNumber?: number | null;
    invoiceNumber?: string | null;
    shippingDate?: string | null;
    responsibleId?: string | null;
    orderSourceId?: string | null;
    proxy?: boolean | null;
    fromMarketPlace?: boolean | null;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.paymentMethodTitle = _data["paymentMethodTitle"] !== undefined ? _data["paymentMethodTitle"] : <any>null;
            this.deliveryMethod = _data["deliveryMethod"] !== undefined ? _data["deliveryMethod"] : <any>null;
            this.deliveryMethodTitle = _data["deliveryMethodTitle"] !== undefined ? _data["deliveryMethodTitle"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.isPaid = _data["isPaid"] !== undefined ? _data["isPaid"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.finalCost = _data["finalCost"] !== undefined ? _data["finalCost"] : <any>null;
            this.deliveryCost = _data["deliveryCost"] !== undefined ? _data["deliveryCost"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.isAccepted = _data["isAccepted"] !== undefined ? _data["isAccepted"] : <any>null;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : <any>null;
            this.invoiceUrl = _data["invoiceUrl"] !== undefined ? _data["invoiceUrl"] : <any>null;
            this.percentagePayment = _data["percentagePayment"] !== undefined ? _data["percentagePayment"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : <any>null;
            this.shippingDate = _data["shippingDate"] !== undefined ? _data["shippingDate"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.orderSourceId = _data["orderSourceId"] !== undefined ? _data["orderSourceId"] : <any>null;
            this.proxy = _data["proxy"] !== undefined ? _data["proxy"] : <any>null;
            this.fromMarketPlace = _data["fromMarketPlace"] !== undefined ? _data["fromMarketPlace"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["paymentMethodTitle"] = this.paymentMethodTitle !== undefined ? this.paymentMethodTitle : <any>null;
        data["deliveryMethod"] = this.deliveryMethod !== undefined ? this.deliveryMethod : <any>null;
        data["deliveryMethodTitle"] = this.deliveryMethodTitle !== undefined ? this.deliveryMethodTitle : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["isPaid"] = this.isPaid !== undefined ? this.isPaid : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["finalCost"] = this.finalCost !== undefined ? this.finalCost : <any>null;
        data["deliveryCost"] = this.deliveryCost !== undefined ? this.deliveryCost : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["isAccepted"] = this.isAccepted !== undefined ? this.isAccepted : <any>null;
        data["isFinished"] = this.isFinished !== undefined ? this.isFinished : <any>null;
        data["invoiceUrl"] = this.invoiceUrl !== undefined ? this.invoiceUrl : <any>null;
        data["percentagePayment"] = this.percentagePayment !== undefined ? this.percentagePayment : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : <any>null;
        data["shippingDate"] = this.shippingDate !== undefined ? this.shippingDate : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["orderSourceId"] = this.orderSourceId !== undefined ? this.orderSourceId : <any>null;
        data["proxy"] = this.proxy !== undefined ? this.proxy : <any>null;
        data["fromMarketPlace"] = this.fromMarketPlace !== undefined ? this.fromMarketPlace : <any>null;
        return data; 
    }

    clone(): OrderDto {
        const json = this.toJSON();
        let result = new OrderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDto {
    id?: string | null;
    created?: string | null;
    fullName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    fullAddress?: string | null;
    paymentMethod?: PaymentMethod;
    paymentMethodTitle?: string | null;
    deliveryMethod?: DeliveryMethod;
    deliveryMethodTitle?: string | null;
    additionalInfo?: string | null;
    composition?: string | null;
    orderId?: string | null;
    isPaid?: boolean | null;
    city?: string | null;
    finalCost?: number | null;
    deliveryCost?: number | null;
    userId?: string | null;
    isAccepted?: boolean | null;
    isFinished?: boolean | null;
    invoiceUrl?: string | null;
    percentagePayment?: number | null;
    orderNumber?: number | null;
    invoiceNumber?: string | null;
    shippingDate?: string | null;
    responsibleId?: string | null;
    orderSourceId?: string | null;
    proxy?: boolean | null;
    fromMarketPlace?: boolean | null;
}

export class InitOrderVM implements IInitOrderVM {
    order?: OrderDto;
    cartGoodPreviewCards?: CartGoodPreviewCardVM[] | null;
    calltouchSessionId?: string | null;

    constructor(data?: IInitOrderVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : <any>null;
            if (Array.isArray(_data["cartGoodPreviewCards"])) {
                this.cartGoodPreviewCards = [] as any;
                for (let item of _data["cartGoodPreviewCards"])
                    this.cartGoodPreviewCards!.push(CartGoodPreviewCardVM.fromJS(item));
            }
            else {
                this.cartGoodPreviewCards = <any>null;
            }
            this.calltouchSessionId = _data["calltouchSessionId"] !== undefined ? _data["calltouchSessionId"] : <any>null;
        }
    }

    static fromJS(data: any): InitOrderVM {
        data = typeof data === 'object' ? data : {};
        let result = new InitOrderVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        if (Array.isArray(this.cartGoodPreviewCards)) {
            data["cartGoodPreviewCards"] = [];
            for (let item of this.cartGoodPreviewCards)
                data["cartGoodPreviewCards"].push(item.toJSON());
        }
        data["calltouchSessionId"] = this.calltouchSessionId !== undefined ? this.calltouchSessionId : <any>null;
        return data; 
    }

    clone(): InitOrderVM {
        const json = this.toJSON();
        let result = new InitOrderVM();
        result.init(json);
        return result;
    }
}

export interface IInitOrderVM {
    order?: OrderDto;
    cartGoodPreviewCards?: CartGoodPreviewCardVM[] | null;
    calltouchSessionId?: string | null;
}

export class InitOrderResponse implements IInitOrderResponse {
    success?: boolean;
    shouldLogin?: boolean;
    userExist?: boolean;
    username?: string | null;
    password?: string | null;

    constructor(data?: IInitOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.shouldLogin = _data["shouldLogin"] !== undefined ? _data["shouldLogin"] : <any>null;
            this.userExist = _data["userExist"] !== undefined ? _data["userExist"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): InitOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InitOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["shouldLogin"] = this.shouldLogin !== undefined ? this.shouldLogin : <any>null;
        data["userExist"] = this.userExist !== undefined ? this.userExist : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }

    clone(): InitOrderResponse {
        const json = this.toJSON();
        let result = new InitOrderResponse();
        result.init(json);
        return result;
    }
}

export interface IInitOrderResponse {
    success?: boolean;
    shouldLogin?: boolean;
    userExist?: boolean;
    username?: string | null;
    password?: string | null;
}

export class SeoForPageVM implements ISeoForPageVM {
    title?: string | null;
    description?: string | null;
    mainPageText?: string | null;
    categoryText?: string | null;
    canonical?: string | null;

    constructor(data?: ISeoForPageVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.mainPageText = _data["mainPageText"] !== undefined ? _data["mainPageText"] : <any>null;
            this.categoryText = _data["categoryText"] !== undefined ? _data["categoryText"] : <any>null;
            this.canonical = _data["canonical"] !== undefined ? _data["canonical"] : <any>null;
        }
    }

    static fromJS(data: any): SeoForPageVM {
        data = typeof data === 'object' ? data : {};
        let result = new SeoForPageVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["mainPageText"] = this.mainPageText !== undefined ? this.mainPageText : <any>null;
        data["categoryText"] = this.categoryText !== undefined ? this.categoryText : <any>null;
        data["canonical"] = this.canonical !== undefined ? this.canonical : <any>null;
        return data; 
    }

    clone(): SeoForPageVM {
        const json = this.toJSON();
        let result = new SeoForPageVM();
        result.init(json);
        return result;
    }
}

export interface ISeoForPageVM {
    title?: string | null;
    description?: string | null;
    mainPageText?: string | null;
    categoryText?: string | null;
    canonical?: string | null;
}

export class MainSliderItemDto implements IMainSliderItemDto {
    id?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;

    constructor(data?: IMainSliderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MainSliderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MainSliderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MainSliderItemDto {
        const json = this.toJSON();
        let result = new MainSliderItemDto();
        result.init(json);
        return result;
    }
}

export interface IMainSliderItemDto {
    id?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;
}

export class MainSliderItem implements IMainSliderItem {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;

    constructor(data?: IMainSliderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MainSliderItem {
        data = typeof data === 'object' ? data : {};
        let result = new MainSliderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MainSliderItem {
        const json = this.toJSON();
        let result = new MainSliderItem();
        result.init(json);
        return result;
    }
}

export interface IMainSliderItem {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;
}

export class TenantFullContextVM implements ITenantFullContextVM {
    deliveryPageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    rewiewsPageInnerHtml?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    cashDisabled?: boolean;
    bankCardDisabled?: boolean;
    onlineDisabled?: boolean;
    legalEntityDisabled?: boolean;

    constructor(data?: ITenantFullContextVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryPageInnerHtml = _data["deliveryPageInnerHtml"] !== undefined ? _data["deliveryPageInnerHtml"] : <any>null;
            this.aboutPageInnerHtml = _data["aboutPageInnerHtml"] !== undefined ? _data["aboutPageInnerHtml"] : <any>null;
            this.contactPageInnerHtml = _data["contactPageInnerHtml"] !== undefined ? _data["contactPageInnerHtml"] : <any>null;
            this.privacyPolicyPageInnerHtml = _data["privacyPolicyPageInnerHtml"] !== undefined ? _data["privacyPolicyPageInnerHtml"] : <any>null;
            this.termsOfUsePageInnerHtml = _data["termsOfUsePageInnerHtml"] !== undefined ? _data["termsOfUsePageInnerHtml"] : <any>null;
            this.returnPageInnerHtml = _data["returnPageInnerHtml"] !== undefined ? _data["returnPageInnerHtml"] : <any>null;
            this.requisitesPageInnerHtml = _data["requisitesPageInnerHtml"] !== undefined ? _data["requisitesPageInnerHtml"] : <any>null;
            this.guaranteePageInnerHtml = _data["guaranteePageInnerHtml"] !== undefined ? _data["guaranteePageInnerHtml"] : <any>null;
            this.publicOfferPageInnerHtml = _data["publicOfferPageInnerHtml"] !== undefined ? _data["publicOfferPageInnerHtml"] : <any>null;
            this.rewiewsPageInnerHtml = _data["rewiewsPageInnerHtml"] !== undefined ? _data["rewiewsPageInnerHtml"] : <any>null;
            this.telegramLink = _data["telegramLink"] !== undefined ? _data["telegramLink"] : <any>null;
            this.instagramLink = _data["instagramLink"] !== undefined ? _data["instagramLink"] : <any>null;
            this.vkLink = _data["vkLink"] !== undefined ? _data["vkLink"] : <any>null;
            this.okLink = _data["okLink"] !== undefined ? _data["okLink"] : <any>null;
            this.facebookLink = _data["facebookLink"] !== undefined ? _data["facebookLink"] : <any>null;
            this.twitterLink = _data["twitterLink"] !== undefined ? _data["twitterLink"] : <any>null;
            this.youTubeLink = _data["youTubeLink"] !== undefined ? _data["youTubeLink"] : <any>null;
            this.cashDisabled = _data["cashDisabled"] !== undefined ? _data["cashDisabled"] : <any>null;
            this.bankCardDisabled = _data["bankCardDisabled"] !== undefined ? _data["bankCardDisabled"] : <any>null;
            this.onlineDisabled = _data["onlineDisabled"] !== undefined ? _data["onlineDisabled"] : <any>null;
            this.legalEntityDisabled = _data["legalEntityDisabled"] !== undefined ? _data["legalEntityDisabled"] : <any>null;
        }
    }

    static fromJS(data: any): TenantFullContextVM {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFullContextVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryPageInnerHtml"] = this.deliveryPageInnerHtml !== undefined ? this.deliveryPageInnerHtml : <any>null;
        data["aboutPageInnerHtml"] = this.aboutPageInnerHtml !== undefined ? this.aboutPageInnerHtml : <any>null;
        data["contactPageInnerHtml"] = this.contactPageInnerHtml !== undefined ? this.contactPageInnerHtml : <any>null;
        data["privacyPolicyPageInnerHtml"] = this.privacyPolicyPageInnerHtml !== undefined ? this.privacyPolicyPageInnerHtml : <any>null;
        data["termsOfUsePageInnerHtml"] = this.termsOfUsePageInnerHtml !== undefined ? this.termsOfUsePageInnerHtml : <any>null;
        data["returnPageInnerHtml"] = this.returnPageInnerHtml !== undefined ? this.returnPageInnerHtml : <any>null;
        data["requisitesPageInnerHtml"] = this.requisitesPageInnerHtml !== undefined ? this.requisitesPageInnerHtml : <any>null;
        data["guaranteePageInnerHtml"] = this.guaranteePageInnerHtml !== undefined ? this.guaranteePageInnerHtml : <any>null;
        data["publicOfferPageInnerHtml"] = this.publicOfferPageInnerHtml !== undefined ? this.publicOfferPageInnerHtml : <any>null;
        data["rewiewsPageInnerHtml"] = this.rewiewsPageInnerHtml !== undefined ? this.rewiewsPageInnerHtml : <any>null;
        data["telegramLink"] = this.telegramLink !== undefined ? this.telegramLink : <any>null;
        data["instagramLink"] = this.instagramLink !== undefined ? this.instagramLink : <any>null;
        data["vkLink"] = this.vkLink !== undefined ? this.vkLink : <any>null;
        data["okLink"] = this.okLink !== undefined ? this.okLink : <any>null;
        data["facebookLink"] = this.facebookLink !== undefined ? this.facebookLink : <any>null;
        data["twitterLink"] = this.twitterLink !== undefined ? this.twitterLink : <any>null;
        data["youTubeLink"] = this.youTubeLink !== undefined ? this.youTubeLink : <any>null;
        data["cashDisabled"] = this.cashDisabled !== undefined ? this.cashDisabled : <any>null;
        data["bankCardDisabled"] = this.bankCardDisabled !== undefined ? this.bankCardDisabled : <any>null;
        data["onlineDisabled"] = this.onlineDisabled !== undefined ? this.onlineDisabled : <any>null;
        data["legalEntityDisabled"] = this.legalEntityDisabled !== undefined ? this.legalEntityDisabled : <any>null;
        return data; 
    }

    clone(): TenantFullContextVM {
        const json = this.toJSON();
        let result = new TenantFullContextVM();
        result.init(json);
        return result;
    }
}

export interface ITenantFullContextVM {
    deliveryPageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    rewiewsPageInnerHtml?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    cashDisabled?: boolean;
    bankCardDisabled?: boolean;
    onlineDisabled?: boolean;
    legalEntityDisabled?: boolean;
}

export class TenantSeoAttributeDto implements ITenantSeoAttributeDto {
    id?: string | null;
    title?: string | null;
    path?: string | null;
    metaHeader?: string | null;
    metaTitle?: string | null;
    metaDescription?: string | null;

    constructor(data?: ITenantSeoAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.metaHeader = _data["metaHeader"] !== undefined ? _data["metaHeader"] : <any>null;
            this.metaTitle = _data["metaTitle"] !== undefined ? _data["metaTitle"] : <any>null;
            this.metaDescription = _data["metaDescription"] !== undefined ? _data["metaDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TenantSeoAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSeoAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["metaHeader"] = this.metaHeader !== undefined ? this.metaHeader : <any>null;
        data["metaTitle"] = this.metaTitle !== undefined ? this.metaTitle : <any>null;
        data["metaDescription"] = this.metaDescription !== undefined ? this.metaDescription : <any>null;
        return data; 
    }

    clone(): TenantSeoAttributeDto {
        const json = this.toJSON();
        let result = new TenantSeoAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ITenantSeoAttributeDto {
    id?: string | null;
    title?: string | null;
    path?: string | null;
    metaHeader?: string | null;
    metaTitle?: string | null;
    metaDescription?: string | null;
}

export class CategoryTextVm implements ICategoryTextVm {
    categoryId?: string;
    text?: string | null;

    constructor(data?: ICategoryTextVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryTextVm {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTextVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data; 
    }

    clone(): CategoryTextVm {
        const json = this.toJSON();
        let result = new CategoryTextVm();
        result.init(json);
        return result;
    }
}

export interface ICategoryTextVm {
    categoryId?: string;
    text?: string | null;
}

export class SeoModelVM implements ISeoModelVM {
    seoAttributes?: TenantSeoAttributeDto[] | null;
    categoryTexts?: CategoryTextVm[] | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    mainPageSeoBlock?: string | null;

    constructor(data?: ISeoModelVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seoAttributes"])) {
                this.seoAttributes = [] as any;
                for (let item of _data["seoAttributes"])
                    this.seoAttributes!.push(TenantSeoAttributeDto.fromJS(item));
            }
            else {
                this.seoAttributes = <any>null;
            }
            if (Array.isArray(_data["categoryTexts"])) {
                this.categoryTexts = [] as any;
                for (let item of _data["categoryTexts"])
                    this.categoryTexts!.push(CategoryTextVm.fromJS(item));
            }
            else {
                this.categoryTexts = <any>null;
            }
            this.categoryMetaTitlePattern = _data["categoryMetaTitlePattern"] !== undefined ? _data["categoryMetaTitlePattern"] : <any>null;
            this.categoryMetaDescriptionPattern = _data["categoryMetaDescriptionPattern"] !== undefined ? _data["categoryMetaDescriptionPattern"] : <any>null;
            this.goodMetaTitlePattern = _data["goodMetaTitlePattern"] !== undefined ? _data["goodMetaTitlePattern"] : <any>null;
            this.goodMetaDescriptionPattern = _data["goodMetaDescriptionPattern"] !== undefined ? _data["goodMetaDescriptionPattern"] : <any>null;
            this.mainPageSeoBlock = _data["mainPageSeoBlock"] !== undefined ? _data["mainPageSeoBlock"] : <any>null;
        }
    }

    static fromJS(data: any): SeoModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new SeoModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seoAttributes)) {
            data["seoAttributes"] = [];
            for (let item of this.seoAttributes)
                data["seoAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryTexts)) {
            data["categoryTexts"] = [];
            for (let item of this.categoryTexts)
                data["categoryTexts"].push(item.toJSON());
        }
        data["categoryMetaTitlePattern"] = this.categoryMetaTitlePattern !== undefined ? this.categoryMetaTitlePattern : <any>null;
        data["categoryMetaDescriptionPattern"] = this.categoryMetaDescriptionPattern !== undefined ? this.categoryMetaDescriptionPattern : <any>null;
        data["goodMetaTitlePattern"] = this.goodMetaTitlePattern !== undefined ? this.goodMetaTitlePattern : <any>null;
        data["goodMetaDescriptionPattern"] = this.goodMetaDescriptionPattern !== undefined ? this.goodMetaDescriptionPattern : <any>null;
        data["mainPageSeoBlock"] = this.mainPageSeoBlock !== undefined ? this.mainPageSeoBlock : <any>null;
        return data; 
    }

    clone(): SeoModelVM {
        const json = this.toJSON();
        let result = new SeoModelVM();
        result.init(json);
        return result;
    }
}

export interface ISeoModelVM {
    seoAttributes?: TenantSeoAttributeDto[] | null;
    categoryTexts?: CategoryTextVm[] | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    mainPageSeoBlock?: string | null;
}

export class TenantInfoVM implements ITenantInfoVM {
    title?: string | null;
    phoneNumber?: string | null;
    workSchedule?: string | null;
    logo?: string | null;
    dynamicScripts?: string | null;
    dynamicHeadScripts?: string | null;
    fullContextVm?: TenantFullContextVM;
    seoModelVm?: SeoModelVM;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    externalConstructorLink?: string | null;

    constructor(data?: ITenantInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.workSchedule = _data["workSchedule"] !== undefined ? _data["workSchedule"] : <any>null;
            this.logo = _data["logo"] !== undefined ? _data["logo"] : <any>null;
            this.dynamicScripts = _data["dynamicScripts"] !== undefined ? _data["dynamicScripts"] : <any>null;
            this.dynamicHeadScripts = _data["dynamicHeadScripts"] !== undefined ? _data["dynamicHeadScripts"] : <any>null;
            this.fullContextVm = _data["fullContextVm"] ? TenantFullContextVM.fromJS(_data["fullContextVm"]) : <any>null;
            this.seoModelVm = _data["seoModelVm"] ? SeoModelVM.fromJS(_data["seoModelVm"]) : <any>null;
            this.mainColor = _data["mainColor"] !== undefined ? _data["mainColor"] : <any>null;
            this.secondColor = _data["secondColor"] !== undefined ? _data["secondColor"] : <any>null;
            this.faviconIcon = _data["faviconIcon"] !== undefined ? _data["faviconIcon"] : <any>null;
            this.externalConstructorLink = _data["externalConstructorLink"] !== undefined ? _data["externalConstructorLink"] : <any>null;
        }
    }

    static fromJS(data: any): TenantInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["workSchedule"] = this.workSchedule !== undefined ? this.workSchedule : <any>null;
        data["logo"] = this.logo !== undefined ? this.logo : <any>null;
        data["dynamicScripts"] = this.dynamicScripts !== undefined ? this.dynamicScripts : <any>null;
        data["dynamicHeadScripts"] = this.dynamicHeadScripts !== undefined ? this.dynamicHeadScripts : <any>null;
        data["fullContextVm"] = this.fullContextVm ? this.fullContextVm.toJSON() : <any>null;
        data["seoModelVm"] = this.seoModelVm ? this.seoModelVm.toJSON() : <any>null;
        data["mainColor"] = this.mainColor !== undefined ? this.mainColor : <any>null;
        data["secondColor"] = this.secondColor !== undefined ? this.secondColor : <any>null;
        data["faviconIcon"] = this.faviconIcon !== undefined ? this.faviconIcon : <any>null;
        data["externalConstructorLink"] = this.externalConstructorLink !== undefined ? this.externalConstructorLink : <any>null;
        return data; 
    }

    clone(): TenantInfoVM {
        const json = this.toJSON();
        let result = new TenantInfoVM();
        result.init(json);
        return result;
    }
}

export interface ITenantInfoVM {
    title?: string | null;
    phoneNumber?: string | null;
    workSchedule?: string | null;
    logo?: string | null;
    dynamicScripts?: string | null;
    dynamicHeadScripts?: string | null;
    fullContextVm?: TenantFullContextVM;
    seoModelVm?: SeoModelVM;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    externalConstructorLink?: string | null;
}

export class TenantCityVM implements ITenantCityVM {
    cityId?: string;
    title?: string | null;
    host?: string | null;
    redirectUrl?: string | null;
    cityDeliveryCost?: number;
    transportDeliveryCost?: number;
    address?: string | null;

    constructor(data?: ITenantCityVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.host = _data["host"] !== undefined ? _data["host"] : <any>null;
            this.redirectUrl = _data["redirectUrl"] !== undefined ? _data["redirectUrl"] : <any>null;
            this.cityDeliveryCost = _data["cityDeliveryCost"] !== undefined ? _data["cityDeliveryCost"] : <any>null;
            this.transportDeliveryCost = _data["transportDeliveryCost"] !== undefined ? _data["transportDeliveryCost"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): TenantCityVM {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCityVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["host"] = this.host !== undefined ? this.host : <any>null;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : <any>null;
        data["cityDeliveryCost"] = this.cityDeliveryCost !== undefined ? this.cityDeliveryCost : <any>null;
        data["transportDeliveryCost"] = this.transportDeliveryCost !== undefined ? this.transportDeliveryCost : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        return data; 
    }

    clone(): TenantCityVM {
        const json = this.toJSON();
        let result = new TenantCityVM();
        result.init(json);
        return result;
    }
}

export interface ITenantCityVM {
    cityId?: string;
    title?: string | null;
    host?: string | null;
    redirectUrl?: string | null;
    cityDeliveryCost?: number;
    transportDeliveryCost?: number;
    address?: string | null;
}

export class GetTenantCitiesResponse implements IGetTenantCitiesResponse {
    cities?: TenantCityVM[] | null;

    constructor(data?: IGetTenantCitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(TenantCityVM.fromJS(item));
            }
            else {
                this.cities = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTenantCitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantCitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetTenantCitiesResponse {
        const json = this.toJSON();
        let result = new GetTenantCitiesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTenantCitiesResponse {
    cities?: TenantCityVM[] | null;
}

export class ManufacturerDto implements IManufacturerDto {
    id?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    created?: string | null;

    constructor(data?: IManufacturerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
        }
    }

    static fromJS(data: any): ManufacturerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        return data; 
    }

    clone(): ManufacturerDto {
        const json = this.toJSON();
        let result = new ManufacturerDto();
        result.init(json);
        return result;
    }
}

export interface IManufacturerDto {
    id?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    created?: string | null;
}

export class ArticleDto implements IArticleDto {
    id?: string | null;
    created?: string | null;
    header?: string | null;
    tags?: string | null;
    htmlContent?: string | null;
    isActive?: boolean | null;
    timeToRead?: string | null;
    isTop?: boolean | null;
    previewImage?: string | null;
    published?: string | null;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.tags = _data["tags"] !== undefined ? _data["tags"] : <any>null;
            this.htmlContent = _data["htmlContent"] !== undefined ? _data["htmlContent"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.timeToRead = _data["timeToRead"] !== undefined ? _data["timeToRead"] : <any>null;
            this.isTop = _data["isTop"] !== undefined ? _data["isTop"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["tags"] = this.tags !== undefined ? this.tags : <any>null;
        data["htmlContent"] = this.htmlContent !== undefined ? this.htmlContent : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["timeToRead"] = this.timeToRead !== undefined ? this.timeToRead : <any>null;
        data["isTop"] = this.isTop !== undefined ? this.isTop : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        return data; 
    }

    clone(): ArticleDto {
        const json = this.toJSON();
        let result = new ArticleDto();
        result.init(json);
        return result;
    }
}

export interface IArticleDto {
    id?: string | null;
    created?: string | null;
    header?: string | null;
    tags?: string | null;
    htmlContent?: string | null;
    isActive?: boolean | null;
    timeToRead?: string | null;
    isTop?: boolean | null;
    previewImage?: string | null;
    published?: string | null;
}

export class Article implements IArticle {
    id?: string;
    created?: string;
    modified?: string | null;
    header?: string | null;
    tags?: string | null;
    htmlContent?: string | null;
    isActive?: boolean;
    timeToRead?: string | null;
    alias?: string | null;
    isTop?: boolean;
    previewImage?: string | null;
    published?: string | null;
    description?: string | null;

    constructor(data?: IArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.tags = _data["tags"] !== undefined ? _data["tags"] : <any>null;
            this.htmlContent = _data["htmlContent"] !== undefined ? _data["htmlContent"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.timeToRead = _data["timeToRead"] !== undefined ? _data["timeToRead"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.isTop = _data["isTop"] !== undefined ? _data["isTop"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): Article {
        data = typeof data === 'object' ? data : {};
        let result = new Article();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["tags"] = this.tags !== undefined ? this.tags : <any>null;
        data["htmlContent"] = this.htmlContent !== undefined ? this.htmlContent : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["timeToRead"] = this.timeToRead !== undefined ? this.timeToRead : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["isTop"] = this.isTop !== undefined ? this.isTop : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data; 
    }

    clone(): Article {
        const json = this.toJSON();
        let result = new Article();
        result.init(json);
        return result;
    }
}

export interface IArticle {
    id?: string;
    created?: string;
    modified?: string | null;
    header?: string | null;
    tags?: string | null;
    htmlContent?: string | null;
    isActive?: boolean;
    timeToRead?: string | null;
    alias?: string | null;
    isTop?: boolean;
    previewImage?: string | null;
    published?: string | null;
    description?: string | null;
}

export class MpCategoryDto implements IMpCategoryDto {
    title?: string | null;
    parentCategoryId?: string | null;
    alias?: string | null;
    id?: string | null;
    created?: string | null;
    priority?: number | null;
    displayOnHeaderBottom?: boolean | null;
    image?: string | null;

    constructor(data?: IMpCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.displayOnHeaderBottom = _data["displayOnHeaderBottom"] !== undefined ? _data["displayOnHeaderBottom"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
        }
    }

    static fromJS(data: any): MpCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["displayOnHeaderBottom"] = this.displayOnHeaderBottom !== undefined ? this.displayOnHeaderBottom : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        return data; 
    }

    clone(): MpCategoryDto {
        const json = this.toJSON();
        let result = new MpCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IMpCategoryDto {
    title?: string | null;
    parentCategoryId?: string | null;
    alias?: string | null;
    id?: string | null;
    created?: string | null;
    priority?: number | null;
    displayOnHeaderBottom?: boolean | null;
    image?: string | null;
}

export class MpCategory implements IMpCategory {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    alias?: string | null;
    parentCategoryId?: string | null;
    isArchived?: boolean;
    priority?: number;
    displayOnHeaderBottom?: boolean;
    image?: string | null;

    constructor(data?: IMpCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.parentCategoryId = _data["parentCategoryId"] !== undefined ? _data["parentCategoryId"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.displayOnHeaderBottom = _data["displayOnHeaderBottom"] !== undefined ? _data["displayOnHeaderBottom"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
        }
    }

    static fromJS(data: any): MpCategory {
        data = typeof data === 'object' ? data : {};
        let result = new MpCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["parentCategoryId"] = this.parentCategoryId !== undefined ? this.parentCategoryId : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["displayOnHeaderBottom"] = this.displayOnHeaderBottom !== undefined ? this.displayOnHeaderBottom : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        return data; 
    }

    clone(): MpCategory {
        const json = this.toJSON();
        let result = new MpCategory();
        result.init(json);
        return result;
    }
}

export interface IMpCategory {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    alias?: string | null;
    parentCategoryId?: string | null;
    isArchived?: boolean;
    priority?: number;
    displayOnHeaderBottom?: boolean;
    image?: string | null;
}

export class MpCategoryRelatedGoodDto implements IMpCategoryRelatedGoodDto {
    id?: string | null;
    categoryId?: string;
    goodId?: string;
    priority?: number | null;

    constructor(data?: IMpCategoryRelatedGoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MpCategoryRelatedGoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpCategoryRelatedGoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MpCategoryRelatedGoodDto {
        const json = this.toJSON();
        let result = new MpCategoryRelatedGoodDto();
        result.init(json);
        return result;
    }
}

export interface IMpCategoryRelatedGoodDto {
    id?: string | null;
    categoryId?: string;
    goodId?: string;
    priority?: number | null;
}

export class MpCategoryRelatedGood implements IMpCategoryRelatedGood {
    id?: string;
    created?: string;
    modified?: string | null;
    categoryId?: string;
    goodId?: string;
    priority?: number;

    constructor(data?: IMpCategoryRelatedGood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MpCategoryRelatedGood {
        data = typeof data === 'object' ? data : {};
        let result = new MpCategoryRelatedGood();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MpCategoryRelatedGood {
        const json = this.toJSON();
        let result = new MpCategoryRelatedGood();
        result.init(json);
        return result;
    }
}

export interface IMpCategoryRelatedGood {
    id?: string;
    created?: string;
    modified?: string | null;
    categoryId?: string;
    goodId?: string;
    priority?: number;
}

export class SetMpCategoryRelatedGoodDto implements ISetMpCategoryRelatedGoodDto {
    goodIds?: string[] | null;
    categoryId?: string;

    constructor(data?: ISetMpCategoryRelatedGoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
        }
    }

    static fromJS(data: any): SetMpCategoryRelatedGoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetMpCategoryRelatedGoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        return data; 
    }

    clone(): SetMpCategoryRelatedGoodDto {
        const json = this.toJSON();
        let result = new SetMpCategoryRelatedGoodDto();
        result.init(json);
        return result;
    }
}

export interface ISetMpCategoryRelatedGoodDto {
    goodIds?: string[] | null;
    categoryId?: string;
}

export class MpCityDto implements IMpCityDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;

    constructor(data?: IMpCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): MpCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): MpCityDto {
        const json = this.toJSON();
        let result = new MpCityDto();
        result.init(json);
        return result;
    }
}

export interface IMpCityDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;
}

export class MpCity implements IMpCity {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;

    constructor(data?: IMpCity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): MpCity {
        data = typeof data === 'object' ? data : {};
        let result = new MpCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): MpCity {
        const json = this.toJSON();
        let result = new MpCity();
        result.init(json);
        return result;
    }
}

export interface IMpCity {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
}

export class MpGoodDto implements IMpGoodDto {
    id?: string | null;
    created?: string | null;
    mpCategoryId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number | null;
    isAccepted?: boolean | null;
    isBase?: boolean | null;
    isArchived?: boolean | null;
    moduleGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    hasStructure?: boolean | null;
    nikaCategoryTitle?: string | null;
    previewImage?: string | null;
    defaultPriceUpRate?: number | null;
    priceUpRate?: number | null;
    hideInCatalog?: boolean | null;
    forMarketplace?: boolean | null;
    isActive?: boolean | null;
    price?: number | null;
    displayPrice?: number | null;
    finalPrice?: number | null;
    saleRate?: number | null;
    saleEndDateTime?: string | null;
    priority?: number | null;

    constructor(data?: IMpGoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.mpCategoryId = _data["mpCategoryId"] !== undefined ? _data["mpCategoryId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.isAccepted = _data["isAccepted"] !== undefined ? _data["isAccepted"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.moduleGroup = _data["moduleGroup"] !== undefined ? _data["moduleGroup"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.additionalGoods = _data["additionalGoods"] !== undefined ? _data["additionalGoods"] : <any>null;
            this.hasStructure = _data["hasStructure"] !== undefined ? _data["hasStructure"] : <any>null;
            this.nikaCategoryTitle = _data["nikaCategoryTitle"] !== undefined ? _data["nikaCategoryTitle"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.defaultPriceUpRate = _data["defaultPriceUpRate"] !== undefined ? _data["defaultPriceUpRate"] : <any>null;
            this.priceUpRate = _data["priceUpRate"] !== undefined ? _data["priceUpRate"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.forMarketplace = _data["forMarketplace"] !== undefined ? _data["forMarketplace"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.displayPrice = _data["displayPrice"] !== undefined ? _data["displayPrice"] : <any>null;
            this.finalPrice = _data["finalPrice"] !== undefined ? _data["finalPrice"] : <any>null;
            this.saleRate = _data["saleRate"] !== undefined ? _data["saleRate"] : <any>null;
            this.saleEndDateTime = _data["saleEndDateTime"] !== undefined ? _data["saleEndDateTime"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MpGoodDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpGoodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["mpCategoryId"] = this.mpCategoryId !== undefined ? this.mpCategoryId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["isAccepted"] = this.isAccepted !== undefined ? this.isAccepted : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["moduleGroup"] = this.moduleGroup !== undefined ? this.moduleGroup : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["additionalGoods"] = this.additionalGoods !== undefined ? this.additionalGoods : <any>null;
        data["hasStructure"] = this.hasStructure !== undefined ? this.hasStructure : <any>null;
        data["nikaCategoryTitle"] = this.nikaCategoryTitle !== undefined ? this.nikaCategoryTitle : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["defaultPriceUpRate"] = this.defaultPriceUpRate !== undefined ? this.defaultPriceUpRate : <any>null;
        data["priceUpRate"] = this.priceUpRate !== undefined ? this.priceUpRate : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["forMarketplace"] = this.forMarketplace !== undefined ? this.forMarketplace : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["displayPrice"] = this.displayPrice !== undefined ? this.displayPrice : <any>null;
        data["finalPrice"] = this.finalPrice !== undefined ? this.finalPrice : <any>null;
        data["saleRate"] = this.saleRate !== undefined ? this.saleRate : <any>null;
        data["saleEndDateTime"] = this.saleEndDateTime !== undefined ? this.saleEndDateTime : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MpGoodDto {
        const json = this.toJSON();
        let result = new MpGoodDto();
        result.init(json);
        return result;
    }
}

export interface IMpGoodDto {
    id?: string | null;
    created?: string | null;
    mpCategoryId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number | null;
    isAccepted?: boolean | null;
    isBase?: boolean | null;
    isArchived?: boolean | null;
    moduleGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    hasStructure?: boolean | null;
    nikaCategoryTitle?: string | null;
    previewImage?: string | null;
    defaultPriceUpRate?: number | null;
    priceUpRate?: number | null;
    hideInCatalog?: boolean | null;
    forMarketplace?: boolean | null;
    isActive?: boolean | null;
    price?: number | null;
    displayPrice?: number | null;
    finalPrice?: number | null;
    saleRate?: number | null;
    saleEndDateTime?: string | null;
    priority?: number | null;
}

export class SetHideInCatalogDto implements ISetHideInCatalogDto {
    goodIds?: string[] | null;

    constructor(data?: ISetHideInCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetHideInCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetHideInCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        return data; 
    }

    clone(): SetHideInCatalogDto {
        const json = this.toJSON();
        let result = new SetHideInCatalogDto();
        result.init(json);
        return result;
    }
}

export interface ISetHideInCatalogDto {
    goodIds?: string[] | null;
}

export enum ModuleType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    __1 = -1,
}

export class MpGood implements IMpGood {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    mpCategoryId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number;
    isAccepted?: boolean;
    isBase?: boolean;
    isArchived?: boolean;
    moduleGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    nikaCategoryTitle?: string | null;
    previewImage?: string | null;
    hasStructure?: boolean;
    color?: string | null;
    colorHex?: string | null;
    secondColor?: string | null;
    secondColorHex?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    manufacturerId?: string | null;
    manufacturer?: Manufacturer;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    material?: string | null;
    features?: string | null;
    capacity?: number;
    priority?: number;
    properties?: string | null;
    nomenclatureStatus?: string | null;
    code?: string | null;
    defaultPriceUpRate?: number;
    forMarketplace?: boolean;
    hideInCatalog?: boolean;
    nomenclatureStatusYekaterinburg?: string | null;
    nomenclatureStatusIrkutsk?: string | null;
    nomenclatureStatusMoscow?: string | null;
    nomenclatureStatusKhabarovsk?: string | null;
    moduleType?: ModuleType;
    instructionsLink?: string | null;

    constructor(data?: IMpGood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.mpCategoryId = _data["mpCategoryId"] !== undefined ? _data["mpCategoryId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.apiId = _data["apiId"] !== undefined ? _data["apiId"] : <any>null;
            this.isAccepted = _data["isAccepted"] !== undefined ? _data["isAccepted"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.moduleGroup = _data["moduleGroup"] !== undefined ? _data["moduleGroup"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.additionalGoods = _data["additionalGoods"] !== undefined ? _data["additionalGoods"] : <any>null;
            this.nikaCategoryTitle = _data["nikaCategoryTitle"] !== undefined ? _data["nikaCategoryTitle"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.hasStructure = _data["hasStructure"] !== undefined ? _data["hasStructure"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.colorHex = _data["colorHex"] !== undefined ? _data["colorHex"] : <any>null;
            this.secondColor = _data["secondColor"] !== undefined ? _data["secondColor"] : <any>null;
            this.secondColorHex = _data["secondColorHex"] !== undefined ? _data["secondColorHex"] : <any>null;
            this.colorGroup = _data["colorGroup"] !== undefined ? _data["colorGroup"] : <any>null;
            this.sizeGroup = _data["sizeGroup"] !== undefined ? _data["sizeGroup"] : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.manufacturer = _data["manufacturer"] ? Manufacturer.fromJS(_data["manufacturer"]) : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.features = _data["features"] !== undefined ? _data["features"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.properties = _data["properties"] !== undefined ? _data["properties"] : <any>null;
            this.nomenclatureStatus = _data["nomenclatureStatus"] !== undefined ? _data["nomenclatureStatus"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.defaultPriceUpRate = _data["defaultPriceUpRate"] !== undefined ? _data["defaultPriceUpRate"] : <any>null;
            this.forMarketplace = _data["forMarketplace"] !== undefined ? _data["forMarketplace"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.nomenclatureStatusYekaterinburg = _data["nomenclatureStatusYekaterinburg"] !== undefined ? _data["nomenclatureStatusYekaterinburg"] : <any>null;
            this.nomenclatureStatusIrkutsk = _data["nomenclatureStatusIrkutsk"] !== undefined ? _data["nomenclatureStatusIrkutsk"] : <any>null;
            this.nomenclatureStatusMoscow = _data["nomenclatureStatusMoscow"] !== undefined ? _data["nomenclatureStatusMoscow"] : <any>null;
            this.nomenclatureStatusKhabarovsk = _data["nomenclatureStatusKhabarovsk"] !== undefined ? _data["nomenclatureStatusKhabarovsk"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.instructionsLink = _data["instructionsLink"] !== undefined ? _data["instructionsLink"] : <any>null;
        }
    }

    static fromJS(data: any): MpGood {
        data = typeof data === 'object' ? data : {};
        let result = new MpGood();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["mpCategoryId"] = this.mpCategoryId !== undefined ? this.mpCategoryId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["apiId"] = this.apiId !== undefined ? this.apiId : <any>null;
        data["isAccepted"] = this.isAccepted !== undefined ? this.isAccepted : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["moduleGroup"] = this.moduleGroup !== undefined ? this.moduleGroup : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["additionalGoods"] = this.additionalGoods !== undefined ? this.additionalGoods : <any>null;
        data["nikaCategoryTitle"] = this.nikaCategoryTitle !== undefined ? this.nikaCategoryTitle : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["hasStructure"] = this.hasStructure !== undefined ? this.hasStructure : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["colorHex"] = this.colorHex !== undefined ? this.colorHex : <any>null;
        data["secondColor"] = this.secondColor !== undefined ? this.secondColor : <any>null;
        data["secondColorHex"] = this.secondColorHex !== undefined ? this.secondColorHex : <any>null;
        data["colorGroup"] = this.colorGroup !== undefined ? this.colorGroup : <any>null;
        data["sizeGroup"] = this.sizeGroup !== undefined ? this.sizeGroup : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["features"] = this.features !== undefined ? this.features : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["properties"] = this.properties !== undefined ? this.properties : <any>null;
        data["nomenclatureStatus"] = this.nomenclatureStatus !== undefined ? this.nomenclatureStatus : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["defaultPriceUpRate"] = this.defaultPriceUpRate !== undefined ? this.defaultPriceUpRate : <any>null;
        data["forMarketplace"] = this.forMarketplace !== undefined ? this.forMarketplace : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["nomenclatureStatusYekaterinburg"] = this.nomenclatureStatusYekaterinburg !== undefined ? this.nomenclatureStatusYekaterinburg : <any>null;
        data["nomenclatureStatusIrkutsk"] = this.nomenclatureStatusIrkutsk !== undefined ? this.nomenclatureStatusIrkutsk : <any>null;
        data["nomenclatureStatusMoscow"] = this.nomenclatureStatusMoscow !== undefined ? this.nomenclatureStatusMoscow : <any>null;
        data["nomenclatureStatusKhabarovsk"] = this.nomenclatureStatusKhabarovsk !== undefined ? this.nomenclatureStatusKhabarovsk : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["instructionsLink"] = this.instructionsLink !== undefined ? this.instructionsLink : <any>null;
        return data; 
    }

    clone(): MpGood {
        const json = this.toJSON();
        let result = new MpGood();
        result.init(json);
        return result;
    }
}

export interface IMpGood {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    mpCategoryId?: string | null;
    title?: string | null;
    alias?: string | null;
    xmlId?: string | null;
    apiId?: number;
    isAccepted?: boolean;
    isBase?: boolean;
    isArchived?: boolean;
    moduleGroup?: string | null;
    composition?: string | null;
    additionalGoods?: string | null;
    nikaCategoryTitle?: string | null;
    previewImage?: string | null;
    hasStructure?: boolean;
    color?: string | null;
    colorHex?: string | null;
    secondColor?: string | null;
    secondColorHex?: string | null;
    colorGroup?: string | null;
    sizeGroup?: string | null;
    manufacturerId?: string | null;
    manufacturer?: Manufacturer;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    material?: string | null;
    features?: string | null;
    capacity?: number;
    priority?: number;
    properties?: string | null;
    nomenclatureStatus?: string | null;
    code?: string | null;
    defaultPriceUpRate?: number;
    forMarketplace?: boolean;
    hideInCatalog?: boolean;
    nomenclatureStatusYekaterinburg?: string | null;
    nomenclatureStatusIrkutsk?: string | null;
    nomenclatureStatusMoscow?: string | null;
    nomenclatureStatusKhabarovsk?: string | null;
    moduleType?: ModuleType;
    instructionsLink?: string | null;
}

export enum MpSelectionType {
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export class MpGoodSelectionDto implements IMpGoodSelectionDto {
    id?: string | null;
    goodId?: string;
    selectionType?: MpSelectionType;
    priority?: number | null;

    constructor(data?: IMpGoodSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.selectionType = _data["selectionType"] !== undefined ? _data["selectionType"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MpGoodSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpGoodSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["selectionType"] = this.selectionType !== undefined ? this.selectionType : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MpGoodSelectionDto {
        const json = this.toJSON();
        let result = new MpGoodSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IMpGoodSelectionDto {
    id?: string | null;
    goodId?: string;
    selectionType?: MpSelectionType;
    priority?: number | null;
}

export class MpGoodSelection implements IMpGoodSelection {
    id?: string;
    created?: string;
    modified?: string | null;
    goodId?: string;
    selectionType?: MpSelectionType;
    priority?: number;

    constructor(data?: IMpGoodSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.selectionType = _data["selectionType"] !== undefined ? _data["selectionType"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): MpGoodSelection {
        data = typeof data === 'object' ? data : {};
        let result = new MpGoodSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["selectionType"] = this.selectionType !== undefined ? this.selectionType : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): MpGoodSelection {
        const json = this.toJSON();
        let result = new MpGoodSelection();
        result.init(json);
        return result;
    }
}

export interface IMpGoodSelection {
    id?: string;
    created?: string;
    modified?: string | null;
    goodId?: string;
    selectionType?: MpSelectionType;
    priority?: number;
}

export class CodeValueEnumPair implements ICodeValueEnumPair {
    code?: string | null;
    value?: number;

    constructor(data?: ICodeValueEnumPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): CodeValueEnumPair {
        data = typeof data === 'object' ? data : {};
        let result = new CodeValueEnumPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data; 
    }

    clone(): CodeValueEnumPair {
        const json = this.toJSON();
        let result = new CodeValueEnumPair();
        result.init(json);
        return result;
    }
}

export interface ICodeValueEnumPair {
    code?: string | null;
    value?: number;
}

export class MpGoodSetSelectionTypeDto implements IMpGoodSetSelectionTypeDto {
    goodIds?: string[] | null;
    selectionType?: number;

    constructor(data?: IMpGoodSetSelectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["goodIds"])) {
                this.goodIds = [] as any;
                for (let item of _data["goodIds"])
                    this.goodIds!.push(item);
            }
            else {
                this.goodIds = <any>null;
            }
            this.selectionType = _data["selectionType"] !== undefined ? _data["selectionType"] : <any>null;
        }
    }

    static fromJS(data: any): MpGoodSetSelectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpGoodSetSelectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.goodIds)) {
            data["goodIds"] = [];
            for (let item of this.goodIds)
                data["goodIds"].push(item);
        }
        data["selectionType"] = this.selectionType !== undefined ? this.selectionType : <any>null;
        return data; 
    }

    clone(): MpGoodSetSelectionTypeDto {
        const json = this.toJSON();
        let result = new MpGoodSetSelectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface IMpGoodSetSelectionTypeDto {
    goodIds?: string[] | null;
    selectionType?: number;
}

export enum MpSliderType {
    _100 = 100,
    _200 = 200,
    _300 = 300,
}

export class MpMainSliderItemDto implements IMpMainSliderItemDto {
    header?: string | null;
    subHeader?: string | null;
    url?: string | null;
    id?: string | null;
    image?: string | null;
    priority?: number | null;
    sliderType?: MpSliderType;
    watermark?: boolean | null;
    isArchived?: boolean | null;
    imageAlt?: string | null;
    imageTitle?: string | null;

    constructor(data?: IMpMainSliderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.subHeader = _data["subHeader"] !== undefined ? _data["subHeader"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.sliderType = _data["sliderType"] !== undefined ? _data["sliderType"] : <any>null;
            this.watermark = _data["watermark"] !== undefined ? _data["watermark"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.imageAlt = _data["imageAlt"] !== undefined ? _data["imageAlt"] : <any>null;
            this.imageTitle = _data["imageTitle"] !== undefined ? _data["imageTitle"] : <any>null;
        }
    }

    static fromJS(data: any): MpMainSliderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpMainSliderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["subHeader"] = this.subHeader !== undefined ? this.subHeader : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["sliderType"] = this.sliderType !== undefined ? this.sliderType : <any>null;
        data["watermark"] = this.watermark !== undefined ? this.watermark : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["imageAlt"] = this.imageAlt !== undefined ? this.imageAlt : <any>null;
        data["imageTitle"] = this.imageTitle !== undefined ? this.imageTitle : <any>null;
        return data; 
    }

    clone(): MpMainSliderItemDto {
        const json = this.toJSON();
        let result = new MpMainSliderItemDto();
        result.init(json);
        return result;
    }
}

export interface IMpMainSliderItemDto {
    header?: string | null;
    subHeader?: string | null;
    url?: string | null;
    id?: string | null;
    image?: string | null;
    priority?: number | null;
    sliderType?: MpSliderType;
    watermark?: boolean | null;
    isArchived?: boolean | null;
    imageAlt?: string | null;
    imageTitle?: string | null;
}

export class MpMainSliderItem implements IMpMainSliderItem {
    id?: string;
    created?: string;
    modified?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;
    header?: string | null;
    subHeader?: string | null;
    sliderType?: MpSliderType;
    watermark?: boolean;
    isArchived?: boolean;
    imageAlt?: string | null;
    imageTitle?: string | null;

    constructor(data?: IMpMainSliderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.subHeader = _data["subHeader"] !== undefined ? _data["subHeader"] : <any>null;
            this.sliderType = _data["sliderType"] !== undefined ? _data["sliderType"] : <any>null;
            this.watermark = _data["watermark"] !== undefined ? _data["watermark"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.imageAlt = _data["imageAlt"] !== undefined ? _data["imageAlt"] : <any>null;
            this.imageTitle = _data["imageTitle"] !== undefined ? _data["imageTitle"] : <any>null;
        }
    }

    static fromJS(data: any): MpMainSliderItem {
        data = typeof data === 'object' ? data : {};
        let result = new MpMainSliderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["subHeader"] = this.subHeader !== undefined ? this.subHeader : <any>null;
        data["sliderType"] = this.sliderType !== undefined ? this.sliderType : <any>null;
        data["watermark"] = this.watermark !== undefined ? this.watermark : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["imageAlt"] = this.imageAlt !== undefined ? this.imageAlt : <any>null;
        data["imageTitle"] = this.imageTitle !== undefined ? this.imageTitle : <any>null;
        return data; 
    }

    clone(): MpMainSliderItem {
        const json = this.toJSON();
        let result = new MpMainSliderItem();
        result.init(json);
        return result;
    }
}

export interface IMpMainSliderItem {
    id?: string;
    created?: string;
    modified?: string | null;
    image?: string | null;
    url?: string | null;
    priority?: number;
    header?: string | null;
    subHeader?: string | null;
    sliderType?: MpSliderType;
    watermark?: boolean;
    isArchived?: boolean;
    imageAlt?: string | null;
    imageTitle?: string | null;
}

export class MpRequestDto implements IMpRequestDto {
    id?: string | null;
    created?: string | null;
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    inProgress?: boolean | null;
    tookInProgress?: string | null;

    constructor(data?: IMpRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientPhoneNumber = _data["clientPhoneNumber"] !== undefined ? _data["clientPhoneNumber"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.tenantTitle = _data["tenantTitle"] !== undefined ? _data["tenantTitle"] : <any>null;
            this.goodUrl = _data["goodUrl"] !== undefined ? _data["goodUrl"] : <any>null;
            this.warehouseAddress = _data["warehouseAddress"] !== undefined ? _data["warehouseAddress"] : <any>null;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : <any>null;
            this.tookInProgress = _data["tookInProgress"] !== undefined ? _data["tookInProgress"] : <any>null;
        }
    }

    static fromJS(data: any): MpRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientPhoneNumber"] = this.clientPhoneNumber !== undefined ? this.clientPhoneNumber : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["tenantTitle"] = this.tenantTitle !== undefined ? this.tenantTitle : <any>null;
        data["goodUrl"] = this.goodUrl !== undefined ? this.goodUrl : <any>null;
        data["warehouseAddress"] = this.warehouseAddress !== undefined ? this.warehouseAddress : <any>null;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : <any>null;
        data["tookInProgress"] = this.tookInProgress !== undefined ? this.tookInProgress : <any>null;
        return data; 
    }

    clone(): MpRequestDto {
        const json = this.toJSON();
        let result = new MpRequestDto();
        result.init(json);
        return result;
    }
}

export interface IMpRequestDto {
    id?: string | null;
    created?: string | null;
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    inProgress?: boolean | null;
    tookInProgress?: string | null;
}

export class MPRequest implements IMPRequest {
    id?: string;
    created?: string;
    modified?: string | null;
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    tenantId?: string | null;
    warehouseId?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    inProgress?: boolean;
    tookInProgress?: string | null;

    constructor(data?: IMPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientPhoneNumber = _data["clientPhoneNumber"] !== undefined ? _data["clientPhoneNumber"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.tenantTitle = _data["tenantTitle"] !== undefined ? _data["tenantTitle"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
            this.goodUrl = _data["goodUrl"] !== undefined ? _data["goodUrl"] : <any>null;
            this.warehouseAddress = _data["warehouseAddress"] !== undefined ? _data["warehouseAddress"] : <any>null;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : <any>null;
            this.tookInProgress = _data["tookInProgress"] !== undefined ? _data["tookInProgress"] : <any>null;
        }
    }

    static fromJS(data: any): MPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientPhoneNumber"] = this.clientPhoneNumber !== undefined ? this.clientPhoneNumber : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["tenantTitle"] = this.tenantTitle !== undefined ? this.tenantTitle : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        data["goodUrl"] = this.goodUrl !== undefined ? this.goodUrl : <any>null;
        data["warehouseAddress"] = this.warehouseAddress !== undefined ? this.warehouseAddress : <any>null;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : <any>null;
        data["tookInProgress"] = this.tookInProgress !== undefined ? this.tookInProgress : <any>null;
        return data; 
    }

    clone(): MPRequest {
        const json = this.toJSON();
        let result = new MPRequest();
        result.init(json);
        return result;
    }
}

export interface IMPRequest {
    id?: string;
    created?: string;
    modified?: string | null;
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    tenantId?: string | null;
    warehouseId?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    inProgress?: boolean;
    tookInProgress?: string | null;
}

export class MPRequestController_MPRequestImportModel implements IMPRequestController_MPRequestImportModel {
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    warehouseId?: string | null;
    tenantId?: string | null;

    constructor(data?: IMPRequestController_MPRequestImportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientPhoneNumber = _data["clientPhoneNumber"] !== undefined ? _data["clientPhoneNumber"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.tenantTitle = _data["tenantTitle"] !== undefined ? _data["tenantTitle"] : <any>null;
            this.goodUrl = _data["goodUrl"] !== undefined ? _data["goodUrl"] : <any>null;
            this.warehouseAddress = _data["warehouseAddress"] !== undefined ? _data["warehouseAddress"] : <any>null;
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): MPRequestController_MPRequestImportModel {
        data = typeof data === 'object' ? data : {};
        let result = new MPRequestController_MPRequestImportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientPhoneNumber"] = this.clientPhoneNumber !== undefined ? this.clientPhoneNumber : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["tenantTitle"] = this.tenantTitle !== undefined ? this.tenantTitle : <any>null;
        data["goodUrl"] = this.goodUrl !== undefined ? this.goodUrl : <any>null;
        data["warehouseAddress"] = this.warehouseAddress !== undefined ? this.warehouseAddress : <any>null;
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): MPRequestController_MPRequestImportModel {
        const json = this.toJSON();
        let result = new MPRequestController_MPRequestImportModel();
        result.init(json);
        return result;
    }
}

export interface IMPRequestController_MPRequestImportModel {
    clientName?: string | null;
    clientPhoneNumber?: string | null;
    goodTitle?: string | null;
    tenantTitle?: string | null;
    goodUrl?: string | null;
    warehouseAddress?: string | null;
    warehouseId?: string | null;
    tenantId?: string | null;
}

export class NavigationItemDto implements INavigationItemDto {
    id?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;

    constructor(data?: INavigationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): NavigationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        return data; 
    }

    clone(): NavigationItemDto {
        const json = this.toJSON();
        let result = new NavigationItemDto();
        result.init(json);
        return result;
    }
}

export interface INavigationItemDto {
    id?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;
}

export class NavigationItem implements INavigationItem {
    id?: string;
    created?: string;
    modified?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;

    constructor(data?: INavigationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): NavigationItem {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        return data; 
    }

    clone(): NavigationItem {
        const json = this.toJSON();
        let result = new NavigationItem();
        result.init(json);
        return result;
    }
}

export interface INavigationItem {
    id?: string;
    created?: string;
    modified?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;
}

export class NavigationDto implements INavigationDto {
    id?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;
    parentId?: string | null;
    priority?: number;
    navigationType?: NavigationType;
    isHidden?: boolean;
    isDirectory?: boolean;
    items?: NavigationDto[] | null;

    constructor(data?: INavigationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.navigationType = _data["navigationType"] !== undefined ? _data["navigationType"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.isDirectory = _data["isDirectory"] !== undefined ? _data["isDirectory"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NavigationDto.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): NavigationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["navigationType"] = this.navigationType !== undefined ? this.navigationType : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["isDirectory"] = this.isDirectory !== undefined ? this.isDirectory : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NavigationDto {
        const json = this.toJSON();
        let result = new NavigationDto();
        result.init(json);
        return result;
    }
}

export interface INavigationDto {
    id?: string | null;
    text?: string | null;
    path?: string | null;
    icon?: string | null;
    parentId?: string | null;
    priority?: number;
    navigationType?: NavigationType;
    isHidden?: boolean;
    isDirectory?: boolean;
    items?: NavigationDto[] | null;
}

export class NavigationItemUpdateDto implements INavigationItemUpdateDto {
    id?: string | null;
    priority?: number | null;
    isHidden?: boolean;
    parentId?: string | null;
    navigationType?: NavigationType;

    constructor(data?: INavigationItemUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.navigationType = _data["navigationType"] !== undefined ? _data["navigationType"] : <any>null;
        }
    }

    static fromJS(data: any): NavigationItemUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationItemUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["navigationType"] = this.navigationType !== undefined ? this.navigationType : <any>null;
        return data; 
    }

    clone(): NavigationItemUpdateDto {
        const json = this.toJSON();
        let result = new NavigationItemUpdateDto();
        result.init(json);
        return result;
    }
}

export interface INavigationItemUpdateDto {
    id?: string | null;
    priority?: number | null;
    isHidden?: boolean;
    parentId?: string | null;
    navigationType?: NavigationType;
}

export class NewsDto implements INewsDto {
    id?: string | null;
    content?: string | null;
    image?: string | null;
    isArchived?: boolean | null;
    header?: string | null;
    published?: string | null;
    priority?: number | null;
    alias?: string | null;

    constructor(data?: INewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
        }
    }

    static fromJS(data: any): NewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        return data; 
    }

    clone(): NewsDto {
        const json = this.toJSON();
        let result = new NewsDto();
        result.init(json);
        return result;
    }
}

export interface INewsDto {
    id?: string | null;
    content?: string | null;
    image?: string | null;
    isArchived?: boolean | null;
    header?: string | null;
    published?: string | null;
    priority?: number | null;
    alias?: string | null;
}

export class News implements INews {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    content?: string | null;
    image?: string | null;
    isArchived?: boolean;
    header?: string | null;
    published?: string | null;
    priority?: number;
    alias?: string | null;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        return data; 
    }

    clone(): News {
        const json = this.toJSON();
        let result = new News();
        result.init(json);
        return result;
    }
}

export interface INews {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    content?: string | null;
    image?: string | null;
    isArchived?: boolean;
    header?: string | null;
    published?: string | null;
    priority?: number;
    alias?: string | null;
}

export class PostBasePriceData implements IPostBasePriceData {
    goodXmlId?: string;
    warehouseXmlId?: string;
    price?: number;

    constructor(data?: IPostBasePriceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.goodXmlId = _data["goodXmlId"] !== undefined ? _data["goodXmlId"] : <any>null;
            this.warehouseXmlId = _data["warehouseXmlId"] !== undefined ? _data["warehouseXmlId"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): PostBasePriceData {
        data = typeof data === 'object' ? data : {};
        let result = new PostBasePriceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["goodXmlId"] = this.goodXmlId !== undefined ? this.goodXmlId : <any>null;
        data["warehouseXmlId"] = this.warehouseXmlId !== undefined ? this.warehouseXmlId : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data; 
    }

    clone(): PostBasePriceData {
        const json = this.toJSON();
        let result = new PostBasePriceData();
        result.init(json);
        return result;
    }
}

export interface IPostBasePriceData {
    goodXmlId?: string;
    warehouseXmlId?: string;
    price?: number;
}

export class PostPartnerInfoData implements IPostPartnerInfoData {
    partnerXmlId?: string;
    partnerName?: string | null;
    priceRate?: number;

    constructor(data?: IPostPartnerInfoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerXmlId = _data["partnerXmlId"] !== undefined ? _data["partnerXmlId"] : <any>null;
            this.partnerName = _data["partnerName"] !== undefined ? _data["partnerName"] : <any>null;
            this.priceRate = _data["priceRate"] !== undefined ? _data["priceRate"] : <any>null;
        }
    }

    static fromJS(data: any): PostPartnerInfoData {
        data = typeof data === 'object' ? data : {};
        let result = new PostPartnerInfoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerXmlId"] = this.partnerXmlId !== undefined ? this.partnerXmlId : <any>null;
        data["partnerName"] = this.partnerName !== undefined ? this.partnerName : <any>null;
        data["priceRate"] = this.priceRate !== undefined ? this.priceRate : <any>null;
        return data; 
    }

    clone(): PostPartnerInfoData {
        const json = this.toJSON();
        let result = new PostPartnerInfoData();
        result.init(json);
        return result;
    }
}

export interface IPostPartnerInfoData {
    partnerXmlId?: string;
    partnerName?: string | null;
    priceRate?: number;
}

export class CreateOrderDto implements ICreateOrderDto {
    email?: string | null;
    phoneNumber?: string | null;
    responsibleId?: string | null;
    fullName?: string | null;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data; 
    }

    clone(): CreateOrderDto {
        const json = this.toJSON();
        let result = new CreateOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDto {
    email?: string | null;
    phoneNumber?: string | null;
    responsibleId?: string | null;
    fullName?: string | null;
}

export class GoodSupplierInfoDto implements IGoodSupplierInfoDto {
    id?: string;
    goodTitle?: string | null;
    imageUrl?: string | null;
    supplierId?: number;
    isBase?: boolean;
    price?: number;
    finalPrice?: number;
    count?: number;

    constructor(data?: IGoodSupplierInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.finalPrice = _data["finalPrice"] !== undefined ? _data["finalPrice"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): GoodSupplierInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodSupplierInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["finalPrice"] = this.finalPrice !== undefined ? this.finalPrice : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data; 
    }

    clone(): GoodSupplierInfoDto {
        const json = this.toJSON();
        let result = new GoodSupplierInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGoodSupplierInfoDto {
    id?: string;
    goodTitle?: string | null;
    imageUrl?: string | null;
    supplierId?: number;
    isBase?: boolean;
    price?: number;
    finalPrice?: number;
    count?: number;
}

export class OrderGoodRestCityModel implements IOrderGoodRestCityModel {
    city?: string | null;
    amount?: number;

    constructor(data?: IOrderGoodRestCityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderGoodRestCityModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGoodRestCityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data; 
    }

    clone(): OrderGoodRestCityModel {
        const json = this.toJSON();
        let result = new OrderGoodRestCityModel();
        result.init(json);
        return result;
    }
}

export interface IOrderGoodRestCityModel {
    city?: string | null;
    amount?: number;
}

export class OrderGoodRestDto implements IOrderGoodRestDto {
    cityModels?: OrderGoodRestCityModel[] | null;
    goodTitle?: string | null;
    amount?: number;

    constructor(data?: IOrderGoodRestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cityModels"])) {
                this.cityModels = [] as any;
                for (let item of _data["cityModels"])
                    this.cityModels!.push(OrderGoodRestCityModel.fromJS(item));
            }
            else {
                this.cityModels = <any>null;
            }
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderGoodRestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGoodRestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cityModels)) {
            data["cityModels"] = [];
            for (let item of this.cityModels)
                data["cityModels"].push(item.toJSON());
        }
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data; 
    }

    clone(): OrderGoodRestDto {
        const json = this.toJSON();
        let result = new OrderGoodRestDto();
        result.init(json);
        return result;
    }
}

export interface IOrderGoodRestDto {
    cityModels?: OrderGoodRestCityModel[] | null;
    goodTitle?: string | null;
    amount?: number;
}

export class OrderGoodPutDto implements IOrderGoodPutDto {
    id?: string | null;
    count?: number;
    initialPrice?: number | null;
    initialPricePriority?: boolean | null;

    constructor(data?: IOrderGoodPutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.initialPrice = _data["initialPrice"] !== undefined ? _data["initialPrice"] : <any>null;
            this.initialPricePriority = _data["initialPricePriority"] !== undefined ? _data["initialPricePriority"] : <any>null;
        }
    }

    static fromJS(data: any): OrderGoodPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGoodPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["initialPrice"] = this.initialPrice !== undefined ? this.initialPrice : <any>null;
        data["initialPricePriority"] = this.initialPricePriority !== undefined ? this.initialPricePriority : <any>null;
        return data; 
    }

    clone(): OrderGoodPutDto {
        const json = this.toJSON();
        let result = new OrderGoodPutDto();
        result.init(json);
        return result;
    }
}

export interface IOrderGoodPutDto {
    id?: string | null;
    count?: number;
    initialPrice?: number | null;
    initialPricePriority?: boolean | null;
}

export class ChangeLogDto implements IChangeLogDto {
    created?: string;
    author?: string | null;
    fieldName?: string | null;
    valueBefore?: string | null;
    valueAfter?: string | null;
    action?: string | null;

    constructor(data?: IChangeLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.author = _data["author"] !== undefined ? _data["author"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.valueBefore = _data["valueBefore"] !== undefined ? _data["valueBefore"] : <any>null;
            this.valueAfter = _data["valueAfter"] !== undefined ? _data["valueAfter"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["author"] = this.author !== undefined ? this.author : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["valueBefore"] = this.valueBefore !== undefined ? this.valueBefore : <any>null;
        data["valueAfter"] = this.valueAfter !== undefined ? this.valueAfter : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        return data; 
    }

    clone(): ChangeLogDto {
        const json = this.toJSON();
        let result = new ChangeLogDto();
        result.init(json);
        return result;
    }
}

export interface IChangeLogDto {
    created?: string;
    author?: string | null;
    fieldName?: string | null;
    valueBefore?: string | null;
    valueAfter?: string | null;
    action?: string | null;
}

export enum OrderStatus {
    _50 = 50,
    _75 = 75,
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export class Order implements IOrder {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    fullAddress?: string | null;
    paymentMethod?: PaymentMethod;
    deliveryMethod?: DeliveryMethod;
    orderStatus?: OrderStatus;
    additionalInfo?: string | null;
    paymentOrderId?: string | null;
    city?: string | null;
    composition?: string | null;
    finalCost?: number;
    deliveryCost?: number;
    count?: number;
    orderNumber?: number;
    isPaid?: boolean;
    isAccepted?: boolean;
    isFinished?: boolean;
    userId?: string | null;
    invoiceUrl?: string | null;
    percentagePayment?: number | null;
    invoiceNumber?: string | null;
    shippingDate?: string | null;
    managerComment?: string | null;
    responsibleId?: string | null;
    deliveryRegionId?: string | null;
    deliveryCityId?: string | null;
    deliveryPhoneNumber?: string | null;
    liftingCost?: number;
    weight?: number;
    volume?: number;
    assembly?: string | null;
    consigneeFullName?: string | null;
    consigneePhoneNumber?: string | null;
    transportCompanyAddress?: string | null;
    transportCompanyPhoneNumber?: string | null;
    additionalPackaging?: string | null;
    transportCompanyDeliveryCost?: number;
    managerDeliveryComment?: string | null;
    supplierOrderId?: number | null;
    incomingOrderNumber?: string | null;
    proxy?: boolean;
    calltouchSessionId?: string | null;
    calltouchOrderId?: number | null;
    orderSourceId?: string | null;
    fromMarketPlace?: boolean;
    shopId?: string | null;
    isCancelled?: boolean;
    deliveryDate?: string | null;
    deliveryInterval?: string | null;
    paymentFormUrl?: string | null;
    approximateReceiveDate?: string | null;
    approximateDeliveryDate?: string | null;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.deliveryMethod = _data["deliveryMethod"] !== undefined ? _data["deliveryMethod"] : <any>null;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.paymentOrderId = _data["paymentOrderId"] !== undefined ? _data["paymentOrderId"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.composition = _data["composition"] !== undefined ? _data["composition"] : <any>null;
            this.finalCost = _data["finalCost"] !== undefined ? _data["finalCost"] : <any>null;
            this.deliveryCost = _data["deliveryCost"] !== undefined ? _data["deliveryCost"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.isPaid = _data["isPaid"] !== undefined ? _data["isPaid"] : <any>null;
            this.isAccepted = _data["isAccepted"] !== undefined ? _data["isAccepted"] : <any>null;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.invoiceUrl = _data["invoiceUrl"] !== undefined ? _data["invoiceUrl"] : <any>null;
            this.percentagePayment = _data["percentagePayment"] !== undefined ? _data["percentagePayment"] : <any>null;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : <any>null;
            this.shippingDate = _data["shippingDate"] !== undefined ? _data["shippingDate"] : <any>null;
            this.managerComment = _data["managerComment"] !== undefined ? _data["managerComment"] : <any>null;
            this.responsibleId = _data["responsibleId"] !== undefined ? _data["responsibleId"] : <any>null;
            this.deliveryRegionId = _data["deliveryRegionId"] !== undefined ? _data["deliveryRegionId"] : <any>null;
            this.deliveryCityId = _data["deliveryCityId"] !== undefined ? _data["deliveryCityId"] : <any>null;
            this.deliveryPhoneNumber = _data["deliveryPhoneNumber"] !== undefined ? _data["deliveryPhoneNumber"] : <any>null;
            this.liftingCost = _data["liftingCost"] !== undefined ? _data["liftingCost"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.assembly = _data["assembly"] !== undefined ? _data["assembly"] : <any>null;
            this.consigneeFullName = _data["consigneeFullName"] !== undefined ? _data["consigneeFullName"] : <any>null;
            this.consigneePhoneNumber = _data["consigneePhoneNumber"] !== undefined ? _data["consigneePhoneNumber"] : <any>null;
            this.transportCompanyAddress = _data["transportCompanyAddress"] !== undefined ? _data["transportCompanyAddress"] : <any>null;
            this.transportCompanyPhoneNumber = _data["transportCompanyPhoneNumber"] !== undefined ? _data["transportCompanyPhoneNumber"] : <any>null;
            this.additionalPackaging = _data["additionalPackaging"] !== undefined ? _data["additionalPackaging"] : <any>null;
            this.transportCompanyDeliveryCost = _data["transportCompanyDeliveryCost"] !== undefined ? _data["transportCompanyDeliveryCost"] : <any>null;
            this.managerDeliveryComment = _data["managerDeliveryComment"] !== undefined ? _data["managerDeliveryComment"] : <any>null;
            this.supplierOrderId = _data["supplierOrderId"] !== undefined ? _data["supplierOrderId"] : <any>null;
            this.incomingOrderNumber = _data["incomingOrderNumber"] !== undefined ? _data["incomingOrderNumber"] : <any>null;
            this.proxy = _data["proxy"] !== undefined ? _data["proxy"] : <any>null;
            this.calltouchSessionId = _data["calltouchSessionId"] !== undefined ? _data["calltouchSessionId"] : <any>null;
            this.calltouchOrderId = _data["calltouchOrderId"] !== undefined ? _data["calltouchOrderId"] : <any>null;
            this.orderSourceId = _data["orderSourceId"] !== undefined ? _data["orderSourceId"] : <any>null;
            this.fromMarketPlace = _data["fromMarketPlace"] !== undefined ? _data["fromMarketPlace"] : <any>null;
            this.shopId = _data["shopId"] !== undefined ? _data["shopId"] : <any>null;
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : <any>null;
            this.deliveryDate = _data["deliveryDate"] !== undefined ? _data["deliveryDate"] : <any>null;
            this.deliveryInterval = _data["deliveryInterval"] !== undefined ? _data["deliveryInterval"] : <any>null;
            this.paymentFormUrl = _data["paymentFormUrl"] !== undefined ? _data["paymentFormUrl"] : <any>null;
            this.approximateReceiveDate = _data["approximateReceiveDate"] !== undefined ? _data["approximateReceiveDate"] : <any>null;
            this.approximateDeliveryDate = _data["approximateDeliveryDate"] !== undefined ? _data["approximateDeliveryDate"] : <any>null;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["deliveryMethod"] = this.deliveryMethod !== undefined ? this.deliveryMethod : <any>null;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["paymentOrderId"] = this.paymentOrderId !== undefined ? this.paymentOrderId : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["composition"] = this.composition !== undefined ? this.composition : <any>null;
        data["finalCost"] = this.finalCost !== undefined ? this.finalCost : <any>null;
        data["deliveryCost"] = this.deliveryCost !== undefined ? this.deliveryCost : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["isPaid"] = this.isPaid !== undefined ? this.isPaid : <any>null;
        data["isAccepted"] = this.isAccepted !== undefined ? this.isAccepted : <any>null;
        data["isFinished"] = this.isFinished !== undefined ? this.isFinished : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["invoiceUrl"] = this.invoiceUrl !== undefined ? this.invoiceUrl : <any>null;
        data["percentagePayment"] = this.percentagePayment !== undefined ? this.percentagePayment : <any>null;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : <any>null;
        data["shippingDate"] = this.shippingDate !== undefined ? this.shippingDate : <any>null;
        data["managerComment"] = this.managerComment !== undefined ? this.managerComment : <any>null;
        data["responsibleId"] = this.responsibleId !== undefined ? this.responsibleId : <any>null;
        data["deliveryRegionId"] = this.deliveryRegionId !== undefined ? this.deliveryRegionId : <any>null;
        data["deliveryCityId"] = this.deliveryCityId !== undefined ? this.deliveryCityId : <any>null;
        data["deliveryPhoneNumber"] = this.deliveryPhoneNumber !== undefined ? this.deliveryPhoneNumber : <any>null;
        data["liftingCost"] = this.liftingCost !== undefined ? this.liftingCost : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["assembly"] = this.assembly !== undefined ? this.assembly : <any>null;
        data["consigneeFullName"] = this.consigneeFullName !== undefined ? this.consigneeFullName : <any>null;
        data["consigneePhoneNumber"] = this.consigneePhoneNumber !== undefined ? this.consigneePhoneNumber : <any>null;
        data["transportCompanyAddress"] = this.transportCompanyAddress !== undefined ? this.transportCompanyAddress : <any>null;
        data["transportCompanyPhoneNumber"] = this.transportCompanyPhoneNumber !== undefined ? this.transportCompanyPhoneNumber : <any>null;
        data["additionalPackaging"] = this.additionalPackaging !== undefined ? this.additionalPackaging : <any>null;
        data["transportCompanyDeliveryCost"] = this.transportCompanyDeliveryCost !== undefined ? this.transportCompanyDeliveryCost : <any>null;
        data["managerDeliveryComment"] = this.managerDeliveryComment !== undefined ? this.managerDeliveryComment : <any>null;
        data["supplierOrderId"] = this.supplierOrderId !== undefined ? this.supplierOrderId : <any>null;
        data["incomingOrderNumber"] = this.incomingOrderNumber !== undefined ? this.incomingOrderNumber : <any>null;
        data["proxy"] = this.proxy !== undefined ? this.proxy : <any>null;
        data["calltouchSessionId"] = this.calltouchSessionId !== undefined ? this.calltouchSessionId : <any>null;
        data["calltouchOrderId"] = this.calltouchOrderId !== undefined ? this.calltouchOrderId : <any>null;
        data["orderSourceId"] = this.orderSourceId !== undefined ? this.orderSourceId : <any>null;
        data["fromMarketPlace"] = this.fromMarketPlace !== undefined ? this.fromMarketPlace : <any>null;
        data["shopId"] = this.shopId !== undefined ? this.shopId : <any>null;
        data["isCancelled"] = this.isCancelled !== undefined ? this.isCancelled : <any>null;
        data["deliveryDate"] = this.deliveryDate !== undefined ? this.deliveryDate : <any>null;
        data["deliveryInterval"] = this.deliveryInterval !== undefined ? this.deliveryInterval : <any>null;
        data["paymentFormUrl"] = this.paymentFormUrl !== undefined ? this.paymentFormUrl : <any>null;
        data["approximateReceiveDate"] = this.approximateReceiveDate !== undefined ? this.approximateReceiveDate : <any>null;
        data["approximateDeliveryDate"] = this.approximateDeliveryDate !== undefined ? this.approximateDeliveryDate : <any>null;
        return data; 
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    fullName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    fullAddress?: string | null;
    paymentMethod?: PaymentMethod;
    deliveryMethod?: DeliveryMethod;
    orderStatus?: OrderStatus;
    additionalInfo?: string | null;
    paymentOrderId?: string | null;
    city?: string | null;
    composition?: string | null;
    finalCost?: number;
    deliveryCost?: number;
    count?: number;
    orderNumber?: number;
    isPaid?: boolean;
    isAccepted?: boolean;
    isFinished?: boolean;
    userId?: string | null;
    invoiceUrl?: string | null;
    percentagePayment?: number | null;
    invoiceNumber?: string | null;
    shippingDate?: string | null;
    managerComment?: string | null;
    responsibleId?: string | null;
    deliveryRegionId?: string | null;
    deliveryCityId?: string | null;
    deliveryPhoneNumber?: string | null;
    liftingCost?: number;
    weight?: number;
    volume?: number;
    assembly?: string | null;
    consigneeFullName?: string | null;
    consigneePhoneNumber?: string | null;
    transportCompanyAddress?: string | null;
    transportCompanyPhoneNumber?: string | null;
    additionalPackaging?: string | null;
    transportCompanyDeliveryCost?: number;
    managerDeliveryComment?: string | null;
    supplierOrderId?: number | null;
    incomingOrderNumber?: string | null;
    proxy?: boolean;
    calltouchSessionId?: string | null;
    calltouchOrderId?: number | null;
    orderSourceId?: string | null;
    fromMarketPlace?: boolean;
    shopId?: string | null;
    isCancelled?: boolean;
    deliveryDate?: string | null;
    deliveryInterval?: string | null;
    paymentFormUrl?: string | null;
    approximateReceiveDate?: string | null;
    approximateDeliveryDate?: string | null;
}

export class TenantKanbanItem implements ITenantKanbanItem {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    entityId?: string;
    stageId?: string;
    kanbanType?: KanbanType;
    priority?: number;

    constructor(data?: ITenantKanbanItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.stageId = _data["stageId"] !== undefined ? _data["stageId"] : <any>null;
            this.kanbanType = _data["kanbanType"] !== undefined ? _data["kanbanType"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): TenantKanbanItem {
        data = typeof data === 'object' ? data : {};
        let result = new TenantKanbanItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["stageId"] = this.stageId !== undefined ? this.stageId : <any>null;
        data["kanbanType"] = this.kanbanType !== undefined ? this.kanbanType : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): TenantKanbanItem {
        const json = this.toJSON();
        let result = new TenantKanbanItem();
        result.init(json);
        return result;
    }
}

export interface ITenantKanbanItem {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    entityId?: string;
    stageId?: string;
    kanbanType?: KanbanType;
    priority?: number;
}

export class DetailedOrderModel implements IDetailedOrderModel {
    order?: Order;
    existInKanban?: boolean;
    kanbanItem?: TenantKanbanItem;
    stageList?: TenantKanbanStageDto[] | null;

    constructor(data?: IDetailedOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>null;
            this.existInKanban = _data["existInKanban"] !== undefined ? _data["existInKanban"] : <any>null;
            this.kanbanItem = _data["kanbanItem"] ? TenantKanbanItem.fromJS(_data["kanbanItem"]) : <any>null;
            if (Array.isArray(_data["stageList"])) {
                this.stageList = [] as any;
                for (let item of _data["stageList"])
                    this.stageList!.push(TenantKanbanStageDto.fromJS(item));
            }
            else {
                this.stageList = <any>null;
            }
        }
    }

    static fromJS(data: any): DetailedOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["existInKanban"] = this.existInKanban !== undefined ? this.existInKanban : <any>null;
        data["kanbanItem"] = this.kanbanItem ? this.kanbanItem.toJSON() : <any>null;
        if (Array.isArray(this.stageList)) {
            data["stageList"] = [];
            for (let item of this.stageList)
                data["stageList"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DetailedOrderModel {
        const json = this.toJSON();
        let result = new DetailedOrderModel();
        result.init(json);
        return result;
    }
}

export interface IDetailedOrderModel {
    order?: Order;
    existInKanban?: boolean;
    kanbanItem?: TenantKanbanItem;
    stageList?: TenantKanbanStageDto[] | null;
}

export enum OrderAttachmentType {
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export class OrderAttachment implements IOrderAttachment {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    attachmentType?: OrderAttachmentType;
    url?: string | null;
    mimeType?: string | null;
    size?: number;
    orderId?: string;
    initialFileName?: string | null;

    constructor(data?: IOrderAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.initialFileName = _data["initialFileName"] !== undefined ? _data["initialFileName"] : <any>null;
        }
    }

    static fromJS(data: any): OrderAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["initialFileName"] = this.initialFileName !== undefined ? this.initialFileName : <any>null;
        return data; 
    }

    clone(): OrderAttachment {
        const json = this.toJSON();
        let result = new OrderAttachment();
        result.init(json);
        return result;
    }
}

export interface IOrderAttachment {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    attachmentType?: OrderAttachmentType;
    url?: string | null;
    mimeType?: string | null;
    size?: number;
    orderId?: string;
    initialFileName?: string | null;
}

export class StolplitOrderExcelImportDto implements IStolplitOrderExcelImportDto {
    orderNumber?: string | null;
    articul?: string | null;
    address?: string | null;
    clientName?: string | null;
    count?: string | null;
    cost?: string | null;
    rowNumber?: number;

    constructor(data?: IStolplitOrderExcelImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.articul = _data["articul"] !== undefined ? _data["articul"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : <any>null;
        }
    }

    static fromJS(data: any): StolplitOrderExcelImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new StolplitOrderExcelImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["articul"] = this.articul !== undefined ? this.articul : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        return data; 
    }

    clone(): StolplitOrderExcelImportDto {
        const json = this.toJSON();
        let result = new StolplitOrderExcelImportDto();
        result.init(json);
        return result;
    }
}

export interface IStolplitOrderExcelImportDto {
    orderNumber?: string | null;
    articul?: string | null;
    address?: string | null;
    clientName?: string | null;
    count?: string | null;
    cost?: string | null;
    rowNumber?: number;
}

export class StolplitExcelImportValidationModel implements IStolplitExcelImportValidationModel {
    success?: boolean;
    errorMessage?: string | null;
    message?: string | null;
    infoMessage?: string | null;
    allowedDtoList?: StolplitOrderExcelImportDto[] | null;

    constructor(data?: IStolplitExcelImportValidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.infoMessage = _data["infoMessage"] !== undefined ? _data["infoMessage"] : <any>null;
            if (Array.isArray(_data["allowedDtoList"])) {
                this.allowedDtoList = [] as any;
                for (let item of _data["allowedDtoList"])
                    this.allowedDtoList!.push(StolplitOrderExcelImportDto.fromJS(item));
            }
            else {
                this.allowedDtoList = <any>null;
            }
        }
    }

    static fromJS(data: any): StolplitExcelImportValidationModel {
        data = typeof data === 'object' ? data : {};
        let result = new StolplitExcelImportValidationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["infoMessage"] = this.infoMessage !== undefined ? this.infoMessage : <any>null;
        if (Array.isArray(this.allowedDtoList)) {
            data["allowedDtoList"] = [];
            for (let item of this.allowedDtoList)
                data["allowedDtoList"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StolplitExcelImportValidationModel {
        const json = this.toJSON();
        let result = new StolplitExcelImportValidationModel();
        result.init(json);
        return result;
    }
}

export interface IStolplitExcelImportValidationModel {
    success?: boolean;
    errorMessage?: string | null;
    message?: string | null;
    infoMessage?: string | null;
    allowedDtoList?: StolplitOrderExcelImportDto[] | null;
}

export class ValidationModel implements IValidationModel {
    success?: boolean;
    errorMessage?: string | null;
    message?: string | null;

    constructor(data?: IValidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ValidationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data; 
    }

    clone(): ValidationModel {
        const json = this.toJSON();
        let result = new ValidationModel();
        result.init(json);
        return result;
    }
}

export interface IValidationModel {
    success?: boolean;
    errorMessage?: string | null;
    message?: string | null;
}

export class OrderSourceDto implements IOrderSourceDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;

    constructor(data?: IOrderSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): OrderSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data; 
    }

    clone(): OrderSourceDto {
        const json = this.toJSON();
        let result = new OrderSourceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSourceDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
}

export class OrderSource implements IOrderSource {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    code?: string | null;

    constructor(data?: IOrderSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): OrderSource {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data; 
    }

    clone(): OrderSource {
        const json = this.toJSON();
        let result = new OrderSource();
        result.init(json);
        return result;
    }
}

export interface IOrderSource {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    code?: string | null;
}

export class GoodOzonDto implements IGoodOzonDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;
    articul?: string | null;
    manufacturerId?: string | null;
    categoryId?: string | null;
    previewImage?: string | null;
    price?: number | null;
    priceUpRate?: number | null;
    oldPriceUpRate?: number | null;
    syncEnabled?: boolean | null;
    colorGroup?: string | null;
    color?: string | null;
    depth?: number | null;
    capacity?: number | null;
    material?: string | null;
    height?: number | null;
    width?: number | null;
    weight?: number | null;
    hideInCatalog?: boolean | null;
    nomenclatureStatus?: string | null;
    isBase?: boolean | null;
    features?: string | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;

    constructor(data?: IGoodOzonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.articul = _data["articul"] !== undefined ? _data["articul"] : <any>null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.previewImage = _data["previewImage"] !== undefined ? _data["previewImage"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.priceUpRate = _data["priceUpRate"] !== undefined ? _data["priceUpRate"] : <any>null;
            this.oldPriceUpRate = _data["oldPriceUpRate"] !== undefined ? _data["oldPriceUpRate"] : <any>null;
            this.syncEnabled = _data["syncEnabled"] !== undefined ? _data["syncEnabled"] : <any>null;
            this.colorGroup = _data["colorGroup"] !== undefined ? _data["colorGroup"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.hideInCatalog = _data["hideInCatalog"] !== undefined ? _data["hideInCatalog"] : <any>null;
            this.nomenclatureStatus = _data["nomenclatureStatus"] !== undefined ? _data["nomenclatureStatus"] : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            this.features = _data["features"] !== undefined ? _data["features"] : <any>null;
            this.exhibitionImages = _data["exhibitionImages"] !== undefined ? _data["exhibitionImages"] : <any>null;
            this.marketPlaceInclusions = _data["marketPlaceInclusions"] !== undefined ? _data["marketPlaceInclusions"] : <any>null;
        }
    }

    static fromJS(data: any): GoodOzonDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodOzonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["articul"] = this.articul !== undefined ? this.articul : <any>null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["previewImage"] = this.previewImage !== undefined ? this.previewImage : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["priceUpRate"] = this.priceUpRate !== undefined ? this.priceUpRate : <any>null;
        data["oldPriceUpRate"] = this.oldPriceUpRate !== undefined ? this.oldPriceUpRate : <any>null;
        data["syncEnabled"] = this.syncEnabled !== undefined ? this.syncEnabled : <any>null;
        data["colorGroup"] = this.colorGroup !== undefined ? this.colorGroup : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["hideInCatalog"] = this.hideInCatalog !== undefined ? this.hideInCatalog : <any>null;
        data["nomenclatureStatus"] = this.nomenclatureStatus !== undefined ? this.nomenclatureStatus : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        data["features"] = this.features !== undefined ? this.features : <any>null;
        data["exhibitionImages"] = this.exhibitionImages !== undefined ? this.exhibitionImages : <any>null;
        data["marketPlaceInclusions"] = this.marketPlaceInclusions !== undefined ? this.marketPlaceInclusions : <any>null;
        return data; 
    }

    clone(): GoodOzonDto {
        const json = this.toJSON();
        let result = new GoodOzonDto();
        result.init(json);
        return result;
    }
}

export interface IGoodOzonDto {
    id?: string | null;
    created?: string | null;
    title?: string | null;
    articul?: string | null;
    manufacturerId?: string | null;
    categoryId?: string | null;
    previewImage?: string | null;
    price?: number | null;
    priceUpRate?: number | null;
    oldPriceUpRate?: number | null;
    syncEnabled?: boolean | null;
    colorGroup?: string | null;
    color?: string | null;
    depth?: number | null;
    capacity?: number | null;
    material?: string | null;
    height?: number | null;
    width?: number | null;
    weight?: number | null;
    hideInCatalog?: boolean | null;
    nomenclatureStatus?: string | null;
    isBase?: boolean | null;
    features?: string | null;
    exhibitionImages?: string | null;
    marketPlaceInclusions?: string | null;
}

export class OzonWarehouseResponseItem implements IOzonWarehouseResponseItem {
    warehouseId?: number;
    name?: string | null;
    isRfbs?: boolean;
    isAbleToSetPrice?: boolean;
    hasEntrustedAcceptance?: boolean;
    isKgt?: boolean;
    canPrintActInAdvance?: boolean;
    minWorkingDays?: number;
    isKarantin?: boolean;
    hasPostingsLimit?: boolean;
    postingsLimit?: number;
    workingDays?: number[] | null;
    minPostingsLimit?: number;
    isTimetableEditable?: boolean;
    status?: string | null;

    constructor(data?: IOzonWarehouseResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isRfbs = _data["isRfbs"] !== undefined ? _data["isRfbs"] : <any>null;
            this.isAbleToSetPrice = _data["isAbleToSetPrice"] !== undefined ? _data["isAbleToSetPrice"] : <any>null;
            this.hasEntrustedAcceptance = _data["hasEntrustedAcceptance"] !== undefined ? _data["hasEntrustedAcceptance"] : <any>null;
            this.isKgt = _data["isKgt"] !== undefined ? _data["isKgt"] : <any>null;
            this.canPrintActInAdvance = _data["canPrintActInAdvance"] !== undefined ? _data["canPrintActInAdvance"] : <any>null;
            this.minWorkingDays = _data["minWorkingDays"] !== undefined ? _data["minWorkingDays"] : <any>null;
            this.isKarantin = _data["isKarantin"] !== undefined ? _data["isKarantin"] : <any>null;
            this.hasPostingsLimit = _data["hasPostingsLimit"] !== undefined ? _data["hasPostingsLimit"] : <any>null;
            this.postingsLimit = _data["postingsLimit"] !== undefined ? _data["postingsLimit"] : <any>null;
            if (Array.isArray(_data["workingDays"])) {
                this.workingDays = [] as any;
                for (let item of _data["workingDays"])
                    this.workingDays!.push(item);
            }
            else {
                this.workingDays = <any>null;
            }
            this.minPostingsLimit = _data["minPostingsLimit"] !== undefined ? _data["minPostingsLimit"] : <any>null;
            this.isTimetableEditable = _data["isTimetableEditable"] !== undefined ? _data["isTimetableEditable"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): OzonWarehouseResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new OzonWarehouseResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isRfbs"] = this.isRfbs !== undefined ? this.isRfbs : <any>null;
        data["isAbleToSetPrice"] = this.isAbleToSetPrice !== undefined ? this.isAbleToSetPrice : <any>null;
        data["hasEntrustedAcceptance"] = this.hasEntrustedAcceptance !== undefined ? this.hasEntrustedAcceptance : <any>null;
        data["isKgt"] = this.isKgt !== undefined ? this.isKgt : <any>null;
        data["canPrintActInAdvance"] = this.canPrintActInAdvance !== undefined ? this.canPrintActInAdvance : <any>null;
        data["minWorkingDays"] = this.minWorkingDays !== undefined ? this.minWorkingDays : <any>null;
        data["isKarantin"] = this.isKarantin !== undefined ? this.isKarantin : <any>null;
        data["hasPostingsLimit"] = this.hasPostingsLimit !== undefined ? this.hasPostingsLimit : <any>null;
        data["postingsLimit"] = this.postingsLimit !== undefined ? this.postingsLimit : <any>null;
        if (Array.isArray(this.workingDays)) {
            data["workingDays"] = [];
            for (let item of this.workingDays)
                data["workingDays"].push(item);
        }
        data["minPostingsLimit"] = this.minPostingsLimit !== undefined ? this.minPostingsLimit : <any>null;
        data["isTimetableEditable"] = this.isTimetableEditable !== undefined ? this.isTimetableEditable : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data; 
    }

    clone(): OzonWarehouseResponseItem {
        const json = this.toJSON();
        let result = new OzonWarehouseResponseItem();
        result.init(json);
        return result;
    }
}

export interface IOzonWarehouseResponseItem {
    warehouseId?: number;
    name?: string | null;
    isRfbs?: boolean;
    isAbleToSetPrice?: boolean;
    hasEntrustedAcceptance?: boolean;
    isKgt?: boolean;
    canPrintActInAdvance?: boolean;
    minWorkingDays?: number;
    isKarantin?: boolean;
    hasPostingsLimit?: boolean;
    postingsLimit?: number;
    workingDays?: number[] | null;
    minPostingsLimit?: number;
    isTimetableEditable?: boolean;
    status?: string | null;
}

export class PageSeoOptionDto implements IPageSeoOptionDto {
    created?: string | null;
    id?: string | null;
    url?: string | null;
    title?: string | null;
    description?: string | null;
    header?: string | null;
    text?: string | null;
    keywords?: string | null;
    categoryId?: string | null;
    lockedForIndex?: boolean | null;
    isCatalogPage?: boolean | null;
    imageAlt?: string | null;
    imageTitle?: string | null;
    humanUrl?: string | null;

    constructor(data?: IPageSeoOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.lockedForIndex = _data["lockedForIndex"] !== undefined ? _data["lockedForIndex"] : <any>null;
            this.isCatalogPage = _data["isCatalogPage"] !== undefined ? _data["isCatalogPage"] : <any>null;
            this.imageAlt = _data["imageAlt"] !== undefined ? _data["imageAlt"] : <any>null;
            this.imageTitle = _data["imageTitle"] !== undefined ? _data["imageTitle"] : <any>null;
            this.humanUrl = _data["humanUrl"] !== undefined ? _data["humanUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PageSeoOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSeoOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["lockedForIndex"] = this.lockedForIndex !== undefined ? this.lockedForIndex : <any>null;
        data["isCatalogPage"] = this.isCatalogPage !== undefined ? this.isCatalogPage : <any>null;
        data["imageAlt"] = this.imageAlt !== undefined ? this.imageAlt : <any>null;
        data["imageTitle"] = this.imageTitle !== undefined ? this.imageTitle : <any>null;
        data["humanUrl"] = this.humanUrl !== undefined ? this.humanUrl : <any>null;
        return data; 
    }

    clone(): PageSeoOptionDto {
        const json = this.toJSON();
        let result = new PageSeoOptionDto();
        result.init(json);
        return result;
    }
}

export interface IPageSeoOptionDto {
    created?: string | null;
    id?: string | null;
    url?: string | null;
    title?: string | null;
    description?: string | null;
    header?: string | null;
    text?: string | null;
    keywords?: string | null;
    categoryId?: string | null;
    lockedForIndex?: boolean | null;
    isCatalogPage?: boolean | null;
    imageAlt?: string | null;
    imageTitle?: string | null;
    humanUrl?: string | null;
}

export class PageSeoOption implements IPageSeoOption {
    id?: string;
    created?: string;
    modified?: string | null;
    url?: string | null;
    categoryId?: string | null;
    title?: string | null;
    description?: string | null;
    header?: string | null;
    text?: string | null;
    keywords?: string | null;
    lockedForIndex?: boolean;
    isCatalogPage?: boolean;
    imageAlt?: string | null;
    imageTitle?: string | null;
    humanUrl?: string | null;

    constructor(data?: IPageSeoOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : <any>null;
            this.lockedForIndex = _data["lockedForIndex"] !== undefined ? _data["lockedForIndex"] : <any>null;
            this.isCatalogPage = _data["isCatalogPage"] !== undefined ? _data["isCatalogPage"] : <any>null;
            this.imageAlt = _data["imageAlt"] !== undefined ? _data["imageAlt"] : <any>null;
            this.imageTitle = _data["imageTitle"] !== undefined ? _data["imageTitle"] : <any>null;
            this.humanUrl = _data["humanUrl"] !== undefined ? _data["humanUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PageSeoOption {
        data = typeof data === 'object' ? data : {};
        let result = new PageSeoOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : <any>null;
        data["lockedForIndex"] = this.lockedForIndex !== undefined ? this.lockedForIndex : <any>null;
        data["isCatalogPage"] = this.isCatalogPage !== undefined ? this.isCatalogPage : <any>null;
        data["imageAlt"] = this.imageAlt !== undefined ? this.imageAlt : <any>null;
        data["imageTitle"] = this.imageTitle !== undefined ? this.imageTitle : <any>null;
        data["humanUrl"] = this.humanUrl !== undefined ? this.humanUrl : <any>null;
        return data; 
    }

    clone(): PageSeoOption {
        const json = this.toJSON();
        let result = new PageSeoOption();
        result.init(json);
        return result;
    }
}

export interface IPageSeoOption {
    id?: string;
    created?: string;
    modified?: string | null;
    url?: string | null;
    categoryId?: string | null;
    title?: string | null;
    description?: string | null;
    header?: string | null;
    text?: string | null;
    keywords?: string | null;
    lockedForIndex?: boolean;
    isCatalogPage?: boolean;
    imageAlt?: string | null;
    imageTitle?: string | null;
    humanUrl?: string | null;
}

export class PaymentSystemDto implements IPaymentSystemDto {
    paymentSystem?: PaymentSystem;
    title?: string | null;

    constructor(data?: IPaymentSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentSystem = _data["paymentSystem"] !== undefined ? _data["paymentSystem"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentSystem"] = this.paymentSystem !== undefined ? this.paymentSystem : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }

    clone(): PaymentSystemDto {
        const json = this.toJSON();
        let result = new PaymentSystemDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentSystemDto {
    paymentSystem?: PaymentSystem;
    title?: string | null;
}

export class SelectionTypeDto implements ISelectionTypeDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    created?: string | null;
    priority?: number | null;

    constructor(data?: ISelectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): SelectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): SelectionTypeDto {
        const json = this.toJSON();
        let result = new SelectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionTypeDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    created?: string | null;
    priority?: number | null;
}

export class GoodSelectionType implements IGoodSelectionType {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    code?: string | null;
    priority?: number;

    constructor(data?: IGoodSelectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): GoodSelectionType {
        data = typeof data === 'object' ? data : {};
        let result = new GoodSelectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data; 
    }

    clone(): GoodSelectionType {
        const json = this.toJSON();
        let result = new GoodSelectionType();
        result.init(json);
        return result;
    }
}

export interface IGoodSelectionType {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    code?: string | null;
    priority?: number;
}

export class SitemapManualUrlDto implements ISitemapManualUrlDto {
    created?: string | null;
    id?: string | null;
    url?: string | null;
    shouldRemove?: boolean | null;

    constructor(data?: ISitemapManualUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.shouldRemove = _data["shouldRemove"] !== undefined ? _data["shouldRemove"] : <any>null;
        }
    }

    static fromJS(data: any): SitemapManualUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new SitemapManualUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["shouldRemove"] = this.shouldRemove !== undefined ? this.shouldRemove : <any>null;
        return data; 
    }

    clone(): SitemapManualUrlDto {
        const json = this.toJSON();
        let result = new SitemapManualUrlDto();
        result.init(json);
        return result;
    }
}

export interface ISitemapManualUrlDto {
    created?: string | null;
    id?: string | null;
    url?: string | null;
    shouldRemove?: boolean | null;
}

export class SitemapManualUrl implements ISitemapManualUrl {
    id?: string;
    created?: string;
    modified?: string | null;
    url?: string | null;
    shouldRemove?: boolean;

    constructor(data?: ISitemapManualUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.shouldRemove = _data["shouldRemove"] !== undefined ? _data["shouldRemove"] : <any>null;
        }
    }

    static fromJS(data: any): SitemapManualUrl {
        data = typeof data === 'object' ? data : {};
        let result = new SitemapManualUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["shouldRemove"] = this.shouldRemove !== undefined ? this.shouldRemove : <any>null;
        return data; 
    }

    clone(): SitemapManualUrl {
        const json = this.toJSON();
        let result = new SitemapManualUrl();
        result.init(json);
        return result;
    }
}

export interface ISitemapManualUrl {
    id?: string;
    created?: string;
    modified?: string | null;
    url?: string | null;
    shouldRemove?: boolean;
}

export enum RealizationDeliveryMethod {
    _1 = 1,
    _2 = 2,
}

export class NewRealizationRequestParameters implements INewRealizationRequestParameters {
    shippingDate?: string | null;
    orderIds?: string[] | null;
    comment?: string | null;
    deliveryMethod?: RealizationDeliveryMethod;

    constructor(data?: INewRealizationRequestParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shippingDate = _data["shippingDate"] !== undefined ? _data["shippingDate"] : <any>null;
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            else {
                this.orderIds = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.deliveryMethod = _data["deliveryMethod"] !== undefined ? _data["deliveryMethod"] : <any>null;
        }
    }

    static fromJS(data: any): NewRealizationRequestParameters {
        data = typeof data === 'object' ? data : {};
        let result = new NewRealizationRequestParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shippingDate"] = this.shippingDate !== undefined ? this.shippingDate : <any>null;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["deliveryMethod"] = this.deliveryMethod !== undefined ? this.deliveryMethod : <any>null;
        return data; 
    }

    clone(): NewRealizationRequestParameters {
        const json = this.toJSON();
        let result = new NewRealizationRequestParameters();
        result.init(json);
        return result;
    }
}

export interface INewRealizationRequestParameters {
    shippingDate?: string | null;
    orderIds?: string[] | null;
    comment?: string | null;
    deliveryMethod?: RealizationDeliveryMethod;
}

export class GetCityInfoResponse implements IGetCityInfoResponse {
    contact?: HtmlResponse;
    delivery?: HtmlResponse;

    constructor(data?: IGetCityInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? HtmlResponse.fromJS(_data["contact"]) : <any>null;
            this.delivery = _data["delivery"] ? HtmlResponse.fromJS(_data["delivery"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCityInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : <any>null;
        return data; 
    }

    clone(): GetCityInfoResponse {
        const json = this.toJSON();
        let result = new GetCityInfoResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCityInfoResponse {
    contact?: HtmlResponse;
    delivery?: HtmlResponse;
}

export class TenantSeoDto implements ITenantSeoDto {
    id?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    mainPageSeoBlock?: string | null;

    constructor(data?: ITenantSeoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.categoryMetaTitlePattern = _data["categoryMetaTitlePattern"] !== undefined ? _data["categoryMetaTitlePattern"] : <any>null;
            this.categoryMetaDescriptionPattern = _data["categoryMetaDescriptionPattern"] !== undefined ? _data["categoryMetaDescriptionPattern"] : <any>null;
            this.goodMetaTitlePattern = _data["goodMetaTitlePattern"] !== undefined ? _data["goodMetaTitlePattern"] : <any>null;
            this.goodMetaDescriptionPattern = _data["goodMetaDescriptionPattern"] !== undefined ? _data["goodMetaDescriptionPattern"] : <any>null;
            this.mainPageSeoBlock = _data["mainPageSeoBlock"] !== undefined ? _data["mainPageSeoBlock"] : <any>null;
        }
    }

    static fromJS(data: any): TenantSeoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSeoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["categoryMetaTitlePattern"] = this.categoryMetaTitlePattern !== undefined ? this.categoryMetaTitlePattern : <any>null;
        data["categoryMetaDescriptionPattern"] = this.categoryMetaDescriptionPattern !== undefined ? this.categoryMetaDescriptionPattern : <any>null;
        data["goodMetaTitlePattern"] = this.goodMetaTitlePattern !== undefined ? this.goodMetaTitlePattern : <any>null;
        data["goodMetaDescriptionPattern"] = this.goodMetaDescriptionPattern !== undefined ? this.goodMetaDescriptionPattern : <any>null;
        data["mainPageSeoBlock"] = this.mainPageSeoBlock !== undefined ? this.mainPageSeoBlock : <any>null;
        return data; 
    }

    clone(): TenantSeoDto {
        const json = this.toJSON();
        let result = new TenantSeoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantSeoDto {
    id?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    mainPageSeoBlock?: string | null;
}

export class NikaPartnerInfo implements INikaPartnerInfo {
    id?: string;
    created?: string;
    modified?: string | null;
    xmlId?: string;
    agreementXmlId?: string;
    partnerName?: string | null;
    priceRate?: number;

    constructor(data?: INikaPartnerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.xmlId = _data["xmlId"] !== undefined ? _data["xmlId"] : <any>null;
            this.agreementXmlId = _data["agreementXmlId"] !== undefined ? _data["agreementXmlId"] : <any>null;
            this.partnerName = _data["partnerName"] !== undefined ? _data["partnerName"] : <any>null;
            this.priceRate = _data["priceRate"] !== undefined ? _data["priceRate"] : <any>null;
        }
    }

    static fromJS(data: any): NikaPartnerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NikaPartnerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["xmlId"] = this.xmlId !== undefined ? this.xmlId : <any>null;
        data["agreementXmlId"] = this.agreementXmlId !== undefined ? this.agreementXmlId : <any>null;
        data["partnerName"] = this.partnerName !== undefined ? this.partnerName : <any>null;
        data["priceRate"] = this.priceRate !== undefined ? this.priceRate : <any>null;
        return data; 
    }

    clone(): NikaPartnerInfo {
        const json = this.toJSON();
        let result = new NikaPartnerInfo();
        result.init(json);
        return result;
    }
}

export interface INikaPartnerInfo {
    id?: string;
    created?: string;
    modified?: string | null;
    xmlId?: string;
    agreementXmlId?: string;
    partnerName?: string | null;
    priceRate?: number;
}

export class TenantActionSetupDto implements ITenantActionSetupDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    allowedInterval?: number | null;
    allowedEmergencyCalls?: number | null;

    constructor(data?: ITenantActionSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.allowedInterval = _data["allowedInterval"] !== undefined ? _data["allowedInterval"] : <any>null;
            this.allowedEmergencyCalls = _data["allowedEmergencyCalls"] !== undefined ? _data["allowedEmergencyCalls"] : <any>null;
        }
    }

    static fromJS(data: any): TenantActionSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantActionSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["allowedInterval"] = this.allowedInterval !== undefined ? this.allowedInterval : <any>null;
        data["allowedEmergencyCalls"] = this.allowedEmergencyCalls !== undefined ? this.allowedEmergencyCalls : <any>null;
        return data; 
    }

    clone(): TenantActionSetupDto {
        const json = this.toJSON();
        let result = new TenantActionSetupDto();
        result.init(json);
        return result;
    }
}

export interface ITenantActionSetupDto {
    id?: string | null;
    title?: string | null;
    code?: string | null;
    allowedInterval?: number | null;
    allowedEmergencyCalls?: number | null;
}

export class TenantActionSetup implements ITenantActionSetup {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    code?: string | null;
    allowedInterval?: number;
    allowedEmergencyCalls?: number;

    constructor(data?: ITenantActionSetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.allowedInterval = _data["allowedInterval"] !== undefined ? _data["allowedInterval"] : <any>null;
            this.allowedEmergencyCalls = _data["allowedEmergencyCalls"] !== undefined ? _data["allowedEmergencyCalls"] : <any>null;
        }
    }

    static fromJS(data: any): TenantActionSetup {
        data = typeof data === 'object' ? data : {};
        let result = new TenantActionSetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["allowedInterval"] = this.allowedInterval !== undefined ? this.allowedInterval : <any>null;
        data["allowedEmergencyCalls"] = this.allowedEmergencyCalls !== undefined ? this.allowedEmergencyCalls : <any>null;
        return data; 
    }

    clone(): TenantActionSetup {
        const json = this.toJSON();
        let result = new TenantActionSetup();
        result.init(json);
        return result;
    }
}

export interface ITenantActionSetup {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    code?: string | null;
    allowedInterval?: number;
    allowedEmergencyCalls?: number;
}

export class TenantCategoryTextDto implements ITenantCategoryTextDto {
    id?: string | null;
    cityId?: string;
    categoryId?: string;
    text?: string | null;

    constructor(data?: ITenantCategoryTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): TenantCategoryTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCategoryTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data; 
    }

    clone(): TenantCategoryTextDto {
        const json = this.toJSON();
        let result = new TenantCategoryTextDto();
        result.init(json);
        return result;
    }
}

export interface ITenantCategoryTextDto {
    id?: string | null;
    cityId?: string;
    categoryId?: string;
    text?: string | null;
}

export class TenantCategoryText implements ITenantCategoryText {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    cityId?: string;
    categoryId?: string;
    text?: string | null;

    constructor(data?: ITenantCategoryText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): TenantCategoryText {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCategoryText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data; 
    }

    clone(): TenantCategoryText {
        const json = this.toJSON();
        let result = new TenantCategoryText();
        result.init(json);
        return result;
    }
}

export interface ITenantCategoryText {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    cityId?: string;
    categoryId?: string;
    text?: string | null;
}

export enum EmailSendEvent {
    _100 = 100,
    _200 = 200,
    _300 = 300,
    _400 = 400,
}

export class TenantInboundEmailDto implements ITenantInboundEmailDto {
    id?: string | null;
    email?: string | null;
    emailSendEvent?: EmailSendEvent;

    constructor(data?: ITenantInboundEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.emailSendEvent = _data["emailSendEvent"] !== undefined ? _data["emailSendEvent"] : <any>null;
        }
    }

    static fromJS(data: any): TenantInboundEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInboundEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["emailSendEvent"] = this.emailSendEvent !== undefined ? this.emailSendEvent : <any>null;
        return data; 
    }

    clone(): TenantInboundEmailDto {
        const json = this.toJSON();
        let result = new TenantInboundEmailDto();
        result.init(json);
        return result;
    }
}

export interface ITenantInboundEmailDto {
    id?: string | null;
    email?: string | null;
    emailSendEvent?: EmailSendEvent;
}

export class TenantInboundEmail implements ITenantInboundEmail {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    email?: string | null;
    emailSendEvent?: EmailSendEvent;

    constructor(data?: ITenantInboundEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.emailSendEvent = _data["emailSendEvent"] !== undefined ? _data["emailSendEvent"] : <any>null;
        }
    }

    static fromJS(data: any): TenantInboundEmail {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInboundEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["emailSendEvent"] = this.emailSendEvent !== undefined ? this.emailSendEvent : <any>null;
        return data; 
    }

    clone(): TenantInboundEmail {
        const json = this.toJSON();
        let result = new TenantInboundEmail();
        result.init(json);
        return result;
    }
}

export interface ITenantInboundEmail {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    email?: string | null;
    emailSendEvent?: EmailSendEvent;
}

export class TenantSeoAttribute implements ITenantSeoAttribute {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    path?: string | null;
    metaHeader?: string | null;
    metaTitle?: string | null;
    metaDescription?: string | null;

    constructor(data?: ITenantSeoAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.metaHeader = _data["metaHeader"] !== undefined ? _data["metaHeader"] : <any>null;
            this.metaTitle = _data["metaTitle"] !== undefined ? _data["metaTitle"] : <any>null;
            this.metaDescription = _data["metaDescription"] !== undefined ? _data["metaDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TenantSeoAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSeoAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["metaHeader"] = this.metaHeader !== undefined ? this.metaHeader : <any>null;
        data["metaTitle"] = this.metaTitle !== undefined ? this.metaTitle : <any>null;
        data["metaDescription"] = this.metaDescription !== undefined ? this.metaDescription : <any>null;
        return data; 
    }

    clone(): TenantSeoAttribute {
        const json = this.toJSON();
        let result = new TenantSeoAttribute();
        result.init(json);
        return result;
    }
}

export interface ITenantSeoAttribute {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    title?: string | null;
    path?: string | null;
    metaHeader?: string | null;
    metaTitle?: string | null;
    metaDescription?: string | null;
}

export class TenantWarehouseRestDto implements ITenantWarehouseRestDto {
    warehouseId?: string;
    goodId?: string;
    amount?: number | null;
    mpAmount?: number | null;
    warehouseTitle?: string | null;
    goodTitle?: string | null;
    price?: number | null;
    videoUrl?: string | null;
    imagesUrls?: string | null;
    readonly key?: string | null;

    constructor(data?: ITenantWarehouseRestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.mpAmount = _data["mpAmount"] !== undefined ? _data["mpAmount"] : <any>null;
            this.warehouseTitle = _data["warehouseTitle"] !== undefined ? _data["warehouseTitle"] : <any>null;
            this.goodTitle = _data["goodTitle"] !== undefined ? _data["goodTitle"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.videoUrl = _data["videoUrl"] !== undefined ? _data["videoUrl"] : <any>null;
            this.imagesUrls = _data["imagesUrls"] !== undefined ? _data["imagesUrls"] : <any>null;
            (<any>this).key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data: any): TenantWarehouseRestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWarehouseRestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["mpAmount"] = this.mpAmount !== undefined ? this.mpAmount : <any>null;
        data["warehouseTitle"] = this.warehouseTitle !== undefined ? this.warehouseTitle : <any>null;
        data["goodTitle"] = this.goodTitle !== undefined ? this.goodTitle : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["videoUrl"] = this.videoUrl !== undefined ? this.videoUrl : <any>null;
        data["imagesUrls"] = this.imagesUrls !== undefined ? this.imagesUrls : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data; 
    }

    clone(): TenantWarehouseRestDto {
        const json = this.toJSON();
        let result = new TenantWarehouseRestDto();
        result.init(json);
        return result;
    }
}

export interface ITenantWarehouseRestDto {
    warehouseId?: string;
    goodId?: string;
    amount?: number | null;
    mpAmount?: number | null;
    warehouseTitle?: string | null;
    goodTitle?: string | null;
    price?: number | null;
    videoUrl?: string | null;
    imagesUrls?: string | null;
    key?: string | null;
}

export class TenantWarehouseRest implements ITenantWarehouseRest {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    warehouseId?: string;
    goodId?: string;
    amount?: number;
    mpAmount?: number;
    price?: number;
    videoUrl?: string | null;
    imagesUrls?: string | null;

    constructor(data?: ITenantWarehouseRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : <any>null;
            this.goodId = _data["goodId"] !== undefined ? _data["goodId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.mpAmount = _data["mpAmount"] !== undefined ? _data["mpAmount"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.videoUrl = _data["videoUrl"] !== undefined ? _data["videoUrl"] : <any>null;
            this.imagesUrls = _data["imagesUrls"] !== undefined ? _data["imagesUrls"] : <any>null;
        }
    }

    static fromJS(data: any): TenantWarehouseRest {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWarehouseRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["warehouseId"] = this.warehouseId !== undefined ? this.warehouseId : <any>null;
        data["goodId"] = this.goodId !== undefined ? this.goodId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["mpAmount"] = this.mpAmount !== undefined ? this.mpAmount : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["videoUrl"] = this.videoUrl !== undefined ? this.videoUrl : <any>null;
        data["imagesUrls"] = this.imagesUrls !== undefined ? this.imagesUrls : <any>null;
        return data; 
    }

    clone(): TenantWarehouseRest {
        const json = this.toJSON();
        let result = new TenantWarehouseRest();
        result.init(json);
        return result;
    }
}

export interface ITenantWarehouseRest {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    warehouseId?: string;
    goodId?: string;
    amount?: number;
    mpAmount?: number;
    price?: number;
    videoUrl?: string | null;
    imagesUrls?: string | null;
}

export class CallUserInfo implements ICallUserInfo {
    contact?: ContactDto;
    orders?: OrderDto[] | null;

    constructor(data?: ICallUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>null;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderDto.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
        }
    }

    static fromJS(data: any): CallUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CallUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CallUserInfo {
        const json = this.toJSON();
        let result = new CallUserInfo();
        result.init(json);
        return result;
    }
}

export interface ICallUserInfo {
    contact?: ContactDto;
    orders?: OrderDto[] | null;
}

export class UserDto implements IUserDto {
    id?: string | null;
    username?: string | null;
    email?: string | null;
    hasAccess?: boolean | null;
    tenantId?: string | null;
    password?: string | null;
    firstName?: string | null;
    created?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    deliveryAddress?: string | null;
    avatar?: string | null;
    role?: string | null;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.hasAccess = _data["hasAccess"] !== undefined ? _data["hasAccess"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.avatar = _data["avatar"] !== undefined ? _data["avatar"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["hasAccess"] = this.hasAccess !== undefined ? this.hasAccess : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["avatar"] = this.avatar !== undefined ? this.avatar : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id?: string | null;
    username?: string | null;
    email?: string | null;
    hasAccess?: boolean | null;
    tenantId?: string | null;
    password?: string | null;
    firstName?: string | null;
    created?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    deliveryAddress?: string | null;
    avatar?: string | null;
    role?: string | null;
}

export class Tenant implements ITenant {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    code?: string | null;
    login?: string | null;
    password?: string | null;
    isActive?: boolean;
    sitePhoneNumber?: string | null;
    siteWorkSchedule?: string | null;
    siteLogo?: string | null;
    siteTitle?: string | null;
    paymentSystem?: PaymentSystem;
    inboundEmail?: string | null;
    defaultPriceUpRate?: number;
    rewiewsPageInnerHtml?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    deliveryPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    deliveryPageRawHtml?: string | null;
    contactPageRawHtml?: string | null;
    privacyPolicyPageRawHtml?: string | null;
    termsOfUsePageRawHtml?: string | null;
    aboutPageRawHtml?: string | null;
    returnPageRawHtml?: string | null;
    requisitesPageRawHtml?: string | null;
    guaranteePageRawHtml?: string | null;
    publicOfferPageRawHtml?: string | null;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    credentials?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    cashDisabled?: boolean;
    bankCardDisabled?: boolean;
    onlineDisabled?: boolean;
    legalEntityDisabled?: boolean;
    dynamicScripts?: string | null;
    dynamicHeadScripts?: string | null;
    mainPageSeoBlock?: string | null;
    mainUrl?: string | null;
    roundType?: RoundType;
    siteConnected?: boolean;
    marketPlaceConnected?: boolean;
    nikaConnected?: boolean;
    claims?: string | null;
    marketPlaceInclusions?: string | null;
    calltouchAccessToken?: string | null;
    calltouchSiteId?: string | null;
    defaultWarehouseId?: string | null;
    nikaPartnerInfoId?: string | null;
    ozonApiKey?: string | null;
    ozonClientId?: string | null;
    ozonWarehouseId?: number | null;
    ozonIntegrationEnabled?: boolean;
    externalConstructorLink?: string | null;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.sitePhoneNumber = _data["sitePhoneNumber"] !== undefined ? _data["sitePhoneNumber"] : <any>null;
            this.siteWorkSchedule = _data["siteWorkSchedule"] !== undefined ? _data["siteWorkSchedule"] : <any>null;
            this.siteLogo = _data["siteLogo"] !== undefined ? _data["siteLogo"] : <any>null;
            this.siteTitle = _data["siteTitle"] !== undefined ? _data["siteTitle"] : <any>null;
            this.paymentSystem = _data["paymentSystem"] !== undefined ? _data["paymentSystem"] : <any>null;
            this.inboundEmail = _data["inboundEmail"] !== undefined ? _data["inboundEmail"] : <any>null;
            this.defaultPriceUpRate = _data["defaultPriceUpRate"] !== undefined ? _data["defaultPriceUpRate"] : <any>null;
            this.rewiewsPageInnerHtml = _data["rewiewsPageInnerHtml"] !== undefined ? _data["rewiewsPageInnerHtml"] : <any>null;
            this.telegramLink = _data["telegramLink"] !== undefined ? _data["telegramLink"] : <any>null;
            this.instagramLink = _data["instagramLink"] !== undefined ? _data["instagramLink"] : <any>null;
            this.vkLink = _data["vkLink"] !== undefined ? _data["vkLink"] : <any>null;
            this.okLink = _data["okLink"] !== undefined ? _data["okLink"] : <any>null;
            this.facebookLink = _data["facebookLink"] !== undefined ? _data["facebookLink"] : <any>null;
            this.twitterLink = _data["twitterLink"] !== undefined ? _data["twitterLink"] : <any>null;
            this.youTubeLink = _data["youTubeLink"] !== undefined ? _data["youTubeLink"] : <any>null;
            this.deliveryPageInnerHtml = _data["deliveryPageInnerHtml"] !== undefined ? _data["deliveryPageInnerHtml"] : <any>null;
            this.contactPageInnerHtml = _data["contactPageInnerHtml"] !== undefined ? _data["contactPageInnerHtml"] : <any>null;
            this.privacyPolicyPageInnerHtml = _data["privacyPolicyPageInnerHtml"] !== undefined ? _data["privacyPolicyPageInnerHtml"] : <any>null;
            this.termsOfUsePageInnerHtml = _data["termsOfUsePageInnerHtml"] !== undefined ? _data["termsOfUsePageInnerHtml"] : <any>null;
            this.aboutPageInnerHtml = _data["aboutPageInnerHtml"] !== undefined ? _data["aboutPageInnerHtml"] : <any>null;
            this.returnPageInnerHtml = _data["returnPageInnerHtml"] !== undefined ? _data["returnPageInnerHtml"] : <any>null;
            this.requisitesPageInnerHtml = _data["requisitesPageInnerHtml"] !== undefined ? _data["requisitesPageInnerHtml"] : <any>null;
            this.guaranteePageInnerHtml = _data["guaranteePageInnerHtml"] !== undefined ? _data["guaranteePageInnerHtml"] : <any>null;
            this.publicOfferPageInnerHtml = _data["publicOfferPageInnerHtml"] !== undefined ? _data["publicOfferPageInnerHtml"] : <any>null;
            this.deliveryPageRawHtml = _data["deliveryPageRawHtml"] !== undefined ? _data["deliveryPageRawHtml"] : <any>null;
            this.contactPageRawHtml = _data["contactPageRawHtml"] !== undefined ? _data["contactPageRawHtml"] : <any>null;
            this.privacyPolicyPageRawHtml = _data["privacyPolicyPageRawHtml"] !== undefined ? _data["privacyPolicyPageRawHtml"] : <any>null;
            this.termsOfUsePageRawHtml = _data["termsOfUsePageRawHtml"] !== undefined ? _data["termsOfUsePageRawHtml"] : <any>null;
            this.aboutPageRawHtml = _data["aboutPageRawHtml"] !== undefined ? _data["aboutPageRawHtml"] : <any>null;
            this.returnPageRawHtml = _data["returnPageRawHtml"] !== undefined ? _data["returnPageRawHtml"] : <any>null;
            this.requisitesPageRawHtml = _data["requisitesPageRawHtml"] !== undefined ? _data["requisitesPageRawHtml"] : <any>null;
            this.guaranteePageRawHtml = _data["guaranteePageRawHtml"] !== undefined ? _data["guaranteePageRawHtml"] : <any>null;
            this.publicOfferPageRawHtml = _data["publicOfferPageRawHtml"] !== undefined ? _data["publicOfferPageRawHtml"] : <any>null;
            this.mainColor = _data["mainColor"] !== undefined ? _data["mainColor"] : <any>null;
            this.secondColor = _data["secondColor"] !== undefined ? _data["secondColor"] : <any>null;
            this.faviconIcon = _data["faviconIcon"] !== undefined ? _data["faviconIcon"] : <any>null;
            this.credentials = _data["credentials"] !== undefined ? _data["credentials"] : <any>null;
            this.categoryMetaTitlePattern = _data["categoryMetaTitlePattern"] !== undefined ? _data["categoryMetaTitlePattern"] : <any>null;
            this.categoryMetaDescriptionPattern = _data["categoryMetaDescriptionPattern"] !== undefined ? _data["categoryMetaDescriptionPattern"] : <any>null;
            this.goodMetaTitlePattern = _data["goodMetaTitlePattern"] !== undefined ? _data["goodMetaTitlePattern"] : <any>null;
            this.goodMetaDescriptionPattern = _data["goodMetaDescriptionPattern"] !== undefined ? _data["goodMetaDescriptionPattern"] : <any>null;
            this.cashDisabled = _data["cashDisabled"] !== undefined ? _data["cashDisabled"] : <any>null;
            this.bankCardDisabled = _data["bankCardDisabled"] !== undefined ? _data["bankCardDisabled"] : <any>null;
            this.onlineDisabled = _data["onlineDisabled"] !== undefined ? _data["onlineDisabled"] : <any>null;
            this.legalEntityDisabled = _data["legalEntityDisabled"] !== undefined ? _data["legalEntityDisabled"] : <any>null;
            this.dynamicScripts = _data["dynamicScripts"] !== undefined ? _data["dynamicScripts"] : <any>null;
            this.dynamicHeadScripts = _data["dynamicHeadScripts"] !== undefined ? _data["dynamicHeadScripts"] : <any>null;
            this.mainPageSeoBlock = _data["mainPageSeoBlock"] !== undefined ? _data["mainPageSeoBlock"] : <any>null;
            this.mainUrl = _data["mainUrl"] !== undefined ? _data["mainUrl"] : <any>null;
            this.roundType = _data["roundType"] !== undefined ? _data["roundType"] : <any>null;
            this.siteConnected = _data["siteConnected"] !== undefined ? _data["siteConnected"] : <any>null;
            this.marketPlaceConnected = _data["marketPlaceConnected"] !== undefined ? _data["marketPlaceConnected"] : <any>null;
            this.nikaConnected = _data["nikaConnected"] !== undefined ? _data["nikaConnected"] : <any>null;
            this.claims = _data["claims"] !== undefined ? _data["claims"] : <any>null;
            this.marketPlaceInclusions = _data["marketPlaceInclusions"] !== undefined ? _data["marketPlaceInclusions"] : <any>null;
            this.calltouchAccessToken = _data["calltouchAccessToken"] !== undefined ? _data["calltouchAccessToken"] : <any>null;
            this.calltouchSiteId = _data["calltouchSiteId"] !== undefined ? _data["calltouchSiteId"] : <any>null;
            this.defaultWarehouseId = _data["defaultWarehouseId"] !== undefined ? _data["defaultWarehouseId"] : <any>null;
            this.nikaPartnerInfoId = _data["nikaPartnerInfoId"] !== undefined ? _data["nikaPartnerInfoId"] : <any>null;
            this.ozonApiKey = _data["ozonApiKey"] !== undefined ? _data["ozonApiKey"] : <any>null;
            this.ozonClientId = _data["ozonClientId"] !== undefined ? _data["ozonClientId"] : <any>null;
            this.ozonWarehouseId = _data["ozonWarehouseId"] !== undefined ? _data["ozonWarehouseId"] : <any>null;
            this.ozonIntegrationEnabled = _data["ozonIntegrationEnabled"] !== undefined ? _data["ozonIntegrationEnabled"] : <any>null;
            this.externalConstructorLink = _data["externalConstructorLink"] !== undefined ? _data["externalConstructorLink"] : <any>null;
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["sitePhoneNumber"] = this.sitePhoneNumber !== undefined ? this.sitePhoneNumber : <any>null;
        data["siteWorkSchedule"] = this.siteWorkSchedule !== undefined ? this.siteWorkSchedule : <any>null;
        data["siteLogo"] = this.siteLogo !== undefined ? this.siteLogo : <any>null;
        data["siteTitle"] = this.siteTitle !== undefined ? this.siteTitle : <any>null;
        data["paymentSystem"] = this.paymentSystem !== undefined ? this.paymentSystem : <any>null;
        data["inboundEmail"] = this.inboundEmail !== undefined ? this.inboundEmail : <any>null;
        data["defaultPriceUpRate"] = this.defaultPriceUpRate !== undefined ? this.defaultPriceUpRate : <any>null;
        data["rewiewsPageInnerHtml"] = this.rewiewsPageInnerHtml !== undefined ? this.rewiewsPageInnerHtml : <any>null;
        data["telegramLink"] = this.telegramLink !== undefined ? this.telegramLink : <any>null;
        data["instagramLink"] = this.instagramLink !== undefined ? this.instagramLink : <any>null;
        data["vkLink"] = this.vkLink !== undefined ? this.vkLink : <any>null;
        data["okLink"] = this.okLink !== undefined ? this.okLink : <any>null;
        data["facebookLink"] = this.facebookLink !== undefined ? this.facebookLink : <any>null;
        data["twitterLink"] = this.twitterLink !== undefined ? this.twitterLink : <any>null;
        data["youTubeLink"] = this.youTubeLink !== undefined ? this.youTubeLink : <any>null;
        data["deliveryPageInnerHtml"] = this.deliveryPageInnerHtml !== undefined ? this.deliveryPageInnerHtml : <any>null;
        data["contactPageInnerHtml"] = this.contactPageInnerHtml !== undefined ? this.contactPageInnerHtml : <any>null;
        data["privacyPolicyPageInnerHtml"] = this.privacyPolicyPageInnerHtml !== undefined ? this.privacyPolicyPageInnerHtml : <any>null;
        data["termsOfUsePageInnerHtml"] = this.termsOfUsePageInnerHtml !== undefined ? this.termsOfUsePageInnerHtml : <any>null;
        data["aboutPageInnerHtml"] = this.aboutPageInnerHtml !== undefined ? this.aboutPageInnerHtml : <any>null;
        data["returnPageInnerHtml"] = this.returnPageInnerHtml !== undefined ? this.returnPageInnerHtml : <any>null;
        data["requisitesPageInnerHtml"] = this.requisitesPageInnerHtml !== undefined ? this.requisitesPageInnerHtml : <any>null;
        data["guaranteePageInnerHtml"] = this.guaranteePageInnerHtml !== undefined ? this.guaranteePageInnerHtml : <any>null;
        data["publicOfferPageInnerHtml"] = this.publicOfferPageInnerHtml !== undefined ? this.publicOfferPageInnerHtml : <any>null;
        data["deliveryPageRawHtml"] = this.deliveryPageRawHtml !== undefined ? this.deliveryPageRawHtml : <any>null;
        data["contactPageRawHtml"] = this.contactPageRawHtml !== undefined ? this.contactPageRawHtml : <any>null;
        data["privacyPolicyPageRawHtml"] = this.privacyPolicyPageRawHtml !== undefined ? this.privacyPolicyPageRawHtml : <any>null;
        data["termsOfUsePageRawHtml"] = this.termsOfUsePageRawHtml !== undefined ? this.termsOfUsePageRawHtml : <any>null;
        data["aboutPageRawHtml"] = this.aboutPageRawHtml !== undefined ? this.aboutPageRawHtml : <any>null;
        data["returnPageRawHtml"] = this.returnPageRawHtml !== undefined ? this.returnPageRawHtml : <any>null;
        data["requisitesPageRawHtml"] = this.requisitesPageRawHtml !== undefined ? this.requisitesPageRawHtml : <any>null;
        data["guaranteePageRawHtml"] = this.guaranteePageRawHtml !== undefined ? this.guaranteePageRawHtml : <any>null;
        data["publicOfferPageRawHtml"] = this.publicOfferPageRawHtml !== undefined ? this.publicOfferPageRawHtml : <any>null;
        data["mainColor"] = this.mainColor !== undefined ? this.mainColor : <any>null;
        data["secondColor"] = this.secondColor !== undefined ? this.secondColor : <any>null;
        data["faviconIcon"] = this.faviconIcon !== undefined ? this.faviconIcon : <any>null;
        data["credentials"] = this.credentials !== undefined ? this.credentials : <any>null;
        data["categoryMetaTitlePattern"] = this.categoryMetaTitlePattern !== undefined ? this.categoryMetaTitlePattern : <any>null;
        data["categoryMetaDescriptionPattern"] = this.categoryMetaDescriptionPattern !== undefined ? this.categoryMetaDescriptionPattern : <any>null;
        data["goodMetaTitlePattern"] = this.goodMetaTitlePattern !== undefined ? this.goodMetaTitlePattern : <any>null;
        data["goodMetaDescriptionPattern"] = this.goodMetaDescriptionPattern !== undefined ? this.goodMetaDescriptionPattern : <any>null;
        data["cashDisabled"] = this.cashDisabled !== undefined ? this.cashDisabled : <any>null;
        data["bankCardDisabled"] = this.bankCardDisabled !== undefined ? this.bankCardDisabled : <any>null;
        data["onlineDisabled"] = this.onlineDisabled !== undefined ? this.onlineDisabled : <any>null;
        data["legalEntityDisabled"] = this.legalEntityDisabled !== undefined ? this.legalEntityDisabled : <any>null;
        data["dynamicScripts"] = this.dynamicScripts !== undefined ? this.dynamicScripts : <any>null;
        data["dynamicHeadScripts"] = this.dynamicHeadScripts !== undefined ? this.dynamicHeadScripts : <any>null;
        data["mainPageSeoBlock"] = this.mainPageSeoBlock !== undefined ? this.mainPageSeoBlock : <any>null;
        data["mainUrl"] = this.mainUrl !== undefined ? this.mainUrl : <any>null;
        data["roundType"] = this.roundType !== undefined ? this.roundType : <any>null;
        data["siteConnected"] = this.siteConnected !== undefined ? this.siteConnected : <any>null;
        data["marketPlaceConnected"] = this.marketPlaceConnected !== undefined ? this.marketPlaceConnected : <any>null;
        data["nikaConnected"] = this.nikaConnected !== undefined ? this.nikaConnected : <any>null;
        data["claims"] = this.claims !== undefined ? this.claims : <any>null;
        data["marketPlaceInclusions"] = this.marketPlaceInclusions !== undefined ? this.marketPlaceInclusions : <any>null;
        data["calltouchAccessToken"] = this.calltouchAccessToken !== undefined ? this.calltouchAccessToken : <any>null;
        data["calltouchSiteId"] = this.calltouchSiteId !== undefined ? this.calltouchSiteId : <any>null;
        data["defaultWarehouseId"] = this.defaultWarehouseId !== undefined ? this.defaultWarehouseId : <any>null;
        data["nikaPartnerInfoId"] = this.nikaPartnerInfoId !== undefined ? this.nikaPartnerInfoId : <any>null;
        data["ozonApiKey"] = this.ozonApiKey !== undefined ? this.ozonApiKey : <any>null;
        data["ozonClientId"] = this.ozonClientId !== undefined ? this.ozonClientId : <any>null;
        data["ozonWarehouseId"] = this.ozonWarehouseId !== undefined ? this.ozonWarehouseId : <any>null;
        data["ozonIntegrationEnabled"] = this.ozonIntegrationEnabled !== undefined ? this.ozonIntegrationEnabled : <any>null;
        data["externalConstructorLink"] = this.externalConstructorLink !== undefined ? this.externalConstructorLink : <any>null;
        return data; 
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    id?: string;
    created?: string;
    modified?: string | null;
    title?: string | null;
    code?: string | null;
    login?: string | null;
    password?: string | null;
    isActive?: boolean;
    sitePhoneNumber?: string | null;
    siteWorkSchedule?: string | null;
    siteLogo?: string | null;
    siteTitle?: string | null;
    paymentSystem?: PaymentSystem;
    inboundEmail?: string | null;
    defaultPriceUpRate?: number;
    rewiewsPageInnerHtml?: string | null;
    telegramLink?: string | null;
    instagramLink?: string | null;
    vkLink?: string | null;
    okLink?: string | null;
    facebookLink?: string | null;
    twitterLink?: string | null;
    youTubeLink?: string | null;
    deliveryPageInnerHtml?: string | null;
    contactPageInnerHtml?: string | null;
    privacyPolicyPageInnerHtml?: string | null;
    termsOfUsePageInnerHtml?: string | null;
    aboutPageInnerHtml?: string | null;
    returnPageInnerHtml?: string | null;
    requisitesPageInnerHtml?: string | null;
    guaranteePageInnerHtml?: string | null;
    publicOfferPageInnerHtml?: string | null;
    deliveryPageRawHtml?: string | null;
    contactPageRawHtml?: string | null;
    privacyPolicyPageRawHtml?: string | null;
    termsOfUsePageRawHtml?: string | null;
    aboutPageRawHtml?: string | null;
    returnPageRawHtml?: string | null;
    requisitesPageRawHtml?: string | null;
    guaranteePageRawHtml?: string | null;
    publicOfferPageRawHtml?: string | null;
    mainColor?: string | null;
    secondColor?: string | null;
    faviconIcon?: string | null;
    credentials?: string | null;
    categoryMetaTitlePattern?: string | null;
    categoryMetaDescriptionPattern?: string | null;
    goodMetaTitlePattern?: string | null;
    goodMetaDescriptionPattern?: string | null;
    cashDisabled?: boolean;
    bankCardDisabled?: boolean;
    onlineDisabled?: boolean;
    legalEntityDisabled?: boolean;
    dynamicScripts?: string | null;
    dynamicHeadScripts?: string | null;
    mainPageSeoBlock?: string | null;
    mainUrl?: string | null;
    roundType?: RoundType;
    siteConnected?: boolean;
    marketPlaceConnected?: boolean;
    nikaConnected?: boolean;
    claims?: string | null;
    marketPlaceInclusions?: string | null;
    calltouchAccessToken?: string | null;
    calltouchSiteId?: string | null;
    defaultWarehouseId?: string | null;
    nikaPartnerInfoId?: string | null;
    ozonApiKey?: string | null;
    ozonClientId?: string | null;
    ozonWarehouseId?: number | null;
    ozonIntegrationEnabled?: boolean;
    externalConstructorLink?: string | null;
}

export class User implements IUser {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    tenant?: Tenant;
    tenantId?: string | null;
    firstName?: string | null;
    created?: string;
    lastName?: string | null;
    hasAccess?: boolean;
    avatar?: string | null;
    fullName?: string | null;
    deliveryAddress?: string | null;
    siteCityName?: string | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.normalizedUserName = _data["normalizedUserName"] !== undefined ? _data["normalizedUserName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.normalizedEmail = _data["normalizedEmail"] !== undefined ? _data["normalizedEmail"] : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
            this.passwordHash = _data["passwordHash"] !== undefined ? _data["passwordHash"] : <any>null;
            this.securityStamp = _data["securityStamp"] !== undefined ? _data["securityStamp"] : <any>null;
            this.concurrencyStamp = _data["concurrencyStamp"] !== undefined ? _data["concurrencyStamp"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"] !== undefined ? _data["phoneNumberConfirmed"] : <any>null;
            this.twoFactorEnabled = _data["twoFactorEnabled"] !== undefined ? _data["twoFactorEnabled"] : <any>null;
            this.lockoutEnd = _data["lockoutEnd"] !== undefined ? _data["lockoutEnd"] : <any>null;
            this.lockoutEnabled = _data["lockoutEnabled"] !== undefined ? _data["lockoutEnabled"] : <any>null;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : <any>null;
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.hasAccess = _data["hasAccess"] !== undefined ? _data["hasAccess"] : <any>null;
            this.avatar = _data["avatar"] !== undefined ? _data["avatar"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.deliveryAddress = _data["deliveryAddress"] !== undefined ? _data["deliveryAddress"] : <any>null;
            this.siteCityName = _data["siteCityName"] !== undefined ? _data["siteCityName"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["normalizedUserName"] = this.normalizedUserName !== undefined ? this.normalizedUserName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["normalizedEmail"] = this.normalizedEmail !== undefined ? this.normalizedEmail : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        data["passwordHash"] = this.passwordHash !== undefined ? this.passwordHash : <any>null;
        data["securityStamp"] = this.securityStamp !== undefined ? this.securityStamp : <any>null;
        data["concurrencyStamp"] = this.concurrencyStamp !== undefined ? this.concurrencyStamp : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed !== undefined ? this.phoneNumberConfirmed : <any>null;
        data["twoFactorEnabled"] = this.twoFactorEnabled !== undefined ? this.twoFactorEnabled : <any>null;
        data["lockoutEnd"] = this.lockoutEnd !== undefined ? this.lockoutEnd : <any>null;
        data["lockoutEnabled"] = this.lockoutEnabled !== undefined ? this.lockoutEnabled : <any>null;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : <any>null;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["hasAccess"] = this.hasAccess !== undefined ? this.hasAccess : <any>null;
        data["avatar"] = this.avatar !== undefined ? this.avatar : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["deliveryAddress"] = this.deliveryAddress !== undefined ? this.deliveryAddress : <any>null;
        data["siteCityName"] = this.siteCityName !== undefined ? this.siteCityName : <any>null;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    tenant?: Tenant;
    tenantId?: string | null;
    firstName?: string | null;
    created?: string;
    lastName?: string | null;
    hasAccess?: boolean;
    avatar?: string | null;
    fullName?: string | null;
    deliveryAddress?: string | null;
    siteCityName?: string | null;
}

export class WarehouseDto implements IWarehouseDto {
    created?: string | null;
    id?: string | null;
    cityId?: string;
    title?: string | null;
    fullAddress?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    inboundEmail?: string | null;
    basePriceCityId?: string | null;
    mpCityId?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.inboundEmail = _data["inboundEmail"] !== undefined ? _data["inboundEmail"] : <any>null;
            this.basePriceCityId = _data["basePriceCityId"] !== undefined ? _data["basePriceCityId"] : <any>null;
            this.mpCityId = _data["mpCityId"] !== undefined ? _data["mpCityId"] : <any>null;
            this.workTime = _data["workTime"] !== undefined ? _data["workTime"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["inboundEmail"] = this.inboundEmail !== undefined ? this.inboundEmail : <any>null;
        data["basePriceCityId"] = this.basePriceCityId !== undefined ? this.basePriceCityId : <any>null;
        data["mpCityId"] = this.mpCityId !== undefined ? this.mpCityId : <any>null;
        data["workTime"] = this.workTime !== undefined ? this.workTime : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data; 
    }

    clone(): WarehouseDto {
        const json = this.toJSON();
        let result = new WarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDto {
    created?: string | null;
    id?: string | null;
    cityId?: string;
    title?: string | null;
    fullAddress?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    inboundEmail?: string | null;
    basePriceCityId?: string | null;
    mpCityId?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;
}

export class Warehouse implements IWarehouse {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    city?: City;
    cityId?: string;
    title?: string | null;
    fullAddress?: string | null;
    latitude?: number;
    longitude?: number;
    inboundEmail?: string | null;
    basePriceCityId?: string | null;
    mpCity?: MpCity;
    mpCityId?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.modified = _data["modified"] !== undefined ? _data["modified"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.city = _data["city"] ? City.fromJS(_data["city"]) : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.inboundEmail = _data["inboundEmail"] !== undefined ? _data["inboundEmail"] : <any>null;
            this.basePriceCityId = _data["basePriceCityId"] !== undefined ? _data["basePriceCityId"] : <any>null;
            this.mpCity = _data["mpCity"] ? MpCity.fromJS(_data["mpCity"]) : <any>null;
            this.mpCityId = _data["mpCityId"] !== undefined ? _data["mpCityId"] : <any>null;
            this.workTime = _data["workTime"] !== undefined ? _data["workTime"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): Warehouse {
        data = typeof data === 'object' ? data : {};
        let result = new Warehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["modified"] = this.modified !== undefined ? this.modified : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["inboundEmail"] = this.inboundEmail !== undefined ? this.inboundEmail : <any>null;
        data["basePriceCityId"] = this.basePriceCityId !== undefined ? this.basePriceCityId : <any>null;
        data["mpCity"] = this.mpCity ? this.mpCity.toJSON() : <any>null;
        data["mpCityId"] = this.mpCityId !== undefined ? this.mpCityId : <any>null;
        data["workTime"] = this.workTime !== undefined ? this.workTime : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data; 
    }

    clone(): Warehouse {
        const json = this.toJSON();
        let result = new Warehouse();
        result.init(json);
        return result;
    }
}

export interface IWarehouse {
    id?: string;
    created?: string;
    modified?: string | null;
    tenantId?: string | null;
    city?: City;
    cityId?: string;
    title?: string | null;
    fullAddress?: string | null;
    latitude?: number;
    longitude?: number;
    inboundEmail?: string | null;
    basePriceCityId?: string | null;
    mpCity?: MpCity;
    mpCityId?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        observer.next(JSON.stringify(blob));
        observer.complete();
    });
}